// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap v4.0.0 (https://getbootstrap.com)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
:root {
    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #6c757d;
    --gray-dark: #343a40;
    --primary: #007bff;
    --secondary: #6c757d;
    --success: #28a745;
    --info: #17a2b8;
    --warning: #ffc107;
    --danger: #dc3545;
    --light: #f8f9fa;
    --dark: #343a40;
    --breakpoint-xs: 0;
    --breakpoint-sm: 576px;
    --breakpoint-md: 768px;
    --breakpoint-lg: 992px;
    --breakpoint-xl: 1200px;
    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

html {
    font-family: sans-serif;
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: transparent;
}

@-ms-viewport {
    width: device-width;
}

article, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {
    display: block;
}

body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: left;
    background-color: #fff;
}

[tabindex="-1"]:focus {
    outline: 0 !important;
}

hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}

p {
    margin-top: 0;
    margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    border-bottom: 0;
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
}

ol,
ul,
dl {
    margin-top: 0;
    margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
    margin-bottom: 0;
}

dt {
    font-weight: 700;
}

dd {
    margin-bottom: .5rem;
    margin-left: 0;
}

blockquote {
    margin: 0 0 1rem;
}

dfn {
    font-style: italic;
}

b,
strong {
    font-weight: bolder;
}

small {
    font-size: 80%;
}

sub,
sup {
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
}

sub {
    bottom: -.25em;
}

sup {
    top: -.5em;
}

a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}

a:hover {
    color: #0056b3;
    text-decoration: underline;
}

a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
}

a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
    color: inherit;
    text-decoration: none;
}

a:not([href]):not([tabindex]):focus {
    outline: 0;
}

pre,
code,
kbd,
samp {
    font-family: monospace, monospace;
    font-size: 1em;
}

pre {
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    -ms-overflow-style: scrollbar;
}

figure {
    margin: 0 0 1rem;
}

img {
    vertical-align: middle;
    border-style: none;
}

svg:not(:root) {
    overflow: hidden;
}

table {
    border-collapse: collapse;
}

caption {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    color: #6c757d;
    text-align: left;
    caption-side: bottom;
}

th {
    text-align: inherit;
}

label {
    display: inline-block;
    margin-bottom: .5rem;
}

button {
    border-radius: 0;
}

button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
}

button,
input {
    overflow: visible;
}

button,
select {
    text-transform: none;
}

button,
html [type="button"],
[type="reset"],
[type="submit"] {
    -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
    padding: 0;
    border-style: none;
}

input[type="radio"],
input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
}

input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
    -webkit-appearance: listbox;
}

textarea {
    overflow: auto;
    resize: vertical;
}

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0;
}

legend {
    display: block;
    width: 100%;
    max-width: 100%;
    padding: 0;
    margin-bottom: .5rem;
    font-size: 1.5rem;
    line-height: inherit;
    color: inherit;
    white-space: normal;
}

progress {
    vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
    height: auto;
}

[type="search"] {
    outline-offset: -2px;
    -webkit-appearance: none;
}

[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
}

::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button;
}

output {
    display: inline-block;
}

summary {
    display: list-item;
    cursor: pointer;
}

template {
    display: none;
}

[hidden] {
    display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
}

h1, .h1 {
    font-size: 2.5rem;
}

h2, .h2 {
    font-size: 2rem;
}

h3, .h3 {
    font-size: 1.75rem;
}

h4, .h4 {
    font-size: 1.5rem;
}

h5, .h5 {
    font-size: 1.25rem;
}

h6, .h6 {
    font-size: 1rem;
}

.lead {
    font-size: 1.25rem;
    font-weight: 300;
}

.display-1 {
    font-size: 6rem;
    font-weight: 300;
    line-height: 1.2;
}

.display-2 {
    font-size: 5.5rem;
    font-weight: 300;
    line-height: 1.2;
}

.display-3 {
    font-size: 4.5rem;
    font-weight: 300;
    line-height: 1.2;
}

.display-4 {
    font-size: 3.5rem;
    font-weight: 300;
    line-height: 1.2;
}

hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
    font-size: 80%;
    font-weight: 400;
}

mark,
.mark {
    padding: 0.2em;
    background-color: #fcf8e3;
}

.list-unstyled {
    padding-left: 0;
    list-style: none;
}

.list-inline {
    padding-left: 0;
    list-style: none;
}

.list-inline-item {
    display: inline-block;
}

.list-inline-item:not(:last-child) {
    margin-right: 0.5rem;
}

.initialism {
    font-size: 90%;
    text-transform: uppercase;
}

.blockquote {
    margin-bottom: 1rem;
    font-size: 1.25rem;
}

.blockquote-footer {
    display: block;
    font-size: 80%;
    color: #6c757d;
}

.blockquote-footer::before {
    content: "\\2014 \\00A0";
}

.img-fluid {
    max-width: 100%;
    height: auto;
}

.img-thumbnail {
    padding: 0.25rem;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    max-width: 100%;
    height: auto;
}

.figure {
    display: inline-block;
}

.figure-img {
    margin-bottom: 0.5rem;
    line-height: 1;
}

.figure-caption {
    font-size: 90%;
    color: #6c757d;
}

code,
kbd,
pre,
samp {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

code {
    font-size: 87.5%;
    color: #e83e8c;
    word-break: break-word;
}

a > code {
    color: inherit;
}

kbd {
    padding: 0.2rem 0.4rem;
    font-size: 87.5%;
    color: #fff;
    background-color: #212529;
    border-radius: 0.2rem;
}

kbd kbd {
    padding: 0;
    font-size: 100%;
    font-weight: 700;
}

pre {
    display: block;
    font-size: 87.5%;
    color: #212529;
}

pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal;
}

.pre-scrollable {
    max-height: 340px;
    overflow-y: scroll;
}

.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

@media (min-width: 576px) {
    .container {
        max-width: 540px;
    }
}

@media (min-width: 768px) {
    .container {
        max-width: 720px;
    }
}

@media (min-width: 992px) {
    .container {
        max-width: 960px;
    }
}

@media (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }
}

.container-fluid {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

.no-gutters {
    margin-right: 0;
    margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
}

.col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
}

.col-auto {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: none;
}

.col-1 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
}

.col-2 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
}

.col-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
}

.col-4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
}

.col-5 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
}

.col-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
}

.col-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
}

.col-8 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
}

.col-9 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
}

.col-10 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
}

.col-11 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
}

.col-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}

.order-first {
    -webkit-box-ordinal-group: 0;
    -ms-flex-order: -1;
    order: -1;
}

.order-last {
    -webkit-box-ordinal-group: 14;
    -ms-flex-order: 13;
    order: 13;
}

.order-0 {
    -webkit-box-ordinal-group: 1;
    -ms-flex-order: 0;
    order: 0;
}

.order-1 {
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    order: 1;
}

.order-2 {
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    order: 2;
}

.order-3 {
    -webkit-box-ordinal-group: 4;
    -ms-flex-order: 3;
    order: 3;
}

.order-4 {
    -webkit-box-ordinal-group: 5;
    -ms-flex-order: 4;
    order: 4;
}

.order-5 {
    -webkit-box-ordinal-group: 6;
    -ms-flex-order: 5;
    order: 5;
}

.order-6 {
    -webkit-box-ordinal-group: 7;
    -ms-flex-order: 6;
    order: 6;
}

.order-7 {
    -webkit-box-ordinal-group: 8;
    -ms-flex-order: 7;
    order: 7;
}

.order-8 {
    -webkit-box-ordinal-group: 9;
    -ms-flex-order: 8;
    order: 8;
}

.order-9 {
    -webkit-box-ordinal-group: 10;
    -ms-flex-order: 9;
    order: 9;
}

.order-10 {
    -webkit-box-ordinal-group: 11;
    -ms-flex-order: 10;
    order: 10;
}

.order-11 {
    -webkit-box-ordinal-group: 12;
    -ms-flex-order: 11;
    order: 11;
}

.order-12 {
    -webkit-box-ordinal-group: 13;
    -ms-flex-order: 12;
    order: 12;
}

.offset-1 {
    margin-left: 8.333333%;
}

.offset-2 {
    margin-left: 16.666667%;
}

.offset-3 {
    margin-left: 25%;
}

.offset-4 {
    margin-left: 33.333333%;
}

.offset-5 {
    margin-left: 41.666667%;
}

.offset-6 {
    margin-left: 50%;
}

.offset-7 {
    margin-left: 58.333333%;
}

.offset-8 {
    margin-left: 66.666667%;
}

.offset-9 {
    margin-left: 75%;
}

.offset-10 {
    margin-left: 83.333333%;
}

.offset-11 {
    margin-left: 91.666667%;
}

@media (min-width: 576px) {
    .col-sm {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-sm-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: none;
    }

    .col-sm-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.333333%;
        flex: 0 0 8.333333%;
        max-width: 8.333333%;
    }

    .col-sm-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.666667%;
        flex: 0 0 16.666667%;
        max-width: 16.666667%;
    }

    .col-sm-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-sm-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .col-sm-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .col-sm-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-sm-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.333333%;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    .col-sm-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    .col-sm-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-sm-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.333333%;
        flex: 0 0 83.333333%;
        max-width: 83.333333%;
    }

    .col-sm-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.666667%;
        flex: 0 0 91.666667%;
        max-width: 91.666667%;
    }

    .col-sm-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

    .order-sm-first {
        -webkit-box-ordinal-group: 0;
        -ms-flex-order: -1;
        order: -1;
    }

    .order-sm-last {
        -webkit-box-ordinal-group: 14;
        -ms-flex-order: 13;
        order: 13;
    }

    .order-sm-0 {
        -webkit-box-ordinal-group: 1;
        -ms-flex-order: 0;
        order: 0;
    }

    .order-sm-1 {
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
    }

    .order-sm-2 {
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
    }

    .order-sm-3 {
        -webkit-box-ordinal-group: 4;
        -ms-flex-order: 3;
        order: 3;
    }

    .order-sm-4 {
        -webkit-box-ordinal-group: 5;
        -ms-flex-order: 4;
        order: 4;
    }

    .order-sm-5 {
        -webkit-box-ordinal-group: 6;
        -ms-flex-order: 5;
        order: 5;
    }

    .order-sm-6 {
        -webkit-box-ordinal-group: 7;
        -ms-flex-order: 6;
        order: 6;
    }

    .order-sm-7 {
        -webkit-box-ordinal-group: 8;
        -ms-flex-order: 7;
        order: 7;
    }

    .order-sm-8 {
        -webkit-box-ordinal-group: 9;
        -ms-flex-order: 8;
        order: 8;
    }

    .order-sm-9 {
        -webkit-box-ordinal-group: 10;
        -ms-flex-order: 9;
        order: 9;
    }

    .order-sm-10 {
        -webkit-box-ordinal-group: 11;
        -ms-flex-order: 10;
        order: 10;
    }

    .order-sm-11 {
        -webkit-box-ordinal-group: 12;
        -ms-flex-order: 11;
        order: 11;
    }

    .order-sm-12 {
        -webkit-box-ordinal-group: 13;
        -ms-flex-order: 12;
        order: 12;
    }

    .offset-sm-0 {
        margin-left: 0;
    }

    .offset-sm-1 {
        margin-left: 8.333333%;
    }

    .offset-sm-2 {
        margin-left: 16.666667%;
    }

    .offset-sm-3 {
        margin-left: 25%;
    }

    .offset-sm-4 {
        margin-left: 33.333333%;
    }

    .offset-sm-5 {
        margin-left: 41.666667%;
    }

    .offset-sm-6 {
        margin-left: 50%;
    }

    .offset-sm-7 {
        margin-left: 58.333333%;
    }

    .offset-sm-8 {
        margin-left: 66.666667%;
    }

    .offset-sm-9 {
        margin-left: 75%;
    }

    .offset-sm-10 {
        margin-left: 83.333333%;
    }

    .offset-sm-11 {
        margin-left: 91.666667%;
    }
}

@media (min-width: 768px) {
    .col-md {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-md-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: none;
    }

    .col-md-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.333333%;
        flex: 0 0 8.333333%;
        max-width: 8.333333%;
    }

    .col-md-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.666667%;
        flex: 0 0 16.666667%;
        max-width: 16.666667%;
    }

    .col-md-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-md-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .col-md-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .col-md-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-md-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.333333%;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    .col-md-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    .col-md-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-md-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.333333%;
        flex: 0 0 83.333333%;
        max-width: 83.333333%;
    }

    .col-md-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.666667%;
        flex: 0 0 91.666667%;
        max-width: 91.666667%;
    }

    .col-md-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

    .order-md-first {
        -webkit-box-ordinal-group: 0;
        -ms-flex-order: -1;
        order: -1;
    }

    .order-md-last {
        -webkit-box-ordinal-group: 14;
        -ms-flex-order: 13;
        order: 13;
    }

    .order-md-0 {
        -webkit-box-ordinal-group: 1;
        -ms-flex-order: 0;
        order: 0;
    }

    .order-md-1 {
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
    }

    .order-md-2 {
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
    }

    .order-md-3 {
        -webkit-box-ordinal-group: 4;
        -ms-flex-order: 3;
        order: 3;
    }

    .order-md-4 {
        -webkit-box-ordinal-group: 5;
        -ms-flex-order: 4;
        order: 4;
    }

    .order-md-5 {
        -webkit-box-ordinal-group: 6;
        -ms-flex-order: 5;
        order: 5;
    }

    .order-md-6 {
        -webkit-box-ordinal-group: 7;
        -ms-flex-order: 6;
        order: 6;
    }

    .order-md-7 {
        -webkit-box-ordinal-group: 8;
        -ms-flex-order: 7;
        order: 7;
    }

    .order-md-8 {
        -webkit-box-ordinal-group: 9;
        -ms-flex-order: 8;
        order: 8;
    }

    .order-md-9 {
        -webkit-box-ordinal-group: 10;
        -ms-flex-order: 9;
        order: 9;
    }

    .order-md-10 {
        -webkit-box-ordinal-group: 11;
        -ms-flex-order: 10;
        order: 10;
    }

    .order-md-11 {
        -webkit-box-ordinal-group: 12;
        -ms-flex-order: 11;
        order: 11;
    }

    .order-md-12 {
        -webkit-box-ordinal-group: 13;
        -ms-flex-order: 12;
        order: 12;
    }

    .offset-md-0 {
        margin-left: 0;
    }

    .offset-md-1 {
        margin-left: 8.333333%;
    }

    .offset-md-2 {
        margin-left: 16.666667%;
    }

    .offset-md-3 {
        margin-left: 25%;
    }

    .offset-md-4 {
        margin-left: 33.333333%;
    }

    .offset-md-5 {
        margin-left: 41.666667%;
    }

    .offset-md-6 {
        margin-left: 50%;
    }

    .offset-md-7 {
        margin-left: 58.333333%;
    }

    .offset-md-8 {
        margin-left: 66.666667%;
    }

    .offset-md-9 {
        margin-left: 75%;
    }

    .offset-md-10 {
        margin-left: 83.333333%;
    }

    .offset-md-11 {
        margin-left: 91.666667%;
    }
}

@media (min-width: 992px) {
    .col-lg {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-lg-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: none;
    }

    .col-lg-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.333333%;
        flex: 0 0 8.333333%;
        max-width: 8.333333%;
    }

    .col-lg-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.666667%;
        flex: 0 0 16.666667%;
        max-width: 16.666667%;
    }

    .col-lg-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-lg-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .col-lg-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .col-lg-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-lg-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.333333%;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    .col-lg-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    .col-lg-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-lg-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.333333%;
        flex: 0 0 83.333333%;
        max-width: 83.333333%;
    }

    .col-lg-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.666667%;
        flex: 0 0 91.666667%;
        max-width: 91.666667%;
    }

    .col-lg-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

    .order-lg-first {
        -webkit-box-ordinal-group: 0;
        -ms-flex-order: -1;
        order: -1;
    }

    .order-lg-last {
        -webkit-box-ordinal-group: 14;
        -ms-flex-order: 13;
        order: 13;
    }

    .order-lg-0 {
        -webkit-box-ordinal-group: 1;
        -ms-flex-order: 0;
        order: 0;
    }

    .order-lg-1 {
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
    }

    .order-lg-2 {
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
    }

    .order-lg-3 {
        -webkit-box-ordinal-group: 4;
        -ms-flex-order: 3;
        order: 3;
    }

    .order-lg-4 {
        -webkit-box-ordinal-group: 5;
        -ms-flex-order: 4;
        order: 4;
    }

    .order-lg-5 {
        -webkit-box-ordinal-group: 6;
        -ms-flex-order: 5;
        order: 5;
    }

    .order-lg-6 {
        -webkit-box-ordinal-group: 7;
        -ms-flex-order: 6;
        order: 6;
    }

    .order-lg-7 {
        -webkit-box-ordinal-group: 8;
        -ms-flex-order: 7;
        order: 7;
    }

    .order-lg-8 {
        -webkit-box-ordinal-group: 9;
        -ms-flex-order: 8;
        order: 8;
    }

    .order-lg-9 {
        -webkit-box-ordinal-group: 10;
        -ms-flex-order: 9;
        order: 9;
    }

    .order-lg-10 {
        -webkit-box-ordinal-group: 11;
        -ms-flex-order: 10;
        order: 10;
    }

    .order-lg-11 {
        -webkit-box-ordinal-group: 12;
        -ms-flex-order: 11;
        order: 11;
    }

    .order-lg-12 {
        -webkit-box-ordinal-group: 13;
        -ms-flex-order: 12;
        order: 12;
    }

    .offset-lg-0 {
        margin-left: 0;
    }

    .offset-lg-1 {
        margin-left: 8.333333%;
    }

    .offset-lg-2 {
        margin-left: 16.666667%;
    }

    .offset-lg-3 {
        margin-left: 25%;
    }

    .offset-lg-4 {
        margin-left: 33.333333%;
    }

    .offset-lg-5 {
        margin-left: 41.666667%;
    }

    .offset-lg-6 {
        margin-left: 50%;
    }

    .offset-lg-7 {
        margin-left: 58.333333%;
    }

    .offset-lg-8 {
        margin-left: 66.666667%;
    }

    .offset-lg-9 {
        margin-left: 75%;
    }

    .offset-lg-10 {
        margin-left: 83.333333%;
    }

    .offset-lg-11 {
        margin-left: 91.666667%;
    }
}

@media (min-width: 1200px) {
    .col-xl {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }

    .col-xl-auto {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: auto;
        max-width: none;
    }

    .col-xl-1 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 8.333333%;
        flex: 0 0 8.333333%;
        max-width: 8.333333%;
    }

    .col-xl-2 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 16.666667%;
        flex: 0 0 16.666667%;
        max-width: 16.666667%;
    }

    .col-xl-3 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
    }

    .col-xl-4 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }

    .col-xl-5 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 41.666667%;
        flex: 0 0 41.666667%;
        max-width: 41.666667%;
    }

    .col-xl-6 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 50%;
    }

    .col-xl-7 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 58.333333%;
        flex: 0 0 58.333333%;
        max-width: 58.333333%;
    }

    .col-xl-8 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
    }

    .col-xl-9 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
    }

    .col-xl-10 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 83.333333%;
        flex: 0 0 83.333333%;
        max-width: 83.333333%;
    }

    .col-xl-11 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 91.666667%;
        flex: 0 0 91.666667%;
        max-width: 91.666667%;
    }

    .col-xl-12 {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }

    .order-xl-first {
        -webkit-box-ordinal-group: 0;
        -ms-flex-order: -1;
        order: -1;
    }

    .order-xl-last {
        -webkit-box-ordinal-group: 14;
        -ms-flex-order: 13;
        order: 13;
    }

    .order-xl-0 {
        -webkit-box-ordinal-group: 1;
        -ms-flex-order: 0;
        order: 0;
    }

    .order-xl-1 {
        -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
        order: 1;
    }

    .order-xl-2 {
        -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
        order: 2;
    }

    .order-xl-3 {
        -webkit-box-ordinal-group: 4;
        -ms-flex-order: 3;
        order: 3;
    }

    .order-xl-4 {
        -webkit-box-ordinal-group: 5;
        -ms-flex-order: 4;
        order: 4;
    }

    .order-xl-5 {
        -webkit-box-ordinal-group: 6;
        -ms-flex-order: 5;
        order: 5;
    }

    .order-xl-6 {
        -webkit-box-ordinal-group: 7;
        -ms-flex-order: 6;
        order: 6;
    }

    .order-xl-7 {
        -webkit-box-ordinal-group: 8;
        -ms-flex-order: 7;
        order: 7;
    }

    .order-xl-8 {
        -webkit-box-ordinal-group: 9;
        -ms-flex-order: 8;
        order: 8;
    }

    .order-xl-9 {
        -webkit-box-ordinal-group: 10;
        -ms-flex-order: 9;
        order: 9;
    }

    .order-xl-10 {
        -webkit-box-ordinal-group: 11;
        -ms-flex-order: 10;
        order: 10;
    }

    .order-xl-11 {
        -webkit-box-ordinal-group: 12;
        -ms-flex-order: 11;
        order: 11;
    }

    .order-xl-12 {
        -webkit-box-ordinal-group: 13;
        -ms-flex-order: 12;
        order: 12;
    }

    .offset-xl-0 {
        margin-left: 0;
    }

    .offset-xl-1 {
        margin-left: 8.333333%;
    }

    .offset-xl-2 {
        margin-left: 16.666667%;
    }

    .offset-xl-3 {
        margin-left: 25%;
    }

    .offset-xl-4 {
        margin-left: 33.333333%;
    }

    .offset-xl-5 {
        margin-left: 41.666667%;
    }

    .offset-xl-6 {
        margin-left: 50%;
    }

    .offset-xl-7 {
        margin-left: 58.333333%;
    }

    .offset-xl-8 {
        margin-left: 66.666667%;
    }

    .offset-xl-9 {
        margin-left: 75%;
    }

    .offset-xl-10 {
        margin-left: 83.333333%;
    }

    .offset-xl-11 {
        margin-left: 91.666667%;
    }
}

.table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;
}

.table th,
.table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}

.table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
}

.table tbody + tbody {
    border-top: 2px solid #dee2e6;
}

.table .table {
    background-color: #fff;
}

.table-sm th,
.table-sm td {
    padding: 0.3rem;
}

.table-bordered {
    border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
    border: 1px solid #dee2e6;
}

.table-bordered thead th,
.table-bordered thead td {
    border-bottom-width: 2px;
}

.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
    background-color: #b8daff;
}

.table-hover .table-primary:hover {
    background-color: #9fcdff;
}

.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
    background-color: #9fcdff;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
    background-color: #d6d8db;
}

.table-hover .table-secondary:hover {
    background-color: #c8cbcf;
}

.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
    background-color: #c8cbcf;
}

.table-success,
.table-success > th,
.table-success > td {
    background-color: #c3e6cb;
}

.table-hover .table-success:hover {
    background-color: #b1dfbb;
}

.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
    background-color: #b1dfbb;
}

.table-info,
.table-info > th,
.table-info > td {
    background-color: #bee5eb;
}

.table-hover .table-info:hover {
    background-color: #abdde5;
}

.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
    background-color: #abdde5;
}

.table-warning,
.table-warning > th,
.table-warning > td {
    background-color: #ffeeba;
}

.table-hover .table-warning:hover {
    background-color: #ffe8a1;
}

.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
    background-color: #ffe8a1;
}

.table-danger,
.table-danger > th,
.table-danger > td {
    background-color: #f5c6cb;
}

.table-hover .table-danger:hover {
    background-color: #f1b0b7;
}

.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
    background-color: #f1b0b7;
}

.table-light,
.table-light > th,
.table-light > td {
    background-color: #fdfdfe;
}

.table-hover .table-light:hover {
    background-color: #ececf6;
}

.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
    background-color: #ececf6;
}

.table-dark,
.table-dark > th,
.table-dark > td {
    background-color: #c6c8ca;
}

.table-hover .table-dark:hover {
    background-color: #b9bbbe;
}

.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
    background-color: #b9bbbe;
}

.table-active,
.table-active > th,
.table-active > td {
    background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
    background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
    background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
    color: #fff;
    background-color: #212529;
    border-color: #32383e;
}

.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
}

.table-dark {
    color: #fff;
    background-color: #212529;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
    border-color: #32383e;
}

.table-dark.table-bordered {
    border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
    background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
    .table-responsive-sm {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .table-responsive-sm > .table-bordered {
        border: 0;
    }
}

@media (max-width: 767.98px) {
    .table-responsive-md {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .table-responsive-md > .table-bordered {
        border: 0;
    }
}

@media (max-width: 991.98px) {
    .table-responsive-lg {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .table-responsive-lg > .table-bordered {
        border: 0;
    }
}

@media (max-width: 1199.98px) {
    .table-responsive-xl {
        display: block;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .table-responsive-xl > .table-bordered {
        border: 0;
    }
}

.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
}

.table-responsive > .table-bordered {
    border: 0;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control::-ms-expand {
    background-color: transparent;
    border: 0;
}

.form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control::-webkit-input-placeholder {
    color: #6c757d;
    opacity: 1;
}

.form-control::-moz-placeholder {
    color: #6c757d;
    opacity: 1;
}

.form-control:-ms-input-placeholder {
    color: #6c757d;
    opacity: 1;
}

.form-control::-ms-input-placeholder {
    color: #6c757d;
    opacity: 1;
}

.form-control::placeholder {
    color: #6c757d;
    opacity: 1;
}

.form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef;
    opacity: 1;
}

select.form-control:not([size]):not([multiple]) {
    height: calc(2.25rem + 2px);
}

select.form-control:focus::-ms-value {
    color: #495057;
    background-color: #fff;
}

.form-control-file,
.form-control-range {
    display: block;
    width: 100%;
}

.col-form-label {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
}

.col-form-label-lg {
    padding-top: calc(0.5rem + 1px);
    padding-bottom: calc(0.5rem + 1px);
    font-size: 1.25rem;
    line-height: 1.5;
}

.col-form-label-sm {
    padding-top: calc(0.25rem + 1px);
    padding-bottom: calc(0.25rem + 1px);
    font-size: 0.875rem;
    line-height: 1.5;
}

.form-control-plaintext {
    display: block;
    width: 100%;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    margin-bottom: 0;
    line-height: 1.5;
    background-color: transparent;
    border: solid transparent;
    border-width: 1px 0;
}

.form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,
.input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,
.input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,
.input-group-sm > .input-group-prepend > .form-control-plaintext.btn,
.input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,
.input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,
.input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,
.input-group-lg > .input-group-prepend > .form-control-plaintext.btn,
.input-group-lg > .input-group-append > .form-control-plaintext.btn {
    padding-right: 0;
    padding-left: 0;
}

.form-control-sm, .input-group-sm > .form-control,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

select.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {
    height: calc(1.8125rem + 2px);
}

.form-control-lg, .input-group-lg > .form-control,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
}

select.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),
.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),
.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {
    height: calc(2.875rem + 2px);
}

.form-group {
    margin-bottom: 1rem;
}

.form-text {
    display: block;
    margin-top: 0.25rem;
}

.form-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
}

.form-row > .col,
.form-row > [class*="col-"] {
    padding-right: 5px;
    padding-left: 5px;
}

.form-check {
    position: relative;
    display: block;
    padding-left: 1.25rem;
}

.form-check-input {
    position: absolute;
    margin-top: 0.3rem;
    margin-left: -1.25rem;
}

.form-check-input:disabled ~ .form-check-label {
    color: #6c757d;
}

.form-check-label {
    margin-bottom: 0;
}

.form-check-inline {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: 0;
    margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
    position: static;
    margin-top: 0;
    margin-right: 0.3125rem;
    margin-left: 0;
}

.valid-feedback {
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #28a745;
}

.valid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .5rem;
    margin-top: .1rem;
    font-size: .875rem;
    line-height: 1;
    color: #fff;
    background-color: rgba(40, 167, 69, 0.8);
    border-radius: .2rem;
}

.was-validated .form-control:valid, .form-control.is-valid, .was-validated
.custom-select:valid,
.custom-select.is-valid {
    border-color: #28a745;
}

.was-validated .form-control:valid:focus, .form-control.is-valid:focus, .was-validated
.custom-select:valid:focus,
.custom-select.is-valid:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip, .was-validated
.custom-select:valid ~ .valid-feedback,
.was-validated
.custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
    display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: #28a745;
}

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
    display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
    color: #28a745;
}

.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
    background-color: #71dd8a;
}

.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
    display: block;
}

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
    background-color: #34ce57;
}

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
    border-color: #28a745;
}

.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
    border-color: inherit;
}

.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
    display: block;
}

.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}

.invalid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .5rem;
    margin-top: .1rem;
    font-size: .875rem;
    line-height: 1;
    color: #fff;
    background-color: rgba(220, 53, 69, 0.8);
    border-radius: .2rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid, .was-validated
.custom-select:invalid,
.custom-select.is-invalid {
    border-color: #dc3545;
}

.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus, .was-validated
.custom-select:invalid:focus,
.custom-select.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip, .was-validated
.custom-select:invalid ~ .invalid-feedback,
.was-validated
.custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
    display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: #dc3545;
}

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
    display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
    color: #dc3545;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
    background-color: #efa2a9;
}

.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
    display: block;
}

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
    background-color: #e4606d;
}

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
    border-color: #dc3545;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
    border-color: inherit;
}

.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
    display: block;
}

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.form-inline {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.form-inline .form-check {
    width: 100%;
}

@media (min-width: 576px) {
    .form-inline label {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-bottom: 0;
    }

    .form-inline .form-group {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin-bottom: 0;
    }

    .form-inline .form-control {
        display: inline-block;
        width: auto;
        vertical-align: middle;
    }

    .form-inline .form-control-plaintext {
        display: inline-block;
    }

    .form-inline .input-group {
        width: auto;
    }

    .form-inline .form-check {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: auto;
        padding-left: 0;
    }

    .form-inline .form-check-input {
        position: relative;
        margin-top: 0;
        margin-right: 0.25rem;
        margin-left: 0;
    }

    .form-inline .custom-control {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .form-inline .custom-control-label {
        margin-bottom: 0;
    }
}

.btn {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn:hover, .btn:focus {
    text-decoration: none;
}

.btn:focus, .btn.focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn.disabled, .btn:disabled {
    opacity: 0.65;
}

.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}

.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
    background-image: none;
}

a.btn.disabled,
fieldset:disabled a.btn {
    pointer-events: none;
}

.btn-primary {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-primary:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
}

.btn-primary:focus, .btn-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-primary.disabled, .btn-primary:disabled {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #0062cc;
    border-color: #005cbf;
}

.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-secondary {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.btn-secondary:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
}

.btn-secondary:focus, .btn-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-secondary.disabled, .btn-secondary:disabled {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #545b62;
    border-color: #4e555b;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-success:hover {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34;
}

.btn-success:focus, .btn-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-success.disabled, .btn-success:disabled {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
.show > .btn-success.dropdown-toggle {
    color: #fff;
    background-color: #1e7e34;
    border-color: #1c7430;
}

.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-success.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-info {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.btn-info:hover {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b;
}

.btn-info:focus, .btn-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-info.disabled, .btn-info:disabled {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #117a8b;
    border-color: #10707f;
}

.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-info.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-warning {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}

.btn-warning:hover {
    color: #212529;
    background-color: #e0a800;
    border-color: #d39e00;
}

.btn-warning:focus, .btn-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-warning.disabled, .btn-warning:disabled {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}

.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
.show > .btn-warning.dropdown-toggle {
    color: #212529;
    background-color: #d39e00;
    border-color: #c69500;
}

.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-warning.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-danger:hover {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
}

.btn-danger:focus, .btn-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-danger.disabled, .btn-danger:disabled {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
.show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #bd2130;
    border-color: #b21f2d;
}

.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-danger.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-light {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}

.btn-light:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
}

.btn-light:focus, .btn-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-light.disabled, .btn-light:disabled {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}

.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,
.show > .btn-light.dropdown-toggle {
    color: #212529;
    background-color: #dae0e5;
    border-color: #d3d9df;
}

.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,
.show > .btn-light.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-dark {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40;
}

.btn-dark:hover {
    color: #fff;
    background-color: #23272b;
    border-color: #1d2124;
}

.btn-dark:focus, .btn-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-dark.disabled, .btn-dark:disabled {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40;
}

.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,
.show > .btn-dark.dropdown-toggle {
    color: #fff;
    background-color: #1d2124;
    border-color: #171a1d;
}

.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-dark.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-outline-primary {
    color: #007bff;
    background-color: transparent;
    background-image: none;
    border-color: #007bff;
}

.btn-outline-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-outline-primary:focus, .btn-outline-primary.focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-outline-primary.disabled, .btn-outline-primary:disabled {
    color: #007bff;
    background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}

.btn-outline-secondary {
    color: #6c757d;
    background-color: transparent;
    background-image: none;
    border-color: #6c757d;
}

.btn-outline-secondary:hover {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.btn-outline-secondary:focus, .btn-outline-secondary.focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
    color: #6c757d;
    background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}

.btn-outline-success {
    color: #28a745;
    background-color: transparent;
    background-image: none;
    border-color: #28a745;
}

.btn-outline-success:hover {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-outline-success:focus, .btn-outline-success.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-success.disabled, .btn-outline-success:disabled {
    color: #28a745;
    background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
}

.btn-outline-info {
    color: #17a2b8;
    background-color: transparent;
    background-image: none;
    border-color: #17a2b8;
}

.btn-outline-info:hover {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.btn-outline-info:focus, .btn-outline-info.focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-info.disabled, .btn-outline-info:disabled {
    color: #17a2b8;
    background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
}

.btn-outline-warning {
    color: #ffc107;
    background-color: transparent;
    background-image: none;
    border-color: #ffc107;
}

.btn-outline-warning:hover {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}

.btn-outline-warning:focus, .btn-outline-warning.focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-warning.disabled, .btn-outline-warning:disabled {
    color: #ffc107;
    background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
    color: #212529;
    background-color: #ffc107;
    border-color: #ffc107;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

.btn-outline-danger {
    color: #dc3545;
    background-color: transparent;
    background-image: none;
    border-color: #dc3545;
}

.btn-outline-danger:hover {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-outline-danger:focus, .btn-outline-danger.focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-danger.disabled, .btn-outline-danger:disabled {
    color: #dc3545;
    background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);
}

.btn-outline-light {
    color: #f8f9fa;
    background-color: transparent;
    background-image: none;
    border-color: #f8f9fa;
}

.btn-outline-light:hover {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}

.btn-outline-light:focus, .btn-outline-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #f8f9fa;
    background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,
.show > .btn-outline-light.dropdown-toggle {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-light.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}

.btn-outline-dark {
    color: #343a40;
    background-color: transparent;
    background-image: none;
    border-color: #343a40;
}

.btn-outline-dark:hover {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40;
}

.btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-outline-dark.disabled, .btn-outline-dark:disabled {
    color: #343a40;
    background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,
.show > .btn-outline-dark.dropdown-toggle {
    color: #fff;
    background-color: #343a40;
    border-color: #343a40;
}

.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-dark.dropdown-toggle:focus {
    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-link {
    font-weight: 400;
    color: #007bff;
    background-color: transparent;
}

.btn-link:hover {
    color: #0056b3;
    text-decoration: underline;
    background-color: transparent;
    border-color: transparent;
}

.btn-link:focus, .btn-link.focus {
    text-decoration: underline;
    border-color: transparent;
    box-shadow: none;
}

.btn-link:disabled, .btn-link.disabled {
    color: #6c757d;
}

.btn-lg, .btn-group-lg > .btn {
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}

.btn-block {
    display: block;
    width: 100%;
}

.btn-block + .btn-block {
    margin-top: 0.5rem;
}

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
    width: 100%;
}

.fade {
    opacity: 0;
    transition: opacity 0.15s linear;
}

.fade.show {
    opacity: 1;
}

.collapse {
    display: none;
}

.collapse.show {
    display: block;
}

tr.collapse.show {
    display: table-row;
}

tbody.collapse.show {
    display: table-row-group;
}

.collapsing {
    position: relative;
    height: 0;
    overflow: hidden;
    transition: height 0.35s ease;
}

.dropup,
.dropdown {
    position: relative;
}

.dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
}

.dropup .dropdown-menu {
    margin-top: 0;
    margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0;
    border-right: 0.3em solid transparent;
    border-bottom: 0.3em solid;
    border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropright .dropdown-menu {
    margin-top: 0;
    margin-left: 0.125rem;
}

.dropright .dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid transparent;
    border-bottom: 0.3em solid transparent;
    border-left: 0.3em solid;
}

.dropright .dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropright .dropdown-toggle::after {
    vertical-align: 0;
}

.dropleft .dropdown-menu {
    margin-top: 0;
    margin-right: 0.125rem;
}

.dropleft .dropdown-toggle::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
}

.dropleft .dropdown-toggle::after {
    display: none;
}

.dropleft .dropdown-toggle::before {
    display: inline-block;
    width: 0;
    height: 0;
    margin-right: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid transparent;
    border-right: 0.3em solid;
    border-bottom: 0.3em solid transparent;
}

.dropleft .dropdown-toggle:empty::after {
    margin-left: 0;
}

.dropleft .dropdown-toggle::before {
    vertical-align: 0;
}

.dropdown-divider {
    height: 0;
    margin: 0.5rem 0;
    overflow: hidden;
    border-top: 1px solid #e9ecef;
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: 0.25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}

.dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: #f8f9fa;
}

.dropdown-item.active, .dropdown-item:active {
    color: #fff;
    text-decoration: none;
    background-color: #007bff;
}

.dropdown-item.disabled, .dropdown-item:disabled {
    color: #6c757d;
    background-color: transparent;
}

.dropdown-menu.show {
    display: block;
}

.dropdown-header {
    display: block;
    padding: 0.5rem 1.5rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    color: #6c757d;
    white-space: nowrap;
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
}

.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
    z-index: 1;
}

.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
    z-index: 1;
}

.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .btn + .btn,
.btn-group-vertical .btn + .btn-group,
.btn-group-vertical .btn-group + .btn,
.btn-group-vertical .btn-group + .btn-group {
    margin-left: -1px;
}

.btn-toolbar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
}

.btn-toolbar .input-group {
    width: auto;
}

.btn-group > .btn:first-child {
    margin-left: 0;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
    padding-right: 0.5625rem;
    padding-left: 0.5625rem;
}

.dropdown-toggle-split::after {
    margin-left: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
    padding-right: 0.375rem;
    padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
    padding-right: 0.75rem;
    padding-left: 0.75rem;
}

.btn-group-vertical {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.btn-group-vertical .btn,
.btn-group-vertical .btn-group {
    width: 100%;
}

.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
    margin-top: -1px;
    margin-left: 0;
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
    margin-bottom: 0;
}

.btn-group-toggle > .btn input[type="radio"],
.btn-group-toggle > .btn input[type="checkbox"],
.btn-group-toggle > .btn-group > .btn input[type="radio"],
.btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
}

.input-group {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    width: 100%;
}

.input-group > .form-control,
.input-group > .custom-select,
.input-group > .custom-file {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
}

.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file:focus {
    z-index: 3;
}

.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
    margin-left: -1px;
}

.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.input-group > .custom-file {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.input-group > .custom-file:not(:last-child) .custom-file-label,
.input-group > .custom-file:not(:last-child) .custom-file-label::before {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group > .custom-file:not(:first-child) .custom-file-label,
.input-group > .custom-file:not(:first-child) .custom-file-label::before {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.input-group-prepend .btn,
.input-group-append .btn {
    position: relative;
    z-index: 2;
}

.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
    margin-left: -1px;
}

.input-group-prepend {
    margin-right: -1px;
}

.input-group-append {
    margin-left: -1px;
}

.input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    text-align: center;
    white-space: nowrap;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

.input-group-text input[type="radio"],
.input-group-text input[type="checkbox"] {
    margin-top: 0;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.custom-control {
    position: relative;
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5rem;
}

.custom-control-inline {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin-right: 1rem;
}

.custom-control-input {
    position: absolute;
    z-index: -1;
    opacity: 0;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    background-color: #007bff;
}

.custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-control-input:active ~ .custom-control-label::before {
    color: #fff;
    background-color: #b3d7ff;
}

.custom-control-input:disabled ~ .custom-control-label {
    color: #6c757d;
}

.custom-control-input:disabled ~ .custom-control-label::before {
    background-color: #e9ecef;
}

.custom-control-label {
    margin-bottom: 0;
}

.custom-control-label::before {
    position: absolute;
    top: 0.25rem;
    left: 0;
    display: block;
    width: 1rem;
    height: 1rem;
    pointer-events: none;
    content: "";
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #dee2e6;
}

.custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: 0;
    display: block;
    width: 1rem;
    height: 1rem;
    content: "";
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% 50%;
}

.custom-checkbox .custom-control-label::before {
    border-radius: 0.25rem;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
    background-color: #007bff;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: rgba(0, 123, 255, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
    background-color: rgba(0, 123, 255, 0.5);
}

.custom-radio .custom-control-label::before {
    border-radius: 50%;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: rgba(0, 123, 255, 0.5);
}

.custom-select {
    display: inline-block;
    width: 100%;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    vertical-align: middle;
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right 0.75rem center;
    background-size: 8px 10px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

.custom-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(128, 189, 255, 0.5);
}

.custom-select:focus::-ms-value {
    color: #495057;
    background-color: #fff;
}

.custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
}

.custom-select:disabled {
    color: #6c757d;
    background-color: #e9ecef;
}

.custom-select::-ms-expand {
    opacity: 0;
}

.custom-select-sm {
    height: calc(1.8125rem + 2px);
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    font-size: 75%;
}

.custom-select-lg {
    height: calc(2.875rem + 2px);
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
    font-size: 125%;
}

.custom-file {
    position: relative;
    display: inline-block;
    width: 100%;
    height: calc(2.25rem + 2px);
    margin-bottom: 0;
}

.custom-file-input {
    position: relative;
    z-index: 2;
    width: 100%;
    height: calc(2.25rem + 2px);
    margin: 0;
    opacity: 0;
}

.custom-file-input:focus ~ .custom-file-control {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.custom-file-input:focus ~ .custom-file-control::before {
    border-color: #80bdff;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse";
}

.custom-file-label {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    height: calc(2.25rem + 2px);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

.custom-file-label::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    display: block;
    height: calc(calc(2.25rem + 2px) - 1px * 2);
    padding: 0.375rem 0.75rem;
    line-height: 1.5;
    color: #495057;
    content: "Browse";
    background-color: #e9ecef;
    border-left: 1px solid #ced4da;
    border-radius: 0 0.25rem 0.25rem 0;
}

.nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.nav-link {
    display: block;
    padding: 0.5rem 1rem;
}

.nav-link:hover, .nav-link:focus {
    text-decoration: none;
}

.nav-link.disabled {
    color: #6c757d;
}

.nav-tabs {
    border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-item {
    margin-bottom: -1px;
}

.nav-tabs .nav-link {
    border: 1px solid transparent;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
    border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.disabled {
    color: #6c757d;
    background-color: transparent;
    border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
    color: #495057;
    background-color: #fff;
    border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .dropdown-menu {
    margin-top: -1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

.nav-pills .nav-link {
    border-radius: 0.25rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: #fff;
    background-color: #007bff;
}

.nav-fill .nav-item {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    text-align: center;
}

.nav-justified .nav-item {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    text-align: center;
}

.tab-content > .tab-pane {
    display: none;
}

.tab-content > .active {
    display: block;
}

.navbar {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0.5rem 1rem;
}

.navbar > .container,
.navbar > .container-fluid {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.navbar-brand {
    display: inline-block;
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
    margin-right: 1rem;
    font-size: 1.25rem;
    line-height: inherit;
    white-space: nowrap;
}

.navbar-brand:hover, .navbar-brand:focus {
    text-decoration: none;
}

.navbar-nav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}

.navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0;
}

.navbar-nav .dropdown-menu {
    position: static;
    float: none;
}

.navbar-text {
    display: inline-block;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.navbar-collapse {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.navbar-toggler {
    padding: 0.25rem 0.75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

.navbar-toggler:hover, .navbar-toggler:focus {
    text-decoration: none;
}

.navbar-toggler:not(:disabled):not(.disabled) {
    cursor: pointer;
}

.navbar-toggler-icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    content: "";
    background: no-repeat center center;
    background-size: 100% 100%;
}

@media (max-width: 575.98px) {
    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid {
        padding-right: 0;
        padding-left: 0;
    }
}

@media (min-width: 576px) {
    .navbar-expand-sm {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .navbar-expand-sm .navbar-nav {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
    }

    .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-sm .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto;
    }

    .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
    }

    .navbar-expand-sm > .container,
    .navbar-expand-sm > .container-fluid {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
    }

    .navbar-expand-sm .navbar-collapse {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
    }

    .navbar-expand-sm .navbar-toggler {
        display: none;
    }

    .navbar-expand-sm .dropup .dropdown-menu {
        top: auto;
        bottom: 100%;
    }
}

@media (max-width: 767.98px) {
    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid {
        padding-right: 0;
        padding-left: 0;
    }
}

@media (min-width: 768px) {
    .navbar-expand-md {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .navbar-expand-md .navbar-nav {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
    }

    .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-md .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto;
    }

    .navbar-expand-md .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
    }

    .navbar-expand-md > .container,
    .navbar-expand-md > .container-fluid {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
    }

    .navbar-expand-md .navbar-collapse {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
    }

    .navbar-expand-md .navbar-toggler {
        display: none;
    }

    .navbar-expand-md .dropup .dropdown-menu {
        top: auto;
        bottom: 100%;
    }
}

@media (max-width: 991.98px) {
    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid {
        padding-right: 0;
        padding-left: 0;
    }
}

@media (min-width: 992px) {
    .navbar-expand-lg {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .navbar-expand-lg .navbar-nav {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto;
    }

    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
    }

    .navbar-expand-lg > .container,
    .navbar-expand-lg > .container-fluid {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
    }

    .navbar-expand-lg .navbar-collapse {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
    }

    .navbar-expand-lg .navbar-toggler {
        display: none;
    }

    .navbar-expand-lg .dropup .dropdown-menu {
        top: auto;
        bottom: 100%;
    }
}

@media (max-width: 1199.98px) {
    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid {
        padding-right: 0;
        padding-left: 0;
    }
}

@media (min-width: 1200px) {
    .navbar-expand-xl {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row nowrap;
        flex-flow: row nowrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
    }

    .navbar-expand-xl .navbar-nav {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
    }

    .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute;
    }

    .navbar-expand-xl .navbar-nav .dropdown-menu-right {
        right: 0;
        left: auto;
    }

    .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: 0.5rem;
        padding-left: 0.5rem;
    }

    .navbar-expand-xl > .container,
    .navbar-expand-xl > .container-fluid {
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
    }

    .navbar-expand-xl .navbar-collapse {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -ms-flex-preferred-size: auto;
        flex-basis: auto;
    }

    .navbar-expand-xl .navbar-toggler {
        display: none;
    }

    .navbar-expand-xl .dropup .dropdown-menu {
        top: auto;
        bottom: 100%;
    }
}

.navbar-expand {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid {
    padding-right: 0;
    padding-left: 0;
}

.navbar-expand .navbar-nav {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
    position: absolute;
}

.navbar-expand .navbar-nav .dropdown-menu-right {
    right: 0;
    left: auto;
}

.navbar-expand .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid {
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
}

.navbar-expand .navbar-toggler {
    display: none;
}

.navbar-expand .dropup .dropdown-menu {
    top: auto;
    bottom: 100%;
}

.navbar-light .navbar-brand {
    color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
    color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
    color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
    color: rgba(0, 0, 0, 0.5);
    border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.navbar-light .navbar-text {
    color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-text a {
    color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
    color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
    color: #fff;
}

.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
    color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
    color: #fff;
}

.navbar-dark .navbar-toggler {
    color: rgba(255, 255, 255, 0.5);
    border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.navbar-dark .navbar-text {
    color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-text a {
    color: #fff;
}

.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
    color: #fff;
}

.card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}

.card > hr {
    margin-right: 0;
    margin-left: 0;
}

.card > .list-group:first-child .list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

.card > .list-group:last-child .list-group-item:last-child {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
}

.card-title {
    margin-bottom: 0.75rem;
}

.card-subtitle {
    margin-top: -0.375rem;
    margin-bottom: 0;
}

.card-text:last-child {
    margin-bottom: 0;
}

.card-link:hover {
    text-decoration: none;
}

.card-link + .card-link {
    margin-left: 1.25rem;
}

.card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header:first-child {
    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header + .list-group .list-group-item:first-child {
    border-top: 0;
}

.card-footer {
    padding: 0.75rem 1.25rem;
    background-color: rgba(0, 0, 0, 0.03);
    border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.card-footer:last-child {
    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
    margin-right: -0.625rem;
    margin-bottom: -0.75rem;
    margin-left: -0.625rem;
    border-bottom: 0;
}

.card-header-pills {
    margin-right: -0.625rem;
    margin-left: -0.625rem;
}

.card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1.25rem;
}

.card-img {
    width: 100%;
    border-radius: calc(0.25rem - 1px);
}

.card-img-top {
    width: 100%;
    border-top-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: calc(0.25rem - 1px);
}

.card-img-bottom {
    width: 100%;
    border-bottom-right-radius: calc(0.25rem - 1px);
    border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.card-deck .card {
    margin-bottom: 15px;
}

@media (min-width: 576px) {
    .card-deck {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        margin-right: -15px;
        margin-left: -15px;
    }

    .card-deck .card {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex: 1 0 0%;
        flex: 1 0 0%;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        margin-right: 15px;
        margin-bottom: 0;
        margin-left: 15px;
    }
}

.card-group {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.card-group > .card {
    margin-bottom: 15px;
}

@media (min-width: 576px) {
    .card-group {
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
    }

    .card-group > .card {
        -webkit-box-flex: 1;
        -ms-flex: 1 0 0%;
        flex: 1 0 0%;
        margin-bottom: 0;
    }

    .card-group > .card + .card {
        margin-left: 0;
        border-left: 0;
    }

    .card-group > .card:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .card-group > .card:first-child .card-img-top,
    .card-group > .card:first-child .card-header {
        border-top-right-radius: 0;
    }

    .card-group > .card:first-child .card-img-bottom,
    .card-group > .card:first-child .card-footer {
        border-bottom-right-radius: 0;
    }

    .card-group > .card:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .card-group > .card:last-child .card-img-top,
    .card-group > .card:last-child .card-header {
        border-top-left-radius: 0;
    }

    .card-group > .card:last-child .card-img-bottom,
    .card-group > .card:last-child .card-footer {
        border-bottom-left-radius: 0;
    }

    .card-group > .card:only-child {
        border-radius: 0.25rem;
    }

    .card-group > .card:only-child .card-img-top,
    .card-group > .card:only-child .card-header {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }

    .card-group > .card:only-child .card-img-bottom,
    .card-group > .card:only-child .card-footer {
        border-bottom-right-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
    }

    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {
        border-radius: 0;
    }

    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,
    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,
    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {
        border-radius: 0;
    }
}

.card-columns .card {
    margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
    .card-columns {
        -webkit-column-count: 3;
        -moz-column-count: 3;
        column-count: 3;
        -webkit-column-gap: 1.25rem;
        -moz-column-gap: 1.25rem;
        column-gap: 1.25rem;
    }

    .card-columns .card {
        display: inline-block;
        width: 100%;
    }
}

.breadcrumb {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    list-style: none;
    background-color: #e9ecef;
    border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item::before {
    display: inline-block;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    color: #6c757d;
    content: "/";
}

.breadcrumb-item + .breadcrumb-item:hover::before {
    text-decoration: underline;
}

.breadcrumb-item + .breadcrumb-item:hover::before {
    text-decoration: none;
}

.breadcrumb-item.active {
    color: #6c757d;
}

.pagination {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}

.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
}

.page-link:hover {
    color: #0056b3;
    text-decoration: none;
    background-color: #e9ecef;
    border-color: #dee2e6;
}

.page-link:focus {
    z-index: 2;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.page-link:not(:disabled):not(.disabled) {
    cursor: pointer;
}

.page-item:first-child .page-link {
    margin-left: 0;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
}

.page-item.active .page-link {
    z-index: 1;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.page-item.disabled .page-link {
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dee2e6;
}

.pagination-lg .page-link {
    padding: 0.75rem 1.5rem;
    font-size: 1.25rem;
    line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
    border-top-left-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
    border-top-right-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
    border-top-left-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
    border-top-right-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
}

.badge {
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}

.badge:empty {
    display: none;
}

.btn .badge {
    position: relative;
    top: -1px;
}

.badge-pill {
    padding-right: 0.6em;
    padding-left: 0.6em;
    border-radius: 10rem;
}

.badge-primary {
    color: #fff;
    background-color: #007bff;
}

.badge-primary[href]:hover, .badge-primary[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #0062cc;
}

.badge-secondary {
    color: #fff;
    background-color: #6c757d;
}

.badge-secondary[href]:hover, .badge-secondary[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #545b62;
}

.badge-success {
    color: #fff;
    background-color: #28a745;
}

.badge-success[href]:hover, .badge-success[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #1e7e34;
}

.badge-info {
    color: #fff;
    background-color: #17a2b8;
}

.badge-info[href]:hover, .badge-info[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #117a8b;
}

.badge-warning {
    color: #212529;
    background-color: #ffc107;
}

.badge-warning[href]:hover, .badge-warning[href]:focus {
    color: #212529;
    text-decoration: none;
    background-color: #d39e00;
}

.badge-danger {
    color: #fff;
    background-color: #dc3545;
}

.badge-danger[href]:hover, .badge-danger[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #bd2130;
}

.badge-light {
    color: #212529;
    background-color: #f8f9fa;
}

.badge-light[href]:hover, .badge-light[href]:focus {
    color: #212529;
    text-decoration: none;
    background-color: #dae0e5;
}

.badge-dark {
    color: #fff;
    background-color: #343a40;
}

.badge-dark[href]:hover, .badge-dark[href]:focus {
    color: #fff;
    text-decoration: none;
    background-color: #1d2124;
}

.jumbotron {
    padding: 2rem 1rem;
    margin-bottom: 2rem;
    background-color: #e9ecef;
    border-radius: 0.3rem;
}

@media (min-width: 576px) {
    .jumbotron {
        padding: 4rem 2rem;
    }
}

.jumbotron-fluid {
    padding-right: 0;
    padding-left: 0;
    border-radius: 0;
}

.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

.alert-heading {
    color: inherit;
}

.alert-link {
    font-weight: 700;
}

.alert-dismissible {
    padding-right: 4rem;
}

.alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.75rem 1.25rem;
    color: inherit;
}

.alert-primary {
    color: #004085;
    background-color: #cce5ff;
    border-color: #b8daff;
}

.alert-primary hr {
    border-top-color: #9fcdff;
}

.alert-primary .alert-link {
    color: #002752;
}

.alert-secondary {
    color: #383d41;
    background-color: #e2e3e5;
    border-color: #d6d8db;
}

.alert-secondary hr {
    border-top-color: #c8cbcf;
}

.alert-secondary .alert-link {
    color: #202326;
}

.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}

.alert-success hr {
    border-top-color: #b1dfbb;
}

.alert-success .alert-link {
    color: #0b2e13;
}

.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}

.alert-info hr {
    border-top-color: #abdde5;
}

.alert-info .alert-link {
    color: #062c33;
}

.alert-warning {
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
}

.alert-warning hr {
    border-top-color: #ffe8a1;
}

.alert-warning .alert-link {
    color: #533f03;
}

.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}

.alert-danger hr {
    border-top-color: #f1b0b7;
}

.alert-danger .alert-link {
    color: #491217;
}

.alert-light {
    color: #818182;
    background-color: #fefefe;
    border-color: #fdfdfe;
}

.alert-light hr {
    border-top-color: #ececf6;
}

.alert-light .alert-link {
    color: #686868;
}

.alert-dark {
    color: #1b1e21;
    background-color: #d6d8d9;
    border-color: #c6c8ca;
}

.alert-dark hr {
    border-top-color: #b9bbbe;
}

.alert-dark .alert-link {
    color: #040505;
}

@-webkit-keyframes progress-bar-stripes {
    from {
        background-position: 1rem 0;
    }
    to {
        background-position: 0 0;
    }
}

@keyframes progress-bar-stripes {
    from {
        background-position: 1rem 0;
    }
    to {
        background-position: 0 0;
    }
}

.progress {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 1rem;
    overflow: hidden;
    font-size: 0.75rem;
    background-color: #e9ecef;
    border-radius: 0.25rem;
}

.progress-bar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    background-color: #007bff;
    transition: width 0.6s ease;
}

.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem;
}

.progress-bar-animated {
    -webkit-animation: progress-bar-stripes 1s linear infinite;
    animation: progress-bar-stripes 1s linear infinite;
}

.media {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
}

.media-body {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.list-group {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
}

.list-group-item-action {
    width: 100%;
    color: #495057;
    text-align: inherit;
}

.list-group-item-action:hover, .list-group-item-action:focus {
    color: #495057;
    text-decoration: none;
    background-color: #f8f9fa;
}

.list-group-item-action:active {
    color: #212529;
    background-color: #e9ecef;
}

.list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:first-child {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

.list-group-item:last-child {
    margin-bottom: 0;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}

.list-group-item:hover, .list-group-item:focus {
    z-index: 1;
    text-decoration: none;
}

.list-group-item.disabled, .list-group-item:disabled {
    color: #6c757d;
    background-color: #fff;
}

.list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}

.list-group-flush .list-group-item {
    border-right: 0;
    border-left: 0;
    border-radius: 0;
}

.list-group-flush:first-child .list-group-item:first-child {
    border-top: 0;
}

.list-group-flush:last-child .list-group-item:last-child {
    border-bottom: 0;
}

.list-group-item-primary {
    color: #004085;
    background-color: #b8daff;
}

.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #004085;
    background-color: #9fcdff;
}

.list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #004085;
    border-color: #004085;
}

.list-group-item-secondary {
    color: #383d41;
    background-color: #d6d8db;
}

.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #383d41;
    background-color: #c8cbcf;
}

.list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #383d41;
    border-color: #383d41;
}

.list-group-item-success {
    color: #155724;
    background-color: #c3e6cb;
}

.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #155724;
    background-color: #b1dfbb;
}

.list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #155724;
    border-color: #155724;
}

.list-group-item-info {
    color: #0c5460;
    background-color: #bee5eb;
}

.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #0c5460;
    background-color: #abdde5;
}

.list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #0c5460;
    border-color: #0c5460;
}

.list-group-item-warning {
    color: #856404;
    background-color: #ffeeba;
}

.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #856404;
    background-color: #ffe8a1;
}

.list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #856404;
    border-color: #856404;
}

.list-group-item-danger {
    color: #721c24;
    background-color: #f5c6cb;
}

.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #721c24;
    background-color: #f1b0b7;
}

.list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #721c24;
    border-color: #721c24;
}

.list-group-item-light {
    color: #818182;
    background-color: #fdfdfe;
}

.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #818182;
    background-color: #ececf6;
}

.list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #818182;
    border-color: #818182;
}

.list-group-item-dark {
    color: #1b1e21;
    background-color: #c6c8ca;
}

.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #1b1e21;
    background-color: #b9bbbe;
}

.list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #1b1e21;
    border-color: #1b1e21;
}

.close {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.close:hover, .close:focus {
    color: #000;
    text-decoration: none;
    opacity: .75;
}

.close:not(:disabled):not(.disabled) {
    cursor: pointer;
}

button.close {
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
}

.modal-open {
    overflow: hidden;
}

.modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
}

.modal-open .modal {
    overflow-x: hidden;
    overflow-y: auto;
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: 0.5rem;
    pointer-events: none;
}

.modal.fade .modal-dialog {
    transition: -webkit-transform 0.3s ease-out;
    transition: transform 0.3s ease-out;
    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
    -webkit-transform: translate(0, -25%);
    transform: translate(0, -25%);
}

.modal.show .modal-dialog {
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
}

.modal-dialog-centered {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-height: calc(100% - (0.5rem * 2));
}

.modal-content {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #000;
}

.modal-backdrop.fade {
    opacity: 0;
}

.modal-backdrop.show {
    opacity: 0.5;
}

.modal-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 1rem;
    border-bottom: 1px solid #e9ecef;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
}

.modal-header .close {
    padding: 1rem;
    margin: -1rem -1rem -1rem auto;
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5;
}

.modal-body {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1rem;
}

.modal-footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding: 1rem;
    border-top: 1px solid #e9ecef;
}

.modal-footer > :not(:first-child) {
    margin-left: .25rem;
}

.modal-footer > :not(:last-child) {
    margin-right: .25rem;
}

.modal-scrollbar-measure {
    position: absolute;
    top: -9999px;
    width: 50px;
    height: 50px;
    overflow: scroll;
}

@media (min-width: 576px) {
    .modal-dialog {
        max-width: 500px;
        margin: 1.75rem auto;
    }

    .modal-dialog-centered {
        min-height: calc(100% - (1.75rem * 2));
    }

    .modal-sm {
        max-width: 300px;
    }
}

@media (min-width: 992px) {
    .modal-lg {
        max-width: 800px;
    }
}

.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 0.875rem;
    word-wrap: break-word;
    opacity: 0;
}

.tooltip.show {
    opacity: 0.9;
}

.tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem;
}

.tooltip .arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
    padding: 0.4rem 0;
}

.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
    bottom: 0;
}

.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
    top: 0;
    border-width: 0.4rem 0.4rem 0;
    border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
    padding: 0 0.4rem;
}

.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
    left: 0;
    width: 0.4rem;
    height: 0.8rem;
}

.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
    right: 0;
    border-width: 0.4rem 0.4rem 0.4rem 0;
    border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
    padding: 0.4rem 0;
}

.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
    top: 0;
}

.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
    bottom: 0;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
    padding: 0 0.4rem;
}

.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
    right: 0;
    width: 0.4rem;
    height: 0.8rem;
}

.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
    left: 0;
    border-width: 0.4rem 0 0.4rem 0.4rem;
    border-left-color: #000;
}

.tooltip-inner {
    max-width: 200px;
    padding: 0.25rem 0.5rem;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: 0.25rem;
}

.popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    display: block;
    max-width: 276px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 0.875rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
}

.popover .arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: 0.5rem;
    margin: 0 0.3rem;
}

.popover .arrow::before, .popover .arrow::after {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
    margin-bottom: 0.5rem;
}

.bs-popover-top .arrow, .bs-popover-auto[x-placement^="top"] .arrow {
    bottom: calc((0.5rem + 1px) * -1);
}

.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^="top"] .arrow::before,
.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^="top"] .arrow::after {
    border-width: 0.5rem 0.5rem 0;
}

.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^="top"] .arrow::before {
    bottom: 0;
    border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^="top"] .arrow::after {
    bottom: 1px;
    border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
    margin-left: 0.5rem;
}

.bs-popover-right .arrow, .bs-popover-auto[x-placement^="right"] .arrow {
    left: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0;
}

.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^="right"] .arrow::before,
.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^="right"] .arrow::after {
    border-width: 0.5rem 0.5rem 0.5rem 0;
}

.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^="right"] .arrow::before {
    left: 0;
    border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^="right"] .arrow::after {
    left: 1px;
    border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
    margin-top: 0.5rem;
}

.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^="bottom"] .arrow {
    top: calc((0.5rem + 1px) * -1);
}

.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^="bottom"] .arrow::before,
.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    border-width: 0 0.5rem 0.5rem 0.5rem;
}

.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^="bottom"] .arrow::before {
    top: 0;
    border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^="bottom"] .arrow::after {
    top: 1px;
    border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -0.5rem;
    content: "";
    border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left, .bs-popover-auto[x-placement^="left"] {
    margin-right: 0.5rem;
}

.bs-popover-left .arrow, .bs-popover-auto[x-placement^="left"] .arrow {
    right: calc((0.5rem + 1px) * -1);
    width: 0.5rem;
    height: 1rem;
    margin: 0.3rem 0;
}

.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^="left"] .arrow::before,
.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^="left"] .arrow::after {
    border-width: 0.5rem 0 0.5rem 0.5rem;
}

.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^="left"] .arrow::before {
    right: 0;
    border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^="left"] .arrow::after {
    right: 1px;
    border-left-color: #fff;
}

.popover-header {
    padding: 0.5rem 0.75rem;
    margin-bottom: 0;
    font-size: 1rem;
    color: inherit;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}

.popover-header:empty {
    display: none;
}

.popover-body {
    padding: 0.5rem 0.75rem;
    color: #212529;
}

.carousel {
    position: relative;
}

.carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.carousel-item {
    position: relative;
    display: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    transition: -webkit-transform 0.6s ease;
    transition: transform 0.6s ease;
    transition: transform 0.6s ease, -webkit-transform 0.6s ease;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000px;
    perspective: 1000px;
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
    display: block;
}

.carousel-item-next,
.carousel-item-prev {
    position: absolute;
    top: 0;
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
    -webkit-transform: translateX(0);
    transform: translateX(0);
}

@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
    .carousel-item-next.carousel-item-left,
    .carousel-item-prev.carousel-item-right {
        -webkit-transform: translate3d(0, 0, 0);
        transform: translate3d(0, 0, 0);
    }
}

.carousel-item-next,
.active.carousel-item-right {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
}

@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
    .carousel-item-next,
    .active.carousel-item-right {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }
}

.carousel-item-prev,
.active.carousel-item-left {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
}

@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {
    .carousel-item-prev,
    .active.carousel-item-left {
        -webkit-transform: translate3d(-100%, 0, 0);
        transform: translate3d(-100%, 0, 0);
    }
}

.carousel-control-prev,
.carousel-control-next {
    position: absolute;
    top: 0;
    bottom: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 15%;
    color: #fff;
    text-align: center;
    opacity: 0.5;
}

.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: .9;
}

.carousel-control-prev {
    left: 0;
}

.carousel-control-next {
    right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: transparent no-repeat center center;
    background-size: 100% 100%;
}

.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 10px;
    left: 0;
    z-index: 15;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-left: 0;
    margin-right: 15%;
    margin-left: 15%;
    list-style: none;
}

.carousel-indicators li {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    background-color: rgba(255, 255, 255, 0.5);
}

.carousel-indicators li::before {
    position: absolute;
    top: -10px;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 10px;
    content: "";
}

.carousel-indicators li::after {
    position: absolute;
    bottom: -10px;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 10px;
    content: "";
}

.carousel-indicators .active {
    background-color: #fff;
}

.carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 20px;
    left: 15%;
    z-index: 10;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #fff;
    text-align: center;
}

.align-baseline {
    vertical-align: baseline !important;
}

.align-top {
    vertical-align: top !important;
}

.align-middle {
    vertical-align: middle !important;
}

.align-bottom {
    vertical-align: bottom !important;
}

.align-text-bottom {
    vertical-align: text-bottom !important;
}

.align-text-top {
    vertical-align: text-top !important;
}

.bg-primary {
    background-color: #007bff !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
    background-color: #0062cc !important;
}

.bg-secondary {
    background-color: #6c757d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
    background-color: #545b62 !important;
}

.bg-success {
    background-color: #28a745 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
    background-color: #1e7e34 !important;
}

.bg-info {
    background-color: #17a2b8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
    background-color: #117a8b !important;
}

.bg-warning {
    background-color: #ffc107 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
    background-color: #d39e00 !important;
}

.bg-danger {
    background-color: #dc3545 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
    background-color: #bd2130 !important;
}

.bg-light {
    background-color: #f8f9fa !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
    background-color: #dae0e5 !important;
}

.bg-dark {
    background-color: #343a40 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
    background-color: #1d2124 !important;
}

.bg-white {
    background-color: #fff !important;
}

.bg-transparent {
    background-color: transparent !important;
}

.border {
    border: 1px solid #dee2e6 !important;
}

.border-top {
    border-top: 1px solid #dee2e6 !important;
}

.border-right {
    border-right: 1px solid #dee2e6 !important;
}

.border-bottom {
    border-bottom: 1px solid #dee2e6 !important;
}

.border-left {
    border-left: 1px solid #dee2e6 !important;
}

.border-0 {
    border: 0 !important;
}

.border-top-0 {
    border-top: 0 !important;
}

.border-right-0 {
    border-right: 0 !important;
}

.border-bottom-0 {
    border-bottom: 0 !important;
}

.border-left-0 {
    border-left: 0 !important;
}

.border-primary {
    border-color: #007bff !important;
}

.border-secondary {
    border-color: #6c757d !important;
}

.border-success {
    border-color: #28a745 !important;
}

.border-info {
    border-color: #17a2b8 !important;
}

.border-warning {
    border-color: #ffc107 !important;
}

.border-danger {
    border-color: #dc3545 !important;
}

.border-light {
    border-color: #f8f9fa !important;
}

.border-dark {
    border-color: #343a40 !important;
}

.border-white {
    border-color: #fff !important;
}

.rounded {
    border-radius: 0.25rem !important;
}

.rounded-top {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
}

.rounded-right {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
    border-bottom-right-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
    border-top-left-radius: 0.25rem !important;
    border-bottom-left-radius: 0.25rem !important;
}

.rounded-circle {
    border-radius: 50% !important;
}

.rounded-0 {
    border-radius: 0 !important;
}

.clearfix::after {
    display: block;
    clear: both;
    content: "";
}

.d-none {
    display: none !important;
}

.d-inline {
    display: inline !important;
}

.d-inline-block {
    display: inline-block !important;
}

.d-block {
    display: block !important;
}

.d-table {
    display: table !important;
}

.d-table-row {
    display: table-row !important;
}

.d-table-cell {
    display: table-cell !important;
}

.d-flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
}

.d-inline-flex {
    display: -webkit-inline-box !important;
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
}

@media (min-width: 576px) {
    .d-sm-none {
        display: none !important;
    }

    .d-sm-inline {
        display: inline !important;
    }

    .d-sm-inline-block {
        display: inline-block !important;
    }

    .d-sm-block {
        display: block !important;
    }

    .d-sm-table {
        display: table !important;
    }

    .d-sm-table-row {
        display: table-row !important;
    }

    .d-sm-table-cell {
        display: table-cell !important;
    }

    .d-sm-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-sm-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media (min-width: 768px) {
    .d-md-none {
        display: none !important;
    }

    .d-md-inline {
        display: inline !important;
    }

    .d-md-inline-block {
        display: inline-block !important;
    }

    .d-md-block {
        display: block !important;
    }

    .d-md-table {
        display: table !important;
    }

    .d-md-table-row {
        display: table-row !important;
    }

    .d-md-table-cell {
        display: table-cell !important;
    }

    .d-md-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-md-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media (min-width: 992px) {
    .d-lg-none {
        display: none !important;
    }

    .d-lg-inline {
        display: inline !important;
    }

    .d-lg-inline-block {
        display: inline-block !important;
    }

    .d-lg-block {
        display: block !important;
    }

    .d-lg-table {
        display: table !important;
    }

    .d-lg-table-row {
        display: table-row !important;
    }

    .d-lg-table-cell {
        display: table-cell !important;
    }

    .d-lg-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-lg-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media (min-width: 1200px) {
    .d-xl-none {
        display: none !important;
    }

    .d-xl-inline {
        display: inline !important;
    }

    .d-xl-inline-block {
        display: inline-block !important;
    }

    .d-xl-block {
        display: block !important;
    }

    .d-xl-table {
        display: table !important;
    }

    .d-xl-table-row {
        display: table-row !important;
    }

    .d-xl-table-cell {
        display: table-cell !important;
    }

    .d-xl-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-xl-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

@media print {
    .d-print-none {
        display: none !important;
    }

    .d-print-inline {
        display: inline !important;
    }

    .d-print-inline-block {
        display: inline-block !important;
    }

    .d-print-block {
        display: block !important;
    }

    .d-print-table {
        display: table !important;
    }

    .d-print-table-row {
        display: table-row !important;
    }

    .d-print-table-cell {
        display: table-cell !important;
    }

    .d-print-flex {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .d-print-inline-flex {
        display: -webkit-inline-box !important;
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
}

.embed-responsive {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden;
}

.embed-responsive::before {
    display: block;
    content: "";
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}

.embed-responsive-21by9::before {
    padding-top: 42.857143%;
}

.embed-responsive-16by9::before {
    padding-top: 56.25%;
}

.embed-responsive-4by3::before {
    padding-top: 75%;
}

.embed-responsive-1by1::before {
    padding-top: 100%;
}

.flex-row {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
}

.flex-column {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: column !important;
    flex-direction: column !important;
}

.flex-row-reverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
}

.flex-column-reverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
}

.flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
}

.flex-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
}

.justify-content-start {
    -webkit-box-pack: start !important;
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
}

.justify-content-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
}

.justify-content-center {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
}

.justify-content-between {
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
}

.justify-content-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
}

.align-items-start {
    -webkit-box-align: start !important;
    -ms-flex-align: start !important;
    align-items: flex-start !important;
}

.align-items-end {
    -webkit-box-align: end !important;
    -ms-flex-align: end !important;
    align-items: flex-end !important;
}

.align-items-center {
    -webkit-box-align: center !important;
    -ms-flex-align: center !important;
    align-items: center !important;
}

.align-items-baseline {
    -webkit-box-align: baseline !important;
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
}

.align-items-stretch {
    -webkit-box-align: stretch !important;
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
}

.align-content-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
}

.align-content-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
}

.align-content-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
}

.align-content-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
}

.align-content-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
}

.align-content-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
}

.align-self-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
}

.align-self-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
}

.align-self-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
}

.align-self-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
}

.align-self-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
}

.align-self-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
}

@media (min-width: 576px) {
    .flex-sm-row {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }

    .flex-sm-column {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }

    .flex-sm-row-reverse {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }

    .flex-sm-column-reverse {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }

    .flex-sm-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }

    .flex-sm-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }

    .flex-sm-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-sm-start {
        -webkit-box-pack: start !important;
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }

    .justify-content-sm-end {
        -webkit-box-pack: end !important;
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }

    .justify-content-sm-center {
        -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }

    .justify-content-sm-between {
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }

    .justify-content-sm-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }

    .align-items-sm-start {
        -webkit-box-align: start !important;
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }

    .align-items-sm-end {
        -webkit-box-align: end !important;
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }

    .align-items-sm-center {
        -webkit-box-align: center !important;
        -ms-flex-align: center !important;
        align-items: center !important;
    }

    .align-items-sm-baseline {
        -webkit-box-align: baseline !important;
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }

    .align-items-sm-stretch {
        -webkit-box-align: stretch !important;
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }

    .align-content-sm-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }

    .align-content-sm-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }

    .align-content-sm-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }

    .align-content-sm-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }

    .align-content-sm-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }

    .align-content-sm-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }

    .align-self-sm-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }

    .align-self-sm-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }

    .align-self-sm-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }

    .align-self-sm-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }

    .align-self-sm-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }

    .align-self-sm-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}

@media (min-width: 768px) {
    .flex-md-row {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }

    .flex-md-column {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }

    .flex-md-row-reverse {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }

    .flex-md-column-reverse {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }

    .flex-md-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }

    .flex-md-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }

    .flex-md-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-md-start {
        -webkit-box-pack: start !important;
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }

    .justify-content-md-end {
        -webkit-box-pack: end !important;
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }

    .justify-content-md-center {
        -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }

    .justify-content-md-between {
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }

    .justify-content-md-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }

    .align-items-md-start {
        -webkit-box-align: start !important;
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }

    .align-items-md-end {
        -webkit-box-align: end !important;
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }

    .align-items-md-center {
        -webkit-box-align: center !important;
        -ms-flex-align: center !important;
        align-items: center !important;
    }

    .align-items-md-baseline {
        -webkit-box-align: baseline !important;
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }

    .align-items-md-stretch {
        -webkit-box-align: stretch !important;
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }

    .align-content-md-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }

    .align-content-md-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }

    .align-content-md-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }

    .align-content-md-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }

    .align-content-md-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }

    .align-content-md-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }

    .align-self-md-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }

    .align-self-md-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }

    .align-self-md-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }

    .align-self-md-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }

    .align-self-md-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }

    .align-self-md-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}

@media (min-width: 992px) {
    .flex-lg-row {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }

    .flex-lg-column {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }

    .flex-lg-row-reverse {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }

    .flex-lg-column-reverse {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }

    .flex-lg-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }

    .flex-lg-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }

    .flex-lg-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-lg-start {
        -webkit-box-pack: start !important;
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }

    .justify-content-lg-end {
        -webkit-box-pack: end !important;
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }

    .justify-content-lg-center {
        -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }

    .justify-content-lg-between {
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }

    .justify-content-lg-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }

    .align-items-lg-start {
        -webkit-box-align: start !important;
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }

    .align-items-lg-end {
        -webkit-box-align: end !important;
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }

    .align-items-lg-center {
        -webkit-box-align: center !important;
        -ms-flex-align: center !important;
        align-items: center !important;
    }

    .align-items-lg-baseline {
        -webkit-box-align: baseline !important;
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }

    .align-items-lg-stretch {
        -webkit-box-align: stretch !important;
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }

    .align-content-lg-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }

    .align-content-lg-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }

    .align-content-lg-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }

    .align-content-lg-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }

    .align-content-lg-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }

    .align-content-lg-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }

    .align-self-lg-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }

    .align-self-lg-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }

    .align-self-lg-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }

    .align-self-lg-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }

    .align-self-lg-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }

    .align-self-lg-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}

@media (min-width: 1200px) {
    .flex-xl-row {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: row !important;
        flex-direction: row !important;
    }

    .flex-xl-column {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: normal !important;
        -ms-flex-direction: column !important;
        flex-direction: column !important;
    }

    .flex-xl-row-reverse {
        -webkit-box-orient: horizontal !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: row-reverse !important;
        flex-direction: row-reverse !important;
    }

    .flex-xl-column-reverse {
        -webkit-box-orient: vertical !important;
        -webkit-box-direction: reverse !important;
        -ms-flex-direction: column-reverse !important;
        flex-direction: column-reverse !important;
    }

    .flex-xl-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }

    .flex-xl-nowrap {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
    }

    .flex-xl-wrap-reverse {
        -ms-flex-wrap: wrap-reverse !important;
        flex-wrap: wrap-reverse !important;
    }

    .justify-content-xl-start {
        -webkit-box-pack: start !important;
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }

    .justify-content-xl-end {
        -webkit-box-pack: end !important;
        -ms-flex-pack: end !important;
        justify-content: flex-end !important;
    }

    .justify-content-xl-center {
        -webkit-box-pack: center !important;
        -ms-flex-pack: center !important;
        justify-content: center !important;
    }

    .justify-content-xl-between {
        -webkit-box-pack: justify !important;
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }

    .justify-content-xl-around {
        -ms-flex-pack: distribute !important;
        justify-content: space-around !important;
    }

    .align-items-xl-start {
        -webkit-box-align: start !important;
        -ms-flex-align: start !important;
        align-items: flex-start !important;
    }

    .align-items-xl-end {
        -webkit-box-align: end !important;
        -ms-flex-align: end !important;
        align-items: flex-end !important;
    }

    .align-items-xl-center {
        -webkit-box-align: center !important;
        -ms-flex-align: center !important;
        align-items: center !important;
    }

    .align-items-xl-baseline {
        -webkit-box-align: baseline !important;
        -ms-flex-align: baseline !important;
        align-items: baseline !important;
    }

    .align-items-xl-stretch {
        -webkit-box-align: stretch !important;
        -ms-flex-align: stretch !important;
        align-items: stretch !important;
    }

    .align-content-xl-start {
        -ms-flex-line-pack: start !important;
        align-content: flex-start !important;
    }

    .align-content-xl-end {
        -ms-flex-line-pack: end !important;
        align-content: flex-end !important;
    }

    .align-content-xl-center {
        -ms-flex-line-pack: center !important;
        align-content: center !important;
    }

    .align-content-xl-between {
        -ms-flex-line-pack: justify !important;
        align-content: space-between !important;
    }

    .align-content-xl-around {
        -ms-flex-line-pack: distribute !important;
        align-content: space-around !important;
    }

    .align-content-xl-stretch {
        -ms-flex-line-pack: stretch !important;
        align-content: stretch !important;
    }

    .align-self-xl-auto {
        -ms-flex-item-align: auto !important;
        align-self: auto !important;
    }

    .align-self-xl-start {
        -ms-flex-item-align: start !important;
        align-self: flex-start !important;
    }

    .align-self-xl-end {
        -ms-flex-item-align: end !important;
        align-self: flex-end !important;
    }

    .align-self-xl-center {
        -ms-flex-item-align: center !important;
        align-self: center !important;
    }

    .align-self-xl-baseline {
        -ms-flex-item-align: baseline !important;
        align-self: baseline !important;
    }

    .align-self-xl-stretch {
        -ms-flex-item-align: stretch !important;
        align-self: stretch !important;
    }
}

.float-left {
    float: left !important;
}

.float-right {
    float: right !important;
}

.float-none {
    float: none !important;
}

@media (min-width: 576px) {
    .float-sm-left {
        float: left !important;
    }

    .float-sm-right {
        float: right !important;
    }

    .float-sm-none {
        float: none !important;
    }
}

@media (min-width: 768px) {
    .float-md-left {
        float: left !important;
    }

    .float-md-right {
        float: right !important;
    }

    .float-md-none {
        float: none !important;
    }
}

@media (min-width: 992px) {
    .float-lg-left {
        float: left !important;
    }

    .float-lg-right {
        float: right !important;
    }

    .float-lg-none {
        float: none !important;
    }
}

@media (min-width: 1200px) {
    .float-xl-left {
        float: left !important;
    }

    .float-xl-right {
        float: right !important;
    }

    .float-xl-none {
        float: none !important;
    }
}

.position-static {
    position: static !important;
}

.position-relative {
    position: relative !important;
}

.position-absolute {
    position: absolute !important;
}

.position-fixed {
    position: fixed !important;
}

.position-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
}

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030;
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
    .sticky-top {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 1020;
    }
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    -webkit-clip-path: inset(50%);
    clip-path: inset(50%);
    border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
    -webkit-clip-path: none;
    clip-path: none;
}

.w-25 {
    width: 25% !important;
}

.w-50 {
    width: 50% !important;
}

.w-75 {
    width: 75% !important;
}

.w-100 {
    width: 100% !important;
}

.h-25 {
    height: 25% !important;
}

.h-50 {
    height: 50% !important;
}

.h-75 {
    height: 75% !important;
}

.h-100 {
    height: 100% !important;
}

.mw-100 {
    max-width: 100% !important;
}

.mh-100 {
    max-height: 100% !important;
}

.m-0 {
    margin: 0 !important;
}

.mt-0,
.my-0 {
    margin-top: 0 !important;
}

.mr-0,
.mx-0 {
    margin-right: 0 !important;
}

.mb-0,
.my-0 {
    margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
    margin-left: 0 !important;
}

.m-1 {
    margin: 0.25rem !important;
}

.mt-1,
.my-1 {
    margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
    margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
    margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
    margin-left: 0.25rem !important;
}

.m-2 {
    margin: 0.5rem !important;
}

.mt-2,
.my-2 {
    margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
    margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
    margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
    margin-left: 0.5rem !important;
}

.m-3 {
    margin: 1rem !important;
}

.mt-3,
.my-3 {
    margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
    margin-right: 1rem !important;
}

.mb-3,
.my-3 {
    margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
    margin-left: 1rem !important;
}

.m-4 {
    margin: 1.5rem !important;
}

.mt-4,
.my-4 {
    margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
    margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
    margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
    margin-left: 1.5rem !important;
}

.m-5 {
    margin: 3rem !important;
}

.mt-5,
.my-5 {
    margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
    margin-right: 3rem !important;
}

.mb-5,
.my-5 {
    margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
    margin-left: 3rem !important;
}

.p-0 {
    padding: 0 !important;
}

.pt-0,
.py-0 {
    padding-top: 0 !important;
}

.pr-0,
.px-0 {
    padding-right: 0 !important;
}

.pb-0,
.py-0 {
    padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
    padding-left: 0 !important;
}

.p-1 {
    padding: 0.25rem !important;
}

.pt-1,
.py-1 {
    padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
    padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
    padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
    padding-left: 0.25rem !important;
}

.p-2 {
    padding: 0.5rem !important;
}

.pt-2,
.py-2 {
    padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
    padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
    padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
    padding-left: 0.5rem !important;
}

.p-3 {
    padding: 1rem !important;
}

.pt-3,
.py-3 {
    padding-top: 1rem !important;
}

.pr-3,
.px-3 {
    padding-right: 1rem !important;
}

.pb-3,
.py-3 {
    padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
    padding-left: 1rem !important;
}

.p-4 {
    padding: 1.5rem !important;
}

.pt-4,
.py-4 {
    padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
    padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
    padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
    padding-left: 1.5rem !important;
}

.p-5 {
    padding: 3rem !important;
}

.pt-5,
.py-5 {
    padding-top: 3rem !important;
}

.pr-5,
.px-5 {
    padding-right: 3rem !important;
}

.pb-5,
.py-5 {
    padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
    padding-left: 3rem !important;
}

.m-auto {
    margin: auto !important;
}

.mt-auto,
.my-auto {
    margin-top: auto !important;
}

.mr-auto,
.mx-auto {
    margin-right: auto !important;
}

.mb-auto,
.my-auto {
    margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
    margin-left: auto !important;
}

@media (min-width: 576px) {
    .m-sm-0 {
        margin: 0 !important;
    }

    .mt-sm-0,
    .my-sm-0 {
        margin-top: 0 !important;
    }

    .mr-sm-0,
    .mx-sm-0 {
        margin-right: 0 !important;
    }

    .mb-sm-0,
    .my-sm-0 {
        margin-bottom: 0 !important;
    }

    .ml-sm-0,
    .mx-sm-0 {
        margin-left: 0 !important;
    }

    .m-sm-1 {
        margin: 0.25rem !important;
    }

    .mt-sm-1,
    .my-sm-1 {
        margin-top: 0.25rem !important;
    }

    .mr-sm-1,
    .mx-sm-1 {
        margin-right: 0.25rem !important;
    }

    .mb-sm-1,
    .my-sm-1 {
        margin-bottom: 0.25rem !important;
    }

    .ml-sm-1,
    .mx-sm-1 {
        margin-left: 0.25rem !important;
    }

    .m-sm-2 {
        margin: 0.5rem !important;
    }

    .mt-sm-2,
    .my-sm-2 {
        margin-top: 0.5rem !important;
    }

    .mr-sm-2,
    .mx-sm-2 {
        margin-right: 0.5rem !important;
    }

    .mb-sm-2,
    .my-sm-2 {
        margin-bottom: 0.5rem !important;
    }

    .ml-sm-2,
    .mx-sm-2 {
        margin-left: 0.5rem !important;
    }

    .m-sm-3 {
        margin: 1rem !important;
    }

    .mt-sm-3,
    .my-sm-3 {
        margin-top: 1rem !important;
    }

    .mr-sm-3,
    .mx-sm-3 {
        margin-right: 1rem !important;
    }

    .mb-sm-3,
    .my-sm-3 {
        margin-bottom: 1rem !important;
    }

    .ml-sm-3,
    .mx-sm-3 {
        margin-left: 1rem !important;
    }

    .m-sm-4 {
        margin: 1.5rem !important;
    }

    .mt-sm-4,
    .my-sm-4 {
        margin-top: 1.5rem !important;
    }

    .mr-sm-4,
    .mx-sm-4 {
        margin-right: 1.5rem !important;
    }

    .mb-sm-4,
    .my-sm-4 {
        margin-bottom: 1.5rem !important;
    }

    .ml-sm-4,
    .mx-sm-4 {
        margin-left: 1.5rem !important;
    }

    .m-sm-5 {
        margin: 3rem !important;
    }

    .mt-sm-5,
    .my-sm-5 {
        margin-top: 3rem !important;
    }

    .mr-sm-5,
    .mx-sm-5 {
        margin-right: 3rem !important;
    }

    .mb-sm-5,
    .my-sm-5 {
        margin-bottom: 3rem !important;
    }

    .ml-sm-5,
    .mx-sm-5 {
        margin-left: 3rem !important;
    }

    .p-sm-0 {
        padding: 0 !important;
    }

    .pt-sm-0,
    .py-sm-0 {
        padding-top: 0 !important;
    }

    .pr-sm-0,
    .px-sm-0 {
        padding-right: 0 !important;
    }

    .pb-sm-0,
    .py-sm-0 {
        padding-bottom: 0 !important;
    }

    .pl-sm-0,
    .px-sm-0 {
        padding-left: 0 !important;
    }

    .p-sm-1 {
        padding: 0.25rem !important;
    }

    .pt-sm-1,
    .py-sm-1 {
        padding-top: 0.25rem !important;
    }

    .pr-sm-1,
    .px-sm-1 {
        padding-right: 0.25rem !important;
    }

    .pb-sm-1,
    .py-sm-1 {
        padding-bottom: 0.25rem !important;
    }

    .pl-sm-1,
    .px-sm-1 {
        padding-left: 0.25rem !important;
    }

    .p-sm-2 {
        padding: 0.5rem !important;
    }

    .pt-sm-2,
    .py-sm-2 {
        padding-top: 0.5rem !important;
    }

    .pr-sm-2,
    .px-sm-2 {
        padding-right: 0.5rem !important;
    }

    .pb-sm-2,
    .py-sm-2 {
        padding-bottom: 0.5rem !important;
    }

    .pl-sm-2,
    .px-sm-2 {
        padding-left: 0.5rem !important;
    }

    .p-sm-3 {
        padding: 1rem !important;
    }

    .pt-sm-3,
    .py-sm-3 {
        padding-top: 1rem !important;
    }

    .pr-sm-3,
    .px-sm-3 {
        padding-right: 1rem !important;
    }

    .pb-sm-3,
    .py-sm-3 {
        padding-bottom: 1rem !important;
    }

    .pl-sm-3,
    .px-sm-3 {
        padding-left: 1rem !important;
    }

    .p-sm-4 {
        padding: 1.5rem !important;
    }

    .pt-sm-4,
    .py-sm-4 {
        padding-top: 1.5rem !important;
    }

    .pr-sm-4,
    .px-sm-4 {
        padding-right: 1.5rem !important;
    }

    .pb-sm-4,
    .py-sm-4 {
        padding-bottom: 1.5rem !important;
    }

    .pl-sm-4,
    .px-sm-4 {
        padding-left: 1.5rem !important;
    }

    .p-sm-5 {
        padding: 3rem !important;
    }

    .pt-sm-5,
    .py-sm-5 {
        padding-top: 3rem !important;
    }

    .pr-sm-5,
    .px-sm-5 {
        padding-right: 3rem !important;
    }

    .pb-sm-5,
    .py-sm-5 {
        padding-bottom: 3rem !important;
    }

    .pl-sm-5,
    .px-sm-5 {
        padding-left: 3rem !important;
    }

    .m-sm-auto {
        margin: auto !important;
    }

    .mt-sm-auto,
    .my-sm-auto {
        margin-top: auto !important;
    }

    .mr-sm-auto,
    .mx-sm-auto {
        margin-right: auto !important;
    }

    .mb-sm-auto,
    .my-sm-auto {
        margin-bottom: auto !important;
    }

    .ml-sm-auto,
    .mx-sm-auto {
        margin-left: auto !important;
    }
}

@media (min-width: 768px) {
    .m-md-0 {
        margin: 0 !important;
    }

    .mt-md-0,
    .my-md-0 {
        margin-top: 0 !important;
    }

    .mr-md-0,
    .mx-md-0 {
        margin-right: 0 !important;
    }

    .mb-md-0,
    .my-md-0 {
        margin-bottom: 0 !important;
    }

    .ml-md-0,
    .mx-md-0 {
        margin-left: 0 !important;
    }

    .m-md-1 {
        margin: 0.25rem !important;
    }

    .mt-md-1,
    .my-md-1 {
        margin-top: 0.25rem !important;
    }

    .mr-md-1,
    .mx-md-1 {
        margin-right: 0.25rem !important;
    }

    .mb-md-1,
    .my-md-1 {
        margin-bottom: 0.25rem !important;
    }

    .ml-md-1,
    .mx-md-1 {
        margin-left: 0.25rem !important;
    }

    .m-md-2 {
        margin: 0.5rem !important;
    }

    .mt-md-2,
    .my-md-2 {
        margin-top: 0.5rem !important;
    }

    .mr-md-2,
    .mx-md-2 {
        margin-right: 0.5rem !important;
    }

    .mb-md-2,
    .my-md-2 {
        margin-bottom: 0.5rem !important;
    }

    .ml-md-2,
    .mx-md-2 {
        margin-left: 0.5rem !important;
    }

    .m-md-3 {
        margin: 1rem !important;
    }

    .mt-md-3,
    .my-md-3 {
        margin-top: 1rem !important;
    }

    .mr-md-3,
    .mx-md-3 {
        margin-right: 1rem !important;
    }

    .mb-md-3,
    .my-md-3 {
        margin-bottom: 1rem !important;
    }

    .ml-md-3,
    .mx-md-3 {
        margin-left: 1rem !important;
    }

    .m-md-4 {
        margin: 1.5rem !important;
    }

    .mt-md-4,
    .my-md-4 {
        margin-top: 1.5rem !important;
    }

    .mr-md-4,
    .mx-md-4 {
        margin-right: 1.5rem !important;
    }

    .mb-md-4,
    .my-md-4 {
        margin-bottom: 1.5rem !important;
    }

    .ml-md-4,
    .mx-md-4 {
        margin-left: 1.5rem !important;
    }

    .m-md-5 {
        margin: 3rem !important;
    }

    .mt-md-5,
    .my-md-5 {
        margin-top: 3rem !important;
    }

    .mr-md-5,
    .mx-md-5 {
        margin-right: 3rem !important;
    }

    .mb-md-5,
    .my-md-5 {
        margin-bottom: 3rem !important;
    }

    .ml-md-5,
    .mx-md-5 {
        margin-left: 3rem !important;
    }

    .p-md-0 {
        padding: 0 !important;
    }

    .pt-md-0,
    .py-md-0 {
        padding-top: 0 !important;
    }

    .pr-md-0,
    .px-md-0 {
        padding-right: 0 !important;
    }

    .pb-md-0,
    .py-md-0 {
        padding-bottom: 0 !important;
    }

    .pl-md-0,
    .px-md-0 {
        padding-left: 0 !important;
    }

    .p-md-1 {
        padding: 0.25rem !important;
    }

    .pt-md-1,
    .py-md-1 {
        padding-top: 0.25rem !important;
    }

    .pr-md-1,
    .px-md-1 {
        padding-right: 0.25rem !important;
    }

    .pb-md-1,
    .py-md-1 {
        padding-bottom: 0.25rem !important;
    }

    .pl-md-1,
    .px-md-1 {
        padding-left: 0.25rem !important;
    }

    .p-md-2 {
        padding: 0.5rem !important;
    }

    .pt-md-2,
    .py-md-2 {
        padding-top: 0.5rem !important;
    }

    .pr-md-2,
    .px-md-2 {
        padding-right: 0.5rem !important;
    }

    .pb-md-2,
    .py-md-2 {
        padding-bottom: 0.5rem !important;
    }

    .pl-md-2,
    .px-md-2 {
        padding-left: 0.5rem !important;
    }

    .p-md-3 {
        padding: 1rem !important;
    }

    .pt-md-3,
    .py-md-3 {
        padding-top: 1rem !important;
    }

    .pr-md-3,
    .px-md-3 {
        padding-right: 1rem !important;
    }

    .pb-md-3,
    .py-md-3 {
        padding-bottom: 1rem !important;
    }

    .pl-md-3,
    .px-md-3 {
        padding-left: 1rem !important;
    }

    .p-md-4 {
        padding: 1.5rem !important;
    }

    .pt-md-4,
    .py-md-4 {
        padding-top: 1.5rem !important;
    }

    .pr-md-4,
    .px-md-4 {
        padding-right: 1.5rem !important;
    }

    .pb-md-4,
    .py-md-4 {
        padding-bottom: 1.5rem !important;
    }

    .pl-md-4,
    .px-md-4 {
        padding-left: 1.5rem !important;
    }

    .p-md-5 {
        padding: 3rem !important;
    }

    .pt-md-5,
    .py-md-5 {
        padding-top: 3rem !important;
    }

    .pr-md-5,
    .px-md-5 {
        padding-right: 3rem !important;
    }

    .pb-md-5,
    .py-md-5 {
        padding-bottom: 3rem !important;
    }

    .pl-md-5,
    .px-md-5 {
        padding-left: 3rem !important;
    }

    .m-md-auto {
        margin: auto !important;
    }

    .mt-md-auto,
    .my-md-auto {
        margin-top: auto !important;
    }

    .mr-md-auto,
    .mx-md-auto {
        margin-right: auto !important;
    }

    .mb-md-auto,
    .my-md-auto {
        margin-bottom: auto !important;
    }

    .ml-md-auto,
    .mx-md-auto {
        margin-left: auto !important;
    }
}

@media (min-width: 992px) {
    .m-lg-0 {
        margin: 0 !important;
    }

    .mt-lg-0,
    .my-lg-0 {
        margin-top: 0 !important;
    }

    .mr-lg-0,
    .mx-lg-0 {
        margin-right: 0 !important;
    }

    .mb-lg-0,
    .my-lg-0 {
        margin-bottom: 0 !important;
    }

    .ml-lg-0,
    .mx-lg-0 {
        margin-left: 0 !important;
    }

    .m-lg-1 {
        margin: 0.25rem !important;
    }

    .mt-lg-1,
    .my-lg-1 {
        margin-top: 0.25rem !important;
    }

    .mr-lg-1,
    .mx-lg-1 {
        margin-right: 0.25rem !important;
    }

    .mb-lg-1,
    .my-lg-1 {
        margin-bottom: 0.25rem !important;
    }

    .ml-lg-1,
    .mx-lg-1 {
        margin-left: 0.25rem !important;
    }

    .m-lg-2 {
        margin: 0.5rem !important;
    }

    .mt-lg-2,
    .my-lg-2 {
        margin-top: 0.5rem !important;
    }

    .mr-lg-2,
    .mx-lg-2 {
        margin-right: 0.5rem !important;
    }

    .mb-lg-2,
    .my-lg-2 {
        margin-bottom: 0.5rem !important;
    }

    .ml-lg-2,
    .mx-lg-2 {
        margin-left: 0.5rem !important;
    }

    .m-lg-3 {
        margin: 1rem !important;
    }

    .mt-lg-3,
    .my-lg-3 {
        margin-top: 1rem !important;
    }

    .mr-lg-3,
    .mx-lg-3 {
        margin-right: 1rem !important;
    }

    .mb-lg-3,
    .my-lg-3 {
        margin-bottom: 1rem !important;
    }

    .ml-lg-3,
    .mx-lg-3 {
        margin-left: 1rem !important;
    }

    .m-lg-4 {
        margin: 1.5rem !important;
    }

    .mt-lg-4,
    .my-lg-4 {
        margin-top: 1.5rem !important;
    }

    .mr-lg-4,
    .mx-lg-4 {
        margin-right: 1.5rem !important;
    }

    .mb-lg-4,
    .my-lg-4 {
        margin-bottom: 1.5rem !important;
    }

    .ml-lg-4,
    .mx-lg-4 {
        margin-left: 1.5rem !important;
    }

    .m-lg-5 {
        margin: 3rem !important;
    }

    .mt-lg-5,
    .my-lg-5 {
        margin-top: 3rem !important;
    }

    .mr-lg-5,
    .mx-lg-5 {
        margin-right: 3rem !important;
    }

    .mb-lg-5,
    .my-lg-5 {
        margin-bottom: 3rem !important;
    }

    .ml-lg-5,
    .mx-lg-5 {
        margin-left: 3rem !important;
    }

    .p-lg-0 {
        padding: 0 !important;
    }

    .pt-lg-0,
    .py-lg-0 {
        padding-top: 0 !important;
    }

    .pr-lg-0,
    .px-lg-0 {
        padding-right: 0 !important;
    }

    .pb-lg-0,
    .py-lg-0 {
        padding-bottom: 0 !important;
    }

    .pl-lg-0,
    .px-lg-0 {
        padding-left: 0 !important;
    }

    .p-lg-1 {
        padding: 0.25rem !important;
    }

    .pt-lg-1,
    .py-lg-1 {
        padding-top: 0.25rem !important;
    }

    .pr-lg-1,
    .px-lg-1 {
        padding-right: 0.25rem !important;
    }

    .pb-lg-1,
    .py-lg-1 {
        padding-bottom: 0.25rem !important;
    }

    .pl-lg-1,
    .px-lg-1 {
        padding-left: 0.25rem !important;
    }

    .p-lg-2 {
        padding: 0.5rem !important;
    }

    .pt-lg-2,
    .py-lg-2 {
        padding-top: 0.5rem !important;
    }

    .pr-lg-2,
    .px-lg-2 {
        padding-right: 0.5rem !important;
    }

    .pb-lg-2,
    .py-lg-2 {
        padding-bottom: 0.5rem !important;
    }

    .pl-lg-2,
    .px-lg-2 {
        padding-left: 0.5rem !important;
    }

    .p-lg-3 {
        padding: 1rem !important;
    }

    .pt-lg-3,
    .py-lg-3 {
        padding-top: 1rem !important;
    }

    .pr-lg-3,
    .px-lg-3 {
        padding-right: 1rem !important;
    }

    .pb-lg-3,
    .py-lg-3 {
        padding-bottom: 1rem !important;
    }

    .pl-lg-3,
    .px-lg-3 {
        padding-left: 1rem !important;
    }

    .p-lg-4 {
        padding: 1.5rem !important;
    }

    .pt-lg-4,
    .py-lg-4 {
        padding-top: 1.5rem !important;
    }

    .pr-lg-4,
    .px-lg-4 {
        padding-right: 1.5rem !important;
    }

    .pb-lg-4,
    .py-lg-4 {
        padding-bottom: 1.5rem !important;
    }

    .pl-lg-4,
    .px-lg-4 {
        padding-left: 1.5rem !important;
    }

    .p-lg-5 {
        padding: 3rem !important;
    }

    .pt-lg-5,
    .py-lg-5 {
        padding-top: 3rem !important;
    }

    .pr-lg-5,
    .px-lg-5 {
        padding-right: 3rem !important;
    }

    .pb-lg-5,
    .py-lg-5 {
        padding-bottom: 3rem !important;
    }

    .pl-lg-5,
    .px-lg-5 {
        padding-left: 3rem !important;
    }

    .m-lg-auto {
        margin: auto !important;
    }

    .mt-lg-auto,
    .my-lg-auto {
        margin-top: auto !important;
    }

    .mr-lg-auto,
    .mx-lg-auto {
        margin-right: auto !important;
    }

    .mb-lg-auto,
    .my-lg-auto {
        margin-bottom: auto !important;
    }

    .ml-lg-auto,
    .mx-lg-auto {
        margin-left: auto !important;
    }
}

@media (min-width: 1200px) {
    .m-xl-0 {
        margin: 0 !important;
    }

    .mt-xl-0,
    .my-xl-0 {
        margin-top: 0 !important;
    }

    .mr-xl-0,
    .mx-xl-0 {
        margin-right: 0 !important;
    }

    .mb-xl-0,
    .my-xl-0 {
        margin-bottom: 0 !important;
    }

    .ml-xl-0,
    .mx-xl-0 {
        margin-left: 0 !important;
    }

    .m-xl-1 {
        margin: 0.25rem !important;
    }

    .mt-xl-1,
    .my-xl-1 {
        margin-top: 0.25rem !important;
    }

    .mr-xl-1,
    .mx-xl-1 {
        margin-right: 0.25rem !important;
    }

    .mb-xl-1,
    .my-xl-1 {
        margin-bottom: 0.25rem !important;
    }

    .ml-xl-1,
    .mx-xl-1 {
        margin-left: 0.25rem !important;
    }

    .m-xl-2 {
        margin: 0.5rem !important;
    }

    .mt-xl-2,
    .my-xl-2 {
        margin-top: 0.5rem !important;
    }

    .mr-xl-2,
    .mx-xl-2 {
        margin-right: 0.5rem !important;
    }

    .mb-xl-2,
    .my-xl-2 {
        margin-bottom: 0.5rem !important;
    }

    .ml-xl-2,
    .mx-xl-2 {
        margin-left: 0.5rem !important;
    }

    .m-xl-3 {
        margin: 1rem !important;
    }

    .mt-xl-3,
    .my-xl-3 {
        margin-top: 1rem !important;
    }

    .mr-xl-3,
    .mx-xl-3 {
        margin-right: 1rem !important;
    }

    .mb-xl-3,
    .my-xl-3 {
        margin-bottom: 1rem !important;
    }

    .ml-xl-3,
    .mx-xl-3 {
        margin-left: 1rem !important;
    }

    .m-xl-4 {
        margin: 1.5rem !important;
    }

    .mt-xl-4,
    .my-xl-4 {
        margin-top: 1.5rem !important;
    }

    .mr-xl-4,
    .mx-xl-4 {
        margin-right: 1.5rem !important;
    }

    .mb-xl-4,
    .my-xl-4 {
        margin-bottom: 1.5rem !important;
    }

    .ml-xl-4,
    .mx-xl-4 {
        margin-left: 1.5rem !important;
    }

    .m-xl-5 {
        margin: 3rem !important;
    }

    .mt-xl-5,
    .my-xl-5 {
        margin-top: 3rem !important;
    }

    .mr-xl-5,
    .mx-xl-5 {
        margin-right: 3rem !important;
    }

    .mb-xl-5,
    .my-xl-5 {
        margin-bottom: 3rem !important;
    }

    .ml-xl-5,
    .mx-xl-5 {
        margin-left: 3rem !important;
    }

    .p-xl-0 {
        padding: 0 !important;
    }

    .pt-xl-0,
    .py-xl-0 {
        padding-top: 0 !important;
    }

    .pr-xl-0,
    .px-xl-0 {
        padding-right: 0 !important;
    }

    .pb-xl-0,
    .py-xl-0 {
        padding-bottom: 0 !important;
    }

    .pl-xl-0,
    .px-xl-0 {
        padding-left: 0 !important;
    }

    .p-xl-1 {
        padding: 0.25rem !important;
    }

    .pt-xl-1,
    .py-xl-1 {
        padding-top: 0.25rem !important;
    }

    .pr-xl-1,
    .px-xl-1 {
        padding-right: 0.25rem !important;
    }

    .pb-xl-1,
    .py-xl-1 {
        padding-bottom: 0.25rem !important;
    }

    .pl-xl-1,
    .px-xl-1 {
        padding-left: 0.25rem !important;
    }

    .p-xl-2 {
        padding: 0.5rem !important;
    }

    .pt-xl-2,
    .py-xl-2 {
        padding-top: 0.5rem !important;
    }

    .pr-xl-2,
    .px-xl-2 {
        padding-right: 0.5rem !important;
    }

    .pb-xl-2,
    .py-xl-2 {
        padding-bottom: 0.5rem !important;
    }

    .pl-xl-2,
    .px-xl-2 {
        padding-left: 0.5rem !important;
    }

    .p-xl-3 {
        padding: 1rem !important;
    }

    .pt-xl-3,
    .py-xl-3 {
        padding-top: 1rem !important;
    }

    .pr-xl-3,
    .px-xl-3 {
        padding-right: 1rem !important;
    }

    .pb-xl-3,
    .py-xl-3 {
        padding-bottom: 1rem !important;
    }

    .pl-xl-3,
    .px-xl-3 {
        padding-left: 1rem !important;
    }

    .p-xl-4 {
        padding: 1.5rem !important;
    }

    .pt-xl-4,
    .py-xl-4 {
        padding-top: 1.5rem !important;
    }

    .pr-xl-4,
    .px-xl-4 {
        padding-right: 1.5rem !important;
    }

    .pb-xl-4,
    .py-xl-4 {
        padding-bottom: 1.5rem !important;
    }

    .pl-xl-4,
    .px-xl-4 {
        padding-left: 1.5rem !important;
    }

    .p-xl-5 {
        padding: 3rem !important;
    }

    .pt-xl-5,
    .py-xl-5 {
        padding-top: 3rem !important;
    }

    .pr-xl-5,
    .px-xl-5 {
        padding-right: 3rem !important;
    }

    .pb-xl-5,
    .py-xl-5 {
        padding-bottom: 3rem !important;
    }

    .pl-xl-5,
    .px-xl-5 {
        padding-left: 3rem !important;
    }

    .m-xl-auto {
        margin: auto !important;
    }

    .mt-xl-auto,
    .my-xl-auto {
        margin-top: auto !important;
    }

    .mr-xl-auto,
    .mx-xl-auto {
        margin-right: auto !important;
    }

    .mb-xl-auto,
    .my-xl-auto {
        margin-bottom: auto !important;
    }

    .ml-xl-auto,
    .mx-xl-auto {
        margin-left: auto !important;
    }
}

.text-justify {
    text-align: justify !important;
}

.text-nowrap {
    white-space: nowrap !important;
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text-left {
    text-align: left !important;
}

.text-right {
    text-align: right !important;
}

.text-center {
    text-align: center !important;
}

@media (min-width: 576px) {
    .text-sm-left {
        text-align: left !important;
    }

    .text-sm-right {
        text-align: right !important;
    }

    .text-sm-center {
        text-align: center !important;
    }
}

@media (min-width: 768px) {
    .text-md-left {
        text-align: left !important;
    }

    .text-md-right {
        text-align: right !important;
    }

    .text-md-center {
        text-align: center !important;
    }
}

@media (min-width: 992px) {
    .text-lg-left {
        text-align: left !important;
    }

    .text-lg-right {
        text-align: right !important;
    }

    .text-lg-center {
        text-align: center !important;
    }
}

@media (min-width: 1200px) {
    .text-xl-left {
        text-align: left !important;
    }

    .text-xl-right {
        text-align: right !important;
    }

    .text-xl-center {
        text-align: center !important;
    }
}

.text-lowercase {
    text-transform: lowercase !important;
}

.text-uppercase {
    text-transform: uppercase !important;
}

.text-capitalize {
    text-transform: capitalize !important;
}

.font-weight-light {
    font-weight: 300 !important;
}

.font-weight-normal {
    font-weight: 400 !important;
}

.font-weight-bold {
    font-weight: 700 !important;
}

.font-italic {
    font-style: italic !important;
}

.text-white {
    color: #fff !important;
}

.text-primary {
    color: #007bff !important;
}

a.text-primary:hover, a.text-primary:focus {
    color: #0062cc !important;
}

.text-secondary {
    color: #6c757d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
    color: #545b62 !important;
}

.text-success {
    color: #28a745 !important;
}

a.text-success:hover, a.text-success:focus {
    color: #1e7e34 !important;
}

.text-info {
    color: #17a2b8 !important;
}

a.text-info:hover, a.text-info:focus {
    color: #117a8b !important;
}

.text-warning {
    color: #ffc107 !important;
}

a.text-warning:hover, a.text-warning:focus {
    color: #d39e00 !important;
}

.text-danger {
    color: #dc3545 !important;
}

a.text-danger:hover, a.text-danger:focus {
    color: #bd2130 !important;
}

.text-light {
    color: #f8f9fa !important;
}

a.text-light:hover, a.text-light:focus {
    color: #dae0e5 !important;
}

.text-dark {
    color: #343a40 !important;
}

a.text-dark:hover, a.text-dark:focus {
    color: #1d2124 !important;
}

.text-muted {
    color: #6c757d !important;
}

.text-hide {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.visible {
    visibility: visible !important;
}

.invisible {
    visibility: hidden !important;
}

@media print {
    *,
    *::before,
    *::after {
        text-shadow: none !important;
        box-shadow: none !important;
    }

    a:not(.btn) {
        text-decoration: underline;
    }

    abbr[title]::after {
        content: " (" attr(title) ")";
    }

    pre {
        white-space: pre-wrap !important;
    }

    pre,
    blockquote {
        border: 1px solid #999;
        page-break-inside: avoid;
    }

    thead {
        display: table-header-group;
    }

    tr,
    img {
        page-break-inside: avoid;
    }

    p,
    h2,
    h3 {
        orphans: 3;
        widows: 3;
    }

    h2,
    h3 {
        page-break-after: avoid;
    }

    @page {
        size: a3;
    }

    body {
        min-width: 992px !important;
    }

    .container {
        min-width: 992px !important;
    }

    .navbar {
        display: none;
    }

    .badge {
        border: 1px solid #000;
    }

    .table {
        border-collapse: collapse !important;
    }

    .table td,
    .table th {
        background-color: #fff !important;
    }

    .table-bordered th,
    .table-bordered td {
        border: 1px solid #ddd !important;
    }
}

.rtl {
    direction: rtl;
    text-align: right;
}

.rtl .nav {
    padding-right: 0;
}

.rtl .navbar-nav .nav-item {
    float: right;
}

.rtl .navbar-nav .nav-item + .nav-item {
    margin-right: 1rem;
    margin-left: inherit;
}

.rtl .alert-dismissible {
    padding-right: 1.25rem;
    padding-left: 4rem;
}

.rtl .dropdown-menu {
    text-align: right;
}

.rtl .checkbox label {
    padding-right: 1.25rem;
    padding-left: inherit;
}

.rtl .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-radius: 0 .2rem .2rem 0;
}

.rtl .btn-group > .btn:last-child:not(:first-child),
.rtl .btn-group > .dropdown-toggle:not(:first-child) {
    border-radius: .2rem 0 0 .2rem;
}

.rtl .btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {
    border-radius: .2rem 0 0 .2rem;
}

.rtl .custom-control-label::after,
.rtl .custom-control-label::before {
    right: 0;
    left: inherit;
}

.rtl .custom-select {
    padding: 0.375rem 0.75rem 0.375rem 1.75rem;
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat left 0.75rem center;
    background-size: 8px 10px;
}

.rtl .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.rtl .input-group > .input-group-append:last-child > .input-group-text:not(:last-child),
.rtl .input-group > .input-group-append:not(:last-child) > .btn,
.rtl .input-group > .input-group-append:not(:last-child) > .input-group-text,
.rtl .input-group > .input-group-prepend > .btn,
.rtl .input-group > .input-group-prepend > .input-group-text {
    border-radius: 0 .2rem .2rem 0;
}

.rtl .input-group > .input-group-append > .btn,
.rtl .input-group > .input-group-append > .input-group-text,
.rtl .input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.rtl .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child),
.rtl .input-group > .input-group-prepend:not(:first-child) > .btn,
.rtl .input-group > .input-group-prepend:not(:first-child) > .input-group-text {
    border-radius: .2rem 0 0 .2rem;
}

.rtl .custom-control {
    padding-right: 1.5rem;
    padding-left: inherit;
    margin-right: inherit;
    margin-left: 1rem;
}

.rtl .custom-control-indicator {
    right: 0;
    left: inherit;
}

.rtl .custom-file-label::after {
    right: initial;
    left: -1px;
    border-radius: .25rem 0 0 .25rem;
}

.rtl .radio input,
.rtl .radio-inline,
.rtl .checkbox input,
.rtl .checkbox-inline input {
    margin-right: -1.25rem;
    margin-left: inherit;
}

.rtl .list-group {
    padding-right: 0;
    padding-left: 40px;
}

.rtl .close {
    float: left;
}

.rtl .modal-header .close {
    margin: -15px auto -15px -15px;
}

.rtl .modal-footer > :not(:first-child) {
    margin-right: .25rem;
}

.rtl .alert-dismissible .close {
    right: inherit;
    left: 0;
}

.rtl .dropdown-toggle::after {
    margin-right: .255em;
    margin-left: 0;
}

.rtl .form-check-input {
    margin-right: -1.25rem;
    margin-left: inherit;
}

.rtl .form-check-label {
    padding-right: 1.25rem;
    padding-left: inherit;
}

.rtl .col-xs-1,
.rtl .col-xs-10,
.rtl .col-xs-11,
.rtl .col-xs-12,
.rtl .col-xs-2,
.rtl .col-xs-3,
.rtl .col-xs-4,
.rtl .col-xs-5,
.rtl .col-xs-6,
.rtl .col-xs-7,
.rtl .col-xs-8,
.rtl .col-xs-9 {
    float: right;
}

.rtl .push-xs-1 {
    right: 8.333333%;
}

.rtl .push-xs-2 {
    right: 16.666667%;
}

.rtl .push-xs-3 {
    right: 25%;
}

.rtl .push-xs-4 {
    right: 33.333333%;
}

.rtl .push-xs-5 {
    right: 41.666667%;
}

.rtl .push-xs-6 {
    right: 50%;
}

.rtl .push-xs-7 {
    right: 58.333333%;
}

.rtl .push-xs-8 {
    right: 66.666667%;
}

.rtl .push-xs-9 {
    right: 75%;
}

.rtl .push-xs-10 {
    right: 83.333333%;
}

.rtl .push-xs-11 {
    right: 91.666667%;
}

.rtl .push-xs-12 {
    right: 100%;
}

.rtl .offset-xs-0 {
    margin-right: 0%;
}

.rtl .offset-xs-1 {
    margin-right: 8.333333%;
}

.rtl .offset-xs-2 {
    margin-right: 16.666667%;
}

.rtl .offset-xs-3 {
    margin-right: 25%;
}

.rtl .offset-xs-4 {
    margin-right: 33.333333%;
}

.rtl .offset-xs-5 {
    margin-right: 41.666667%;
}

.rtl .offset-xs-6 {
    margin-right: 50%;
}

.rtl .offset-xs-7 {
    margin-right: 58.333333%;
}

.rtl .offset-xs-8 {
    margin-right: 66.666667%;
}

.rtl .offset-xs-9 {
    margin-right: 75%;
}

.rtl .offset-xs-10 {
    margin-right: 83.333333%;
}

.rtl .offset-xs-11 {
    margin-right: 91.666667%;
}

.rtl .offset-xs-12 {
    margin-right: 100%;
}

@media (min-width: 544px) {
    .rtl .col-sm-1,
    .rtl .col-sm-2,
    .rtl .col-sm-3,
    .rtl .col-sm-4,
    .rtl .col-sm-5,
    .rtl .col-sm-6,
    .rtl .col-sm-7,
    .rtl .col-sm-8,
    .rtl .col-sm-9,
    .rtl .col-sm-10,
    .rtl .col-sm-11,
    .rtl .col-sm-12 {
        float: right;
    }

    .rtl .offset-sm-0 {
        margin-right: 0%;
    }

    .rtl .offset-sm-1 {
        margin-right: 8.333333%;
    }

    .rtl .offset-sm-2 {
        margin-right: 16.666667%;
    }

    .rtl .offset-sm-3 {
        margin-right: 25%;
    }

    .rtl .offset-sm-4 {
        margin-right: 33.333333%;
    }

    .rtl .offset-sm-5 {
        margin-right: 41.666667%;
    }

    .rtl .offset-sm-6 {
        margin-right: 50%;
    }

    .rtl .offset-sm-7 {
        margin-right: 58.333333%;
    }

    .rtl .offset-sm-8 {
        margin-right: 66.666667%;
    }

    .rtl .offset-sm-9 {
        margin-right: 75%;
    }

    .rtl .offset-sm-10 {
        margin-right: 83.333333%;
    }

    .rtl .offset-sm-11 {
        margin-right: 91.666667%;
    }

    .rtl .offset-sm-12 {
        margin-right: 100%;
    }
}

@media (min-width: 768px) {
    .rtl .col-md-1,
    .rtl .col-md-10,
    .rtl .col-md-11,
    .rtl .col-md-12,
    .rtl .col-md-2,
    .rtl .col-md-3,
    .rtl .col-md-4,
    .rtl .col-md-5,
    .rtl .col-md-6,
    .rtl .col-md-7,
    .rtl .col-md-8,
    .rtl .col-md-9 {
        float: right;
    }

    .rtl .offset-md-0 {
        margin-right: 0%;
    }

    .rtl .offset-md-1 {
        margin-right: 8.333333%;
    }

    .rtl .offset-md-2 {
        margin-right: 16.666667%;
    }

    .rtl .offset-md-3 {
        margin-right: 25%;
    }

    .rtl .offset-md-4 {
        margin-right: 33.333333%;
    }

    .rtl .offset-md-5 {
        margin-right: 41.666667%;
    }

    .rtl .offset-md-6 {
        margin-right: 50%;
    }

    .rtl .offset-md-7 {
        margin-right: 58.333333%;
    }

    .rtl .offset-md-8 {
        margin-right: 66.666667%;
    }

    .rtl .offset-md-9 {
        margin-right: 75%;
    }

    .rtl .offset-md-10 {
        margin-right: 83.333333%;
    }

    .rtl .offset-md-11 {
        margin-right: 91.666667%;
    }

    .rtl .offset-md-12 {
        margin-right: 100%;
    }
}

@media (min-width: 992px) {
    .rtl .col-lg-1,
    .rtl .col-lg-2,
    .rtl .col-lg-3,
    .rtl .col-lg-4,
    .rtl .col-lg-5,
    .rtl .col-lg-6,
    .rtl .col-lg-7,
    .rtl .col-lg-8,
    .rtl .col-lg-9,
    .rtl .col-lg-10,
    .rtl .col-lg-11,
    .rtl .col-lg-12 {
        float: right;
    }

    .rtl .offset-lg-0 {
        margin-right: 0%;
    }

    .rtl .offset-lg-1 {
        margin-right: 8.333333%;
    }

    .rtl .offset-lg-2 {
        margin-right: 16.666667%;
    }

    .rtl .offset-lg-3 {
        margin-right: 25%;
    }

    .rtl .offset-lg-4 {
        margin-right: 33.333333%;
    }

    .rtl .offset-lg-5 {
        margin-right: 41.666667%;
    }

    .rtl .offset-lg-6 {
        margin-right: 50%;
    }

    .rtl .offset-lg-7 {
        margin-right: 58.333333%;
    }

    .rtl .offset-lg-8 {
        margin-right: 66.666667%;
    }

    .rtl .offset-lg-9 {
        margin-right: 75%;
    }

    .rtl .offset-lg-10 {
        margin-right: 83.333333%;
    }

    .rtl .offset-lg-11 {
        margin-right: 91.666667%;
    }

    .rtl .offset-lg-12 {
        margin-right: 100%;
    }
}

@media (min-width: 1200px) {
    .rtl .col-xl-1,
    .rtl .col-xl-2,
    .rtl .col-xl-3,
    .rtl .col-xl-4,
    .rtl .col-xl-5,
    .rtl .col-xl-6,
    .rtl .col-xl-7,
    .rtl .col-xl-8,
    .rtl .col-xl-9,
    .rtl .col-xl-10,
    .rtl .col-xl-11,
    .rtl .col-xl-12 {
        float: right;
    }

    .rtl .offset-xl-0 {
        margin-right: 0%;
    }

    .rtl .offset-xl-1 {
        margin-right: 8.333333%;
    }

    .rtl .offset-xl-2 {
        margin-right: 16.666667%;
    }

    .rtl .offset-xl-3 {
        margin-right: 25%;
    }

    .rtl .offset-xl-4 {
        margin-right: 33.333333%;
    }

    .rtl .offset-xl-5 {
        margin-right: 41.666667%;
    }

    .rtl .offset-xl-6 {
        margin-right: 50%;
    }

    .rtl .offset-xl-7 {
        margin-right: 58.333333%;
    }

    .rtl .offset-xl-8 {
        margin-right: 66.666667%;
    }

    .rtl .offset-xl-9 {
        margin-right: 75%;
    }

    .rtl .offset-xl-10 {
        margin-right: 83.333333%;
    }

    .rtl .offset-xl-11 {
        margin-right: 91.666667%;
    }

    .rtl .offset-xl-12 {
        margin-right: 100%;
    }
}

/*# sourceMappingURL=bootstrap-rtl.css.map */`, "",{"version":3,"sources":["webpack://./src/assets/vendors/bootstrap-rtl.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,8KAA8K;IAC9K,6GAA6G;AACjH;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iKAAiK;IACjK,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,yCAAyC;IACzC,iCAAiC;IACjC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;IAII,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;;;;IAII,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;;;;IAII,0BAA0B;AAC9B;;AAEA;;;;IAII,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,sBAAsB;IACtB,UAAU;AACd;;AAEA;;;;IAII,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,wCAAwC;AAC5C;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;;;;IAII,iGAAiG;AACrG;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;;;IAMI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,QAAQ;AACZ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,0BAA0B;QAC1B,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,4BAA4B;QAC5B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,iBAAiB;QACjB,QAAQ;IACZ;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;QACjC,4CAA4C;IAChD;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;QACjC,4CAA4C;IAChD;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;QACjC,4CAA4C;IAChD;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;QAChB,iCAAiC;QACjC,4CAA4C;IAChD;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;IACjC,4CAA4C;AAChD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE;AAC5E;;AAEA;IACI,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;;IAEI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;;;;;;;IASI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;;;IAKI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;;;;IAKI,6BAA6B;AACjC;;AAEA;;;;;IAKI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;;;;IAKI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;;;;;;;;IAQI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;;;;;;;;IAQI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,wBAAwB;QACxB,qBAAqB;QACrB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,cAAc;QACd,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;QACnB,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,wBAAwB;QACxB,qBAAqB;QACrB,uBAAuB;QACvB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;QACtB,mBAAmB;QACnB,wBAAwB;QACxB,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qIAAqI;AACzI;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,qCAAqC;IACrC,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,0BAA0B;IAC1B,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,mCAAmC;IACnC,sCAAsC;IACtC,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,mCAAmC;IACnC,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;;;;;;;IAQI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;AACf;;AAEA;;;;IAII,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;;;IAII,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;;;IAGI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;;;;;;;IASI,iBAAiB;AACrB;;AAEA;;IAEI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;;IAEI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;;;;;;;IAQI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;;;;IAMI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;;;;;IAMI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAA0N;AAC9N;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAAuK;AAC3K;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAAoK;AACxK;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,2BAA2B;IAC3B,0CAA0C;IAC1C,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,uFAAsN;IACtN,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kFAAkF;AACtF;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,cAAc;IACd,2CAA2C;IAC3C,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;;IAEI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,yBAAyB;QACzB,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;QACpB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;;QAEI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;QACxB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,yBAAyB;QACzB,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;QACpB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;;QAEI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;QACxB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,yBAAyB;QACzB,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;QACpB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;;QAEI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;QACxB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,yBAAyB;QACzB,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;QACpB,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;IACxB;;IAEA;;QAEI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;QACxB,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;;IAEI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yDAAqQ;AACzQ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;;IAII,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,yDAA2Q;AAC/Q;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;QACpB,oBAAoB;QACpB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,4BAA4B;QAC5B,6BAA6B;QAC7B,0BAA0B;QAC1B,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;IAChC;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,+BAA+B;QAC/B,gCAAgC;IACpC;;IAEA;;QAEI,mCAAmC;QACnC,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;;QAII,gBAAgB;IACpB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,uBAAuB;QACvB,oBAAoB;QACpB,eAAe;QACf,2BAA2B;QAC3B,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,WAAW;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,qMAAqM;IACrM,0BAA0B;AAC9B;;AAEA;IACI,0DAA0D;IAC1D,kDAAkD;AACtD;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,OAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,2CAA2C;IAC3C,mCAAmC;IACnC,oEAAoE;IACpE,qCAAqC;IACrC,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,SAAS;IACT,iKAAiK;IACjK,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,MAAM;IACN,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,QAAQ;IACR,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;IACT,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iKAAiK;IACjK,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,OAAO;IACP,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,MAAM;IACN,wCAAwC;AAC5C;;AAEA;IACI,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,QAAQ;IACR,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gCAAgC;IAChC,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,uCAAuC;IACvC,+BAA+B;IAC/B,4DAA4D;IAC5D,mCAAmC;IACnC,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;AACV;;AAEA;;IAEI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI;;QAEI,uCAAuC;QACvC,+BAA+B;IACnC;AACJ;;AAEA;;IAEI,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI;;QAEI,0CAA0C;QAC1C,kCAAkC;IACtC;AACJ;;AAEA;;IAEI,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI;;QAEI,2CAA2C;QAC3C,mCAAmC;IACvC;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,yDAAgN;AACpN;;AAEA;IACI,yDAAgN;AACpN;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,OAAO;IACP,WAAW;IACX,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;IACI,0CAA0C;IAC1C,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,sCAAsC;IACtC,sCAAsC;IACtC,+BAA+B;AACnC;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;IAC5B;;IAEA;QACI,sCAAsC;QACtC,sCAAsC;QACtC,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;IAC5B;;IAEA;QACI,sCAAsC;QACtC,sCAAsC;QACtC,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;IAC5B;;IAEA;QACI,sCAAsC;QACtC,sCAAsC;QACtC,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;IAC5B;;IAEA;QACI,sCAAsC;QACtC,sCAAsC;QACtC,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;QAC/B,+BAA+B;QAC/B,wBAAwB;IAC5B;;IAEA;QACI,sCAAsC;QACtC,sCAAsC;QACtC,+BAA+B;IACnC;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;;;;;IAKI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;IACzC,wCAAwC;IACxC,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;IACxC,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,yCAAyC;IACzC,yCAAyC;IACzC,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;IACtC,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI;QACI,yCAAyC;QACzC,wCAAwC;QACxC,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,yCAAyC;QACzC,yCAAyC;QACzC,0CAA0C;QAC1C,sCAAsC;IAC1C;;IAEA;QACI,uCAAuC;QACvC,yCAAyC;QACzC,6CAA6C;QAC7C,yCAAyC;IAC7C;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;QAChC,4BAA4B;IAChC;;IAEA;QACI,sCAAsC;QACtC,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,+BAA+B;QAC/B,sCAAsC;IAC1C;;IAEA;QACI,gCAAgC;QAChC,6BAA6B;QAC7B,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,yCAAyC;IAC7C;;IAEA;QACI,oCAAoC;QACpC,wCAAwC;IAC5C;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,sCAAsC;QACtC,mCAAmC;QACnC,gCAAgC;IACpC;;IAEA;QACI,qCAAqC;QACrC,kCAAkC;QAClC,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;QACpC,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;QAClC,kCAAkC;IACtC;;IAEA;QACI,qCAAqC;QACrC,gCAAgC;IACpC;;IAEA;QACI,sCAAsC;QACtC,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;QACtC,iCAAiC;IACrC;;IAEA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;;IAEA;QACI,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,mCAAmC;QACnC,+BAA+B;IACnC;;IAEA;QACI,sCAAsC;QACtC,6BAA6B;IACjC;;IAEA;QACI,wCAAwC;QACxC,+BAA+B;IACnC;;IAEA;QACI,uCAAuC;QACvC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,yCAAyC;QACzC,wCAAwC;QACxC,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,yCAAyC;QACzC,yCAAyC;QACzC,0CAA0C;QAC1C,sCAAsC;IAC1C;;IAEA;QACI,uCAAuC;QACvC,yCAAyC;QACzC,6CAA6C;QAC7C,yCAAyC;IAC7C;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;QAChC,4BAA4B;IAChC;;IAEA;QACI,sCAAsC;QACtC,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,+BAA+B;QAC/B,sCAAsC;IAC1C;;IAEA;QACI,gCAAgC;QAChC,6BAA6B;QAC7B,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,yCAAyC;IAC7C;;IAEA;QACI,oCAAoC;QACpC,wCAAwC;IAC5C;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,sCAAsC;QACtC,mCAAmC;QACnC,gCAAgC;IACpC;;IAEA;QACI,qCAAqC;QACrC,kCAAkC;QAClC,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;QACpC,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;QAClC,kCAAkC;IACtC;;IAEA;QACI,qCAAqC;QACrC,gCAAgC;IACpC;;IAEA;QACI,sCAAsC;QACtC,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;QACtC,iCAAiC;IACrC;;IAEA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;;IAEA;QACI,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,mCAAmC;QACnC,+BAA+B;IACnC;;IAEA;QACI,sCAAsC;QACtC,6BAA6B;IACjC;;IAEA;QACI,wCAAwC;QACxC,+BAA+B;IACnC;;IAEA;QACI,uCAAuC;QACvC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,yCAAyC;QACzC,wCAAwC;QACxC,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,yCAAyC;QACzC,yCAAyC;QACzC,0CAA0C;QAC1C,sCAAsC;IAC1C;;IAEA;QACI,uCAAuC;QACvC,yCAAyC;QACzC,6CAA6C;QAC7C,yCAAyC;IAC7C;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;QAChC,4BAA4B;IAChC;;IAEA;QACI,sCAAsC;QACtC,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,+BAA+B;QAC/B,sCAAsC;IAC1C;;IAEA;QACI,gCAAgC;QAChC,6BAA6B;QAC7B,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,yCAAyC;IAC7C;;IAEA;QACI,oCAAoC;QACpC,wCAAwC;IAC5C;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,sCAAsC;QACtC,mCAAmC;QACnC,gCAAgC;IACpC;;IAEA;QACI,qCAAqC;QACrC,kCAAkC;QAClC,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;QACpC,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;QAClC,kCAAkC;IACtC;;IAEA;QACI,qCAAqC;QACrC,gCAAgC;IACpC;;IAEA;QACI,sCAAsC;QACtC,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;QACtC,iCAAiC;IACrC;;IAEA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;;IAEA;QACI,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,mCAAmC;QACnC,+BAA+B;IACnC;;IAEA;QACI,sCAAsC;QACtC,6BAA6B;IACjC;;IAEA;QACI,wCAAwC;QACxC,+BAA+B;IACnC;;IAEA;QACI,uCAAuC;QACvC,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,yCAAyC;QACzC,wCAAwC;QACxC,kCAAkC;QAClC,8BAA8B;IAClC;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;QACxC,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,yCAAyC;QACzC,yCAAyC;QACzC,0CAA0C;QAC1C,sCAAsC;IAC1C;;IAEA;QACI,uCAAuC;QACvC,yCAAyC;QACzC,6CAA6C;QAC7C,yCAAyC;IAC7C;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,gCAAgC;QAChC,4BAA4B;IAChC;;IAEA;QACI,sCAAsC;QACtC,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,+BAA+B;QAC/B,sCAAsC;IAC1C;;IAEA;QACI,gCAAgC;QAChC,6BAA6B;QAC7B,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,yCAAyC;IAC7C;;IAEA;QACI,oCAAoC;QACpC,wCAAwC;IAC5C;;IAEA;QACI,mCAAmC;QACnC,gCAAgC;QAChC,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;QAC9B,gCAAgC;IACpC;;IAEA;QACI,oCAAoC;QACpC,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,sCAAsC;QACtC,mCAAmC;QACnC,gCAAgC;IACpC;;IAEA;QACI,qCAAqC;QACrC,kCAAkC;QAClC,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;QACpC,oCAAoC;IACxC;;IAEA;QACI,kCAAkC;QAClC,kCAAkC;IACtC;;IAEA;QACI,qCAAqC;QACrC,gCAAgC;IACpC;;IAEA;QACI,sCAAsC;QACtC,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;QACzC,sCAAsC;IAC1C;;IAEA;QACI,sCAAsC;QACtC,iCAAiC;IACrC;;IAEA;QACI,oCAAoC;QACpC,2BAA2B;IAC/B;;IAEA;QACI,qCAAqC;QACrC,iCAAiC;IACrC;;IAEA;QACI,mCAAmC;QACnC,+BAA+B;IACnC;;IAEA;QACI,sCAAsC;QACtC,6BAA6B;IACjC;;IAEA;QACI,wCAAwC;QACxC,+BAA+B;IACnC;;IAEA;QACI,uCAAuC;QACvC,8BAA8B;IAClC;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;AACjB;;AAEA;IACI;QACI,wBAAwB;QACxB,gBAAgB;QAChB,MAAM;QACN,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,yBAAyB;IAC7B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,kCAAkC;IACtC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,gCAAgC;IACpC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,+BAA+B;IACnC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,4BAA4B;IAChC;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;;;QAGI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;;;QAGI,UAAU;QACV,SAAS;IACb;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;;QAEI,iCAAiC;IACrC;;IAEA;;QAEI,iCAAiC;IACrC;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,sFAAqN;IACrN,yBAAyB;AAC7B;;AAEA;;;;;;IAMI,8BAA8B;AAClC;;AAEA;;;;;;IAMI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gCAAgC;AACpC;;AAEA;;;;IAII,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,OAAO;AACX;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;;;;;;;;;;;IAYI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;;;;;;;;;;;;QAYI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;;;;;;;;;;;;QAYI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,4CAA4C","sourcesContent":["/*!\n * Bootstrap v4.0.0 (https://getbootstrap.com)\n * Copyright 2011-2018 The Bootstrap Authors\n * Copyright 2011-2018 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n:root {\n    --blue: #007bff;\n    --indigo: #6610f2;\n    --purple: #6f42c1;\n    --pink: #e83e8c;\n    --red: #dc3545;\n    --orange: #fd7e14;\n    --yellow: #ffc107;\n    --green: #28a745;\n    --teal: #20c997;\n    --cyan: #17a2b8;\n    --white: #fff;\n    --gray: #6c757d;\n    --gray-dark: #343a40;\n    --primary: #007bff;\n    --secondary: #6c757d;\n    --success: #28a745;\n    --info: #17a2b8;\n    --warning: #ffc107;\n    --danger: #dc3545;\n    --light: #f8f9fa;\n    --dark: #343a40;\n    --breakpoint-xs: 0;\n    --breakpoint-sm: 576px;\n    --breakpoint-md: 768px;\n    --breakpoint-lg: 992px;\n    --breakpoint-xl: 1200px;\n    --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\nhtml {\n    font-family: sans-serif;\n    line-height: 1.15;\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    -ms-overflow-style: scrollbar;\n    -webkit-tap-highlight-color: transparent;\n}\n\n@-ms-viewport {\n    width: device-width;\n}\n\narticle, aside, dialog, figcaption, figure, footer, header, hgroup, main, nav, section {\n    display: block;\n}\n\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #212529;\n    text-align: left;\n    background-color: #fff;\n}\n\n[tabindex=\"-1\"]:focus {\n    outline: 0 !important;\n}\n\nhr {\n    box-sizing: content-box;\n    height: 0;\n    overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n    text-decoration: underline;\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    border-bottom: 0;\n}\n\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit;\n}\n\nol,\nul,\ndl {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n    margin-bottom: 0;\n}\n\ndt {\n    font-weight: 700;\n}\n\ndd {\n    margin-bottom: .5rem;\n    margin-left: 0;\n}\n\nblockquote {\n    margin: 0 0 1rem;\n}\n\ndfn {\n    font-style: italic;\n}\n\nb,\nstrong {\n    font-weight: bolder;\n}\n\nsmall {\n    font-size: 80%;\n}\n\nsub,\nsup {\n    position: relative;\n    font-size: 75%;\n    line-height: 0;\n    vertical-align: baseline;\n}\n\nsub {\n    bottom: -.25em;\n}\n\nsup {\n    top: -.5em;\n}\n\na {\n    color: #007bff;\n    text-decoration: none;\n    background-color: transparent;\n    -webkit-text-decoration-skip: objects;\n}\n\na:hover {\n    color: #0056b3;\n    text-decoration: underline;\n}\n\na:not([href]):not([tabindex]) {\n    color: inherit;\n    text-decoration: none;\n}\n\na:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {\n    color: inherit;\n    text-decoration: none;\n}\n\na:not([href]):not([tabindex]):focus {\n    outline: 0;\n}\n\npre,\ncode,\nkbd,\nsamp {\n    font-family: monospace, monospace;\n    font-size: 1em;\n}\n\npre {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    -ms-overflow-style: scrollbar;\n}\n\nfigure {\n    margin: 0 0 1rem;\n}\n\nimg {\n    vertical-align: middle;\n    border-style: none;\n}\n\nsvg:not(:root) {\n    overflow: hidden;\n}\n\ntable {\n    border-collapse: collapse;\n}\n\ncaption {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n    color: #6c757d;\n    text-align: left;\n    caption-side: bottom;\n}\n\nth {\n    text-align: inherit;\n}\n\nlabel {\n    display: inline-block;\n    margin-bottom: .5rem;\n}\n\nbutton {\n    border-radius: 0;\n}\n\nbutton:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n}\n\nbutton,\ninput {\n    overflow: visible;\n}\n\nbutton,\nselect {\n    text-transform: none;\n}\n\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n    -webkit-appearance: button;\n}\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n    box-sizing: border-box;\n    padding: 0;\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n    -webkit-appearance: listbox;\n}\n\ntextarea {\n    overflow: auto;\n    resize: vertical;\n}\n\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0;\n}\n\nlegend {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin-bottom: .5rem;\n    font-size: 1.5rem;\n    line-height: inherit;\n    color: inherit;\n    white-space: normal;\n}\n\nprogress {\n    vertical-align: baseline;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n}\n\n[type=\"search\"] {\n    outline-offset: -2px;\n    -webkit-appearance: none;\n}\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button;\n}\n\noutput {\n    display: inline-block;\n}\n\nsummary {\n    display: list-item;\n    cursor: pointer;\n}\n\ntemplate {\n    display: none;\n}\n\n[hidden] {\n    display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n    margin-bottom: 0.5rem;\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.2;\n    color: inherit;\n}\n\nh1, .h1 {\n    font-size: 2.5rem;\n}\n\nh2, .h2 {\n    font-size: 2rem;\n}\n\nh3, .h3 {\n    font-size: 1.75rem;\n}\n\nh4, .h4 {\n    font-size: 1.5rem;\n}\n\nh5, .h5 {\n    font-size: 1.25rem;\n}\n\nh6, .h6 {\n    font-size: 1rem;\n}\n\n.lead {\n    font-size: 1.25rem;\n    font-weight: 300;\n}\n\n.display-1 {\n    font-size: 6rem;\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n.display-2 {\n    font-size: 5.5rem;\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n.display-3 {\n    font-size: 4.5rem;\n    font-weight: 300;\n    line-height: 1.2;\n}\n\n.display-4 {\n    font-size: 3.5rem;\n    font-weight: 300;\n    line-height: 1.2;\n}\n\nhr {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n    font-size: 80%;\n    font-weight: 400;\n}\n\nmark,\n.mark {\n    padding: 0.2em;\n    background-color: #fcf8e3;\n}\n\n.list-unstyled {\n    padding-left: 0;\n    list-style: none;\n}\n\n.list-inline {\n    padding-left: 0;\n    list-style: none;\n}\n\n.list-inline-item {\n    display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n    margin-right: 0.5rem;\n}\n\n.initialism {\n    font-size: 90%;\n    text-transform: uppercase;\n}\n\n.blockquote {\n    margin-bottom: 1rem;\n    font-size: 1.25rem;\n}\n\n.blockquote-footer {\n    display: block;\n    font-size: 80%;\n    color: #6c757d;\n}\n\n.blockquote-footer::before {\n    content: \"\\2014 \\00A0\";\n}\n\n.img-fluid {\n    max-width: 100%;\n    height: auto;\n}\n\n.img-thumbnail {\n    padding: 0.25rem;\n    background-color: #fff;\n    border: 1px solid #dee2e6;\n    border-radius: 0.25rem;\n    max-width: 100%;\n    height: auto;\n}\n\n.figure {\n    display: inline-block;\n}\n\n.figure-img {\n    margin-bottom: 0.5rem;\n    line-height: 1;\n}\n\n.figure-caption {\n    font-size: 90%;\n    color: #6c757d;\n}\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\ncode {\n    font-size: 87.5%;\n    color: #e83e8c;\n    word-break: break-word;\n}\n\na > code {\n    color: inherit;\n}\n\nkbd {\n    padding: 0.2rem 0.4rem;\n    font-size: 87.5%;\n    color: #fff;\n    background-color: #212529;\n    border-radius: 0.2rem;\n}\n\nkbd kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n}\n\npre {\n    display: block;\n    font-size: 87.5%;\n    color: #212529;\n}\n\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal;\n}\n\n.pre-scrollable {\n    max-height: 340px;\n    overflow-y: scroll;\n}\n\n.container {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n@media (min-width: 576px) {\n    .container {\n        max-width: 540px;\n    }\n}\n\n@media (min-width: 768px) {\n    .container {\n        max-width: 720px;\n    }\n}\n\n@media (min-width: 992px) {\n    .container {\n        max-width: 960px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .container {\n        max-width: 1140px;\n    }\n}\n\n.container-fluid {\n    width: 100%;\n    padding-right: 15px;\n    padding-left: 15px;\n    margin-right: auto;\n    margin-left: auto;\n}\n\n.row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n}\n\n.no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n}\n\n.no-gutters > .col,\n.no-gutters > [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n    position: relative;\n    width: 100%;\n    min-height: 1px;\n    padding-right: 15px;\n    padding-left: 15px;\n}\n\n.col {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    max-width: 100%;\n}\n\n.col-auto {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n}\n\n.col-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.333333%;\n    flex: 0 0 8.333333%;\n    max-width: 8.333333%;\n}\n\n.col-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.666667%;\n    flex: 0 0 16.666667%;\n    max-width: 16.666667%;\n}\n\n.col-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n}\n\n.col-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.333333%;\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n}\n\n.col-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.666667%;\n    flex: 0 0 41.666667%;\n    max-width: 41.666667%;\n}\n\n.col-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n}\n\n.col-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.333333%;\n    flex: 0 0 58.333333%;\n    max-width: 58.333333%;\n}\n\n.col-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.666667%;\n    flex: 0 0 66.666667%;\n    max-width: 66.666667%;\n}\n\n.col-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n}\n\n.col-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.333333%;\n    flex: 0 0 83.333333%;\n    max-width: 83.333333%;\n}\n\n.col-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.666667%;\n    flex: 0 0 91.666667%;\n    max-width: 91.666667%;\n}\n\n.col-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n}\n\n.order-first {\n    -webkit-box-ordinal-group: 0;\n    -ms-flex-order: -1;\n    order: -1;\n}\n\n.order-last {\n    -webkit-box-ordinal-group: 14;\n    -ms-flex-order: 13;\n    order: 13;\n}\n\n.order-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n}\n\n.order-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n}\n\n.order-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n}\n\n.order-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n}\n\n.order-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n}\n\n.order-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n}\n\n.order-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n}\n\n.order-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n}\n\n.order-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n}\n\n.order-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n}\n\n.order-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n}\n\n.order-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n}\n\n.order-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n}\n\n.offset-1 {\n    margin-left: 8.333333%;\n}\n\n.offset-2 {\n    margin-left: 16.666667%;\n}\n\n.offset-3 {\n    margin-left: 25%;\n}\n\n.offset-4 {\n    margin-left: 33.333333%;\n}\n\n.offset-5 {\n    margin-left: 41.666667%;\n}\n\n.offset-6 {\n    margin-left: 50%;\n}\n\n.offset-7 {\n    margin-left: 58.333333%;\n}\n\n.offset-8 {\n    margin-left: 66.666667%;\n}\n\n.offset-9 {\n    margin-left: 75%;\n}\n\n.offset-10 {\n    margin-left: 83.333333%;\n}\n\n.offset-11 {\n    margin-left: 91.666667%;\n}\n\n@media (min-width: 576px) {\n    .col-sm {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-sm-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: none;\n    }\n\n    .col-sm-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.333333%;\n        flex: 0 0 8.333333%;\n        max-width: 8.333333%;\n    }\n\n    .col-sm-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.666667%;\n        flex: 0 0 16.666667%;\n        max-width: 16.666667%;\n    }\n\n    .col-sm-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-sm-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.333333%;\n        flex: 0 0 33.333333%;\n        max-width: 33.333333%;\n    }\n\n    .col-sm-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.666667%;\n        flex: 0 0 41.666667%;\n        max-width: 41.666667%;\n    }\n\n    .col-sm-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-sm-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.333333%;\n        flex: 0 0 58.333333%;\n        max-width: 58.333333%;\n    }\n\n    .col-sm-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.666667%;\n        flex: 0 0 66.666667%;\n        max-width: 66.666667%;\n    }\n\n    .col-sm-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-sm-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.333333%;\n        flex: 0 0 83.333333%;\n        max-width: 83.333333%;\n    }\n\n    .col-sm-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.666667%;\n        flex: 0 0 91.666667%;\n        max-width: 91.666667%;\n    }\n\n    .col-sm-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n    .order-sm-first {\n        -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n        order: -1;\n    }\n\n    .order-sm-last {\n        -webkit-box-ordinal-group: 14;\n        -ms-flex-order: 13;\n        order: 13;\n    }\n\n    .order-sm-0 {\n        -webkit-box-ordinal-group: 1;\n        -ms-flex-order: 0;\n        order: 0;\n    }\n\n    .order-sm-1 {\n        -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n        order: 1;\n    }\n\n    .order-sm-2 {\n        -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n        order: 2;\n    }\n\n    .order-sm-3 {\n        -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n        order: 3;\n    }\n\n    .order-sm-4 {\n        -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n        order: 4;\n    }\n\n    .order-sm-5 {\n        -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n        order: 5;\n    }\n\n    .order-sm-6 {\n        -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n        order: 6;\n    }\n\n    .order-sm-7 {\n        -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n        order: 7;\n    }\n\n    .order-sm-8 {\n        -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n        order: 8;\n    }\n\n    .order-sm-9 {\n        -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n        order: 9;\n    }\n\n    .order-sm-10 {\n        -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n        order: 10;\n    }\n\n    .order-sm-11 {\n        -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n        order: 11;\n    }\n\n    .order-sm-12 {\n        -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n        order: 12;\n    }\n\n    .offset-sm-0 {\n        margin-left: 0;\n    }\n\n    .offset-sm-1 {\n        margin-left: 8.333333%;\n    }\n\n    .offset-sm-2 {\n        margin-left: 16.666667%;\n    }\n\n    .offset-sm-3 {\n        margin-left: 25%;\n    }\n\n    .offset-sm-4 {\n        margin-left: 33.333333%;\n    }\n\n    .offset-sm-5 {\n        margin-left: 41.666667%;\n    }\n\n    .offset-sm-6 {\n        margin-left: 50%;\n    }\n\n    .offset-sm-7 {\n        margin-left: 58.333333%;\n    }\n\n    .offset-sm-8 {\n        margin-left: 66.666667%;\n    }\n\n    .offset-sm-9 {\n        margin-left: 75%;\n    }\n\n    .offset-sm-10 {\n        margin-left: 83.333333%;\n    }\n\n    .offset-sm-11 {\n        margin-left: 91.666667%;\n    }\n}\n\n@media (min-width: 768px) {\n    .col-md {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-md-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: none;\n    }\n\n    .col-md-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.333333%;\n        flex: 0 0 8.333333%;\n        max-width: 8.333333%;\n    }\n\n    .col-md-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.666667%;\n        flex: 0 0 16.666667%;\n        max-width: 16.666667%;\n    }\n\n    .col-md-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-md-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.333333%;\n        flex: 0 0 33.333333%;\n        max-width: 33.333333%;\n    }\n\n    .col-md-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.666667%;\n        flex: 0 0 41.666667%;\n        max-width: 41.666667%;\n    }\n\n    .col-md-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-md-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.333333%;\n        flex: 0 0 58.333333%;\n        max-width: 58.333333%;\n    }\n\n    .col-md-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.666667%;\n        flex: 0 0 66.666667%;\n        max-width: 66.666667%;\n    }\n\n    .col-md-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-md-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.333333%;\n        flex: 0 0 83.333333%;\n        max-width: 83.333333%;\n    }\n\n    .col-md-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.666667%;\n        flex: 0 0 91.666667%;\n        max-width: 91.666667%;\n    }\n\n    .col-md-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n    .order-md-first {\n        -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n        order: -1;\n    }\n\n    .order-md-last {\n        -webkit-box-ordinal-group: 14;\n        -ms-flex-order: 13;\n        order: 13;\n    }\n\n    .order-md-0 {\n        -webkit-box-ordinal-group: 1;\n        -ms-flex-order: 0;\n        order: 0;\n    }\n\n    .order-md-1 {\n        -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n        order: 1;\n    }\n\n    .order-md-2 {\n        -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n        order: 2;\n    }\n\n    .order-md-3 {\n        -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n        order: 3;\n    }\n\n    .order-md-4 {\n        -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n        order: 4;\n    }\n\n    .order-md-5 {\n        -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n        order: 5;\n    }\n\n    .order-md-6 {\n        -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n        order: 6;\n    }\n\n    .order-md-7 {\n        -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n        order: 7;\n    }\n\n    .order-md-8 {\n        -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n        order: 8;\n    }\n\n    .order-md-9 {\n        -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n        order: 9;\n    }\n\n    .order-md-10 {\n        -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n        order: 10;\n    }\n\n    .order-md-11 {\n        -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n        order: 11;\n    }\n\n    .order-md-12 {\n        -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n        order: 12;\n    }\n\n    .offset-md-0 {\n        margin-left: 0;\n    }\n\n    .offset-md-1 {\n        margin-left: 8.333333%;\n    }\n\n    .offset-md-2 {\n        margin-left: 16.666667%;\n    }\n\n    .offset-md-3 {\n        margin-left: 25%;\n    }\n\n    .offset-md-4 {\n        margin-left: 33.333333%;\n    }\n\n    .offset-md-5 {\n        margin-left: 41.666667%;\n    }\n\n    .offset-md-6 {\n        margin-left: 50%;\n    }\n\n    .offset-md-7 {\n        margin-left: 58.333333%;\n    }\n\n    .offset-md-8 {\n        margin-left: 66.666667%;\n    }\n\n    .offset-md-9 {\n        margin-left: 75%;\n    }\n\n    .offset-md-10 {\n        margin-left: 83.333333%;\n    }\n\n    .offset-md-11 {\n        margin-left: 91.666667%;\n    }\n}\n\n@media (min-width: 992px) {\n    .col-lg {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-lg-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: none;\n    }\n\n    .col-lg-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.333333%;\n        flex: 0 0 8.333333%;\n        max-width: 8.333333%;\n    }\n\n    .col-lg-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.666667%;\n        flex: 0 0 16.666667%;\n        max-width: 16.666667%;\n    }\n\n    .col-lg-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-lg-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.333333%;\n        flex: 0 0 33.333333%;\n        max-width: 33.333333%;\n    }\n\n    .col-lg-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.666667%;\n        flex: 0 0 41.666667%;\n        max-width: 41.666667%;\n    }\n\n    .col-lg-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-lg-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.333333%;\n        flex: 0 0 58.333333%;\n        max-width: 58.333333%;\n    }\n\n    .col-lg-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.666667%;\n        flex: 0 0 66.666667%;\n        max-width: 66.666667%;\n    }\n\n    .col-lg-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-lg-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.333333%;\n        flex: 0 0 83.333333%;\n        max-width: 83.333333%;\n    }\n\n    .col-lg-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.666667%;\n        flex: 0 0 91.666667%;\n        max-width: 91.666667%;\n    }\n\n    .col-lg-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n    .order-lg-first {\n        -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n        order: -1;\n    }\n\n    .order-lg-last {\n        -webkit-box-ordinal-group: 14;\n        -ms-flex-order: 13;\n        order: 13;\n    }\n\n    .order-lg-0 {\n        -webkit-box-ordinal-group: 1;\n        -ms-flex-order: 0;\n        order: 0;\n    }\n\n    .order-lg-1 {\n        -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n        order: 1;\n    }\n\n    .order-lg-2 {\n        -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n        order: 2;\n    }\n\n    .order-lg-3 {\n        -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n        order: 3;\n    }\n\n    .order-lg-4 {\n        -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n        order: 4;\n    }\n\n    .order-lg-5 {\n        -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n        order: 5;\n    }\n\n    .order-lg-6 {\n        -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n        order: 6;\n    }\n\n    .order-lg-7 {\n        -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n        order: 7;\n    }\n\n    .order-lg-8 {\n        -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n        order: 8;\n    }\n\n    .order-lg-9 {\n        -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n        order: 9;\n    }\n\n    .order-lg-10 {\n        -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n        order: 10;\n    }\n\n    .order-lg-11 {\n        -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n        order: 11;\n    }\n\n    .order-lg-12 {\n        -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n        order: 12;\n    }\n\n    .offset-lg-0 {\n        margin-left: 0;\n    }\n\n    .offset-lg-1 {\n        margin-left: 8.333333%;\n    }\n\n    .offset-lg-2 {\n        margin-left: 16.666667%;\n    }\n\n    .offset-lg-3 {\n        margin-left: 25%;\n    }\n\n    .offset-lg-4 {\n        margin-left: 33.333333%;\n    }\n\n    .offset-lg-5 {\n        margin-left: 41.666667%;\n    }\n\n    .offset-lg-6 {\n        margin-left: 50%;\n    }\n\n    .offset-lg-7 {\n        margin-left: 58.333333%;\n    }\n\n    .offset-lg-8 {\n        margin-left: 66.666667%;\n    }\n\n    .offset-lg-9 {\n        margin-left: 75%;\n    }\n\n    .offset-lg-10 {\n        margin-left: 83.333333%;\n    }\n\n    .offset-lg-11 {\n        margin-left: 91.666667%;\n    }\n}\n\n@media (min-width: 1200px) {\n    .col-xl {\n        -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n        -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n        flex-grow: 1;\n        max-width: 100%;\n    }\n\n    .col-xl-auto {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        width: auto;\n        max-width: none;\n    }\n\n    .col-xl-1 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 8.333333%;\n        flex: 0 0 8.333333%;\n        max-width: 8.333333%;\n    }\n\n    .col-xl-2 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 16.666667%;\n        flex: 0 0 16.666667%;\n        max-width: 16.666667%;\n    }\n\n    .col-xl-3 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n    }\n\n    .col-xl-4 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 33.333333%;\n        flex: 0 0 33.333333%;\n        max-width: 33.333333%;\n    }\n\n    .col-xl-5 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 41.666667%;\n        flex: 0 0 41.666667%;\n        max-width: 41.666667%;\n    }\n\n    .col-xl-6 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n        max-width: 50%;\n    }\n\n    .col-xl-7 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 58.333333%;\n        flex: 0 0 58.333333%;\n        max-width: 58.333333%;\n    }\n\n    .col-xl-8 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 66.666667%;\n        flex: 0 0 66.666667%;\n        max-width: 66.666667%;\n    }\n\n    .col-xl-9 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n    }\n\n    .col-xl-10 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 83.333333%;\n        flex: 0 0 83.333333%;\n        max-width: 83.333333%;\n    }\n\n    .col-xl-11 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 91.666667%;\n        flex: 0 0 91.666667%;\n        max-width: 91.666667%;\n    }\n\n    .col-xl-12 {\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n\n    .order-xl-first {\n        -webkit-box-ordinal-group: 0;\n        -ms-flex-order: -1;\n        order: -1;\n    }\n\n    .order-xl-last {\n        -webkit-box-ordinal-group: 14;\n        -ms-flex-order: 13;\n        order: 13;\n    }\n\n    .order-xl-0 {\n        -webkit-box-ordinal-group: 1;\n        -ms-flex-order: 0;\n        order: 0;\n    }\n\n    .order-xl-1 {\n        -webkit-box-ordinal-group: 2;\n        -ms-flex-order: 1;\n        order: 1;\n    }\n\n    .order-xl-2 {\n        -webkit-box-ordinal-group: 3;\n        -ms-flex-order: 2;\n        order: 2;\n    }\n\n    .order-xl-3 {\n        -webkit-box-ordinal-group: 4;\n        -ms-flex-order: 3;\n        order: 3;\n    }\n\n    .order-xl-4 {\n        -webkit-box-ordinal-group: 5;\n        -ms-flex-order: 4;\n        order: 4;\n    }\n\n    .order-xl-5 {\n        -webkit-box-ordinal-group: 6;\n        -ms-flex-order: 5;\n        order: 5;\n    }\n\n    .order-xl-6 {\n        -webkit-box-ordinal-group: 7;\n        -ms-flex-order: 6;\n        order: 6;\n    }\n\n    .order-xl-7 {\n        -webkit-box-ordinal-group: 8;\n        -ms-flex-order: 7;\n        order: 7;\n    }\n\n    .order-xl-8 {\n        -webkit-box-ordinal-group: 9;\n        -ms-flex-order: 8;\n        order: 8;\n    }\n\n    .order-xl-9 {\n        -webkit-box-ordinal-group: 10;\n        -ms-flex-order: 9;\n        order: 9;\n    }\n\n    .order-xl-10 {\n        -webkit-box-ordinal-group: 11;\n        -ms-flex-order: 10;\n        order: 10;\n    }\n\n    .order-xl-11 {\n        -webkit-box-ordinal-group: 12;\n        -ms-flex-order: 11;\n        order: 11;\n    }\n\n    .order-xl-12 {\n        -webkit-box-ordinal-group: 13;\n        -ms-flex-order: 12;\n        order: 12;\n    }\n\n    .offset-xl-0 {\n        margin-left: 0;\n    }\n\n    .offset-xl-1 {\n        margin-left: 8.333333%;\n    }\n\n    .offset-xl-2 {\n        margin-left: 16.666667%;\n    }\n\n    .offset-xl-3 {\n        margin-left: 25%;\n    }\n\n    .offset-xl-4 {\n        margin-left: 33.333333%;\n    }\n\n    .offset-xl-5 {\n        margin-left: 41.666667%;\n    }\n\n    .offset-xl-6 {\n        margin-left: 50%;\n    }\n\n    .offset-xl-7 {\n        margin-left: 58.333333%;\n    }\n\n    .offset-xl-8 {\n        margin-left: 66.666667%;\n    }\n\n    .offset-xl-9 {\n        margin-left: 75%;\n    }\n\n    .offset-xl-10 {\n        margin-left: 83.333333%;\n    }\n\n    .offset-xl-11 {\n        margin-left: 91.666667%;\n    }\n}\n\n.table {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 1rem;\n    background-color: transparent;\n}\n\n.table th,\n.table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6;\n}\n\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 2px solid #dee2e6;\n}\n\n.table tbody + tbody {\n    border-top: 2px solid #dee2e6;\n}\n\n.table .table {\n    background-color: #fff;\n}\n\n.table-sm th,\n.table-sm td {\n    padding: 0.3rem;\n}\n\n.table-bordered {\n    border: 1px solid #dee2e6;\n}\n\n.table-bordered th,\n.table-bordered td {\n    border: 1px solid #dee2e6;\n}\n\n.table-bordered thead th,\n.table-bordered thead td {\n    border-bottom-width: 2px;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.table-hover tbody tr:hover {\n    background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n    background-color: #b8daff;\n}\n\n.table-hover .table-primary:hover {\n    background-color: #9fcdff;\n}\n\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n    background-color: #9fcdff;\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n    background-color: #d6d8db;\n}\n\n.table-hover .table-secondary:hover {\n    background-color: #c8cbcf;\n}\n\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n    background-color: #c8cbcf;\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n    background-color: #c3e6cb;\n}\n\n.table-hover .table-success:hover {\n    background-color: #b1dfbb;\n}\n\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n    background-color: #b1dfbb;\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n    background-color: #bee5eb;\n}\n\n.table-hover .table-info:hover {\n    background-color: #abdde5;\n}\n\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n    background-color: #abdde5;\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n    background-color: #ffeeba;\n}\n\n.table-hover .table-warning:hover {\n    background-color: #ffe8a1;\n}\n\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n    background-color: #ffe8a1;\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n    background-color: #f5c6cb;\n}\n\n.table-hover .table-danger:hover {\n    background-color: #f1b0b7;\n}\n\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n    background-color: #f1b0b7;\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n    background-color: #fdfdfe;\n}\n\n.table-hover .table-light:hover {\n    background-color: #ececf6;\n}\n\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n    background-color: #ececf6;\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n    background-color: #c6c8ca;\n}\n\n.table-hover .table-dark:hover {\n    background-color: #b9bbbe;\n}\n\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n    background-color: #b9bbbe;\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n    background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover {\n    background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n    background-color: rgba(0, 0, 0, 0.075);\n}\n\n.table .thead-dark th {\n    color: #fff;\n    background-color: #212529;\n    border-color: #32383e;\n}\n\n.table .thead-light th {\n    color: #495057;\n    background-color: #e9ecef;\n    border-color: #dee2e6;\n}\n\n.table-dark {\n    color: #fff;\n    background-color: #212529;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n    border-color: #32383e;\n}\n\n.table-dark.table-bordered {\n    border: 0;\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n\n.table-dark.table-hover tbody tr:hover {\n    background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n    .table-responsive-sm {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n    }\n\n    .table-responsive-sm > .table-bordered {\n        border: 0;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .table-responsive-md {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n    }\n\n    .table-responsive-md > .table-bordered {\n        border: 0;\n    }\n}\n\n@media (max-width: 991.98px) {\n    .table-responsive-lg {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n    }\n\n    .table-responsive-lg > .table-bordered {\n        border: 0;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .table-responsive-xl {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n    }\n\n    .table-responsive-xl > .table-bordered {\n        border: 0;\n    }\n}\n\n.table-responsive {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n\n.table-responsive > .table-bordered {\n    border: 0;\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-control::-ms-expand {\n    background-color: transparent;\n    border: 0;\n}\n\n.form-control:focus {\n    color: #495057;\n    background-color: #fff;\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.form-control::-webkit-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control::-moz-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control::-ms-input-placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control::placeholder {\n    color: #6c757d;\n    opacity: 1;\n}\n\n.form-control:disabled, .form-control[readonly] {\n    background-color: #e9ecef;\n    opacity: 1;\n}\n\nselect.form-control:not([size]):not([multiple]) {\n    height: calc(2.25rem + 2px);\n}\n\nselect.form-control:focus::-ms-value {\n    color: #495057;\n    background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n    display: block;\n    width: 100%;\n}\n\n.col-form-label {\n    padding-top: calc(0.375rem + 1px);\n    padding-bottom: calc(0.375rem + 1px);\n    margin-bottom: 0;\n    font-size: inherit;\n    line-height: 1.5;\n}\n\n.col-form-label-lg {\n    padding-top: calc(0.5rem + 1px);\n    padding-bottom: calc(0.5rem + 1px);\n    font-size: 1.25rem;\n    line-height: 1.5;\n}\n\n.col-form-label-sm {\n    padding-top: calc(0.25rem + 1px);\n    padding-bottom: calc(0.25rem + 1px);\n    font-size: 0.875rem;\n    line-height: 1.5;\n}\n\n.form-control-plaintext {\n    display: block;\n    width: 100%;\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n    margin-bottom: 0;\n    line-height: 1.5;\n    background-color: transparent;\n    border: solid transparent;\n    border-width: 1px 0;\n}\n\n.form-control-plaintext.form-control-sm, .input-group-sm > .form-control-plaintext.form-control,\n.input-group-sm > .input-group-prepend > .form-control-plaintext.input-group-text,\n.input-group-sm > .input-group-append > .form-control-plaintext.input-group-text,\n.input-group-sm > .input-group-prepend > .form-control-plaintext.btn,\n.input-group-sm > .input-group-append > .form-control-plaintext.btn, .form-control-plaintext.form-control-lg, .input-group-lg > .form-control-plaintext.form-control,\n.input-group-lg > .input-group-prepend > .form-control-plaintext.input-group-text,\n.input-group-lg > .input-group-append > .form-control-plaintext.input-group-text,\n.input-group-lg > .input-group-prepend > .form-control-plaintext.btn,\n.input-group-lg > .input-group-append > .form-control-plaintext.btn {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.form-control-sm, .input-group-sm > .form-control,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n}\n\nselect.form-control-sm:not([size]):not([multiple]), .input-group-sm > select.form-control:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-sm > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-sm > .input-group-append > select.btn:not([size]):not([multiple]) {\n    height: calc(1.8125rem + 2px);\n}\n\n.form-control-lg, .input-group-lg > .form-control,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n    padding: 0.5rem 1rem;\n    font-size: 1.25rem;\n    line-height: 1.5;\n    border-radius: 0.3rem;\n}\n\nselect.form-control-lg:not([size]):not([multiple]), .input-group-lg > select.form-control:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.input-group-text:not([size]):not([multiple]),\n.input-group-lg > .input-group-prepend > select.btn:not([size]):not([multiple]),\n.input-group-lg > .input-group-append > select.btn:not([size]):not([multiple]) {\n    height: calc(2.875rem + 2px);\n}\n\n.form-group {\n    margin-bottom: 1rem;\n}\n\n.form-text {\n    display: block;\n    margin-top: 0.25rem;\n}\n\n.form-row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -5px;\n    margin-left: -5px;\n}\n\n.form-row > .col,\n.form-row > [class*=\"col-\"] {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n\n.form-check {\n    position: relative;\n    display: block;\n    padding-left: 1.25rem;\n}\n\n.form-check-input {\n    position: absolute;\n    margin-top: 0.3rem;\n    margin-left: -1.25rem;\n}\n\n.form-check-input:disabled ~ .form-check-label {\n    color: #6c757d;\n}\n\n.form-check-label {\n    margin-bottom: 0;\n}\n\n.form-check-inline {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding-left: 0;\n    margin-right: 0.75rem;\n}\n\n.form-check-inline .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: 0.3125rem;\n    margin-left: 0;\n}\n\n.valid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 80%;\n    color: #28a745;\n}\n\n.valid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .5rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    line-height: 1;\n    color: #fff;\n    background-color: rgba(40, 167, 69, 0.8);\n    border-radius: .2rem;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid, .was-validated\n.custom-select:valid,\n.custom-select.is-valid {\n    border-color: #28a745;\n}\n\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus, .was-validated\n.custom-select:valid:focus,\n.custom-select.is-valid:focus {\n    border-color: #28a745;\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-tooltip, .was-validated\n.custom-select:valid ~ .valid-feedback,\n.was-validated\n.custom-select:valid ~ .valid-tooltip,\n.custom-select.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-tooltip {\n    display: block;\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n    color: #28a745;\n}\n\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n    display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n    color: #28a745;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n    background-color: #71dd8a;\n}\n\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n    display: block;\n}\n\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n    background-color: #34ce57;\n}\n\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n    border-color: #28a745;\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {\n    border-color: inherit;\n}\n\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n    display: block;\n}\n\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n}\n\n.invalid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: 0.25rem;\n    font-size: 80%;\n    color: #dc3545;\n}\n\n.invalid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .5rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    line-height: 1;\n    color: #fff;\n    background-color: rgba(220, 53, 69, 0.8);\n    border-radius: .2rem;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid, .was-validated\n.custom-select:invalid,\n.custom-select.is-invalid {\n    border-color: #dc3545;\n}\n\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus, .was-validated\n.custom-select:invalid:focus,\n.custom-select.is-invalid:focus {\n    border-color: #dc3545;\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-tooltip, .was-validated\n.custom-select:invalid ~ .invalid-feedback,\n.was-validated\n.custom-select:invalid ~ .invalid-tooltip,\n.custom-select.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-tooltip {\n    display: block;\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n    color: #dc3545;\n}\n\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n    display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n    color: #dc3545;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n    background-color: #efa2a9;\n}\n\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n    display: block;\n}\n\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n    background-color: #e4606d;\n}\n\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n    border-color: #dc3545;\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {\n    border-color: inherit;\n}\n\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n    display: block;\n}\n\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n\n.form-inline {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-flow: row wrap;\n    flex-flow: row wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.form-inline .form-check {\n    width: 100%;\n}\n\n@media (min-width: 576px) {\n    .form-inline label {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        margin-bottom: 0;\n    }\n\n    .form-inline .form-group {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-flex: 0;\n        -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 0;\n    }\n\n    .form-inline .form-control {\n        display: inline-block;\n        width: auto;\n        vertical-align: middle;\n    }\n\n    .form-inline .form-control-plaintext {\n        display: inline-block;\n    }\n\n    .form-inline .input-group {\n        width: auto;\n    }\n\n    .form-inline .form-check {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n        width: auto;\n        padding-left: 0;\n    }\n\n    .form-inline .form-check-input {\n        position: relative;\n        margin-top: 0;\n        margin-right: 0.25rem;\n        margin-left: 0;\n    }\n\n    .form-inline .custom-control {\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n    }\n\n    .form-inline .custom-control-label {\n        margin-bottom: 0;\n    }\n}\n\n.btn {\n    display: inline-block;\n    font-weight: 400;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border: 1px solid transparent;\n    padding: 0.375rem 0.75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: 0.25rem;\n    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn:hover, .btn:focus {\n    text-decoration: none;\n}\n\n.btn:focus, .btn.focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.btn.disabled, .btn:disabled {\n    opacity: 0.65;\n}\n\n.btn:not(:disabled):not(.disabled) {\n    cursor: pointer;\n}\n\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {\n    background-image: none;\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n    pointer-events: none;\n}\n\n.btn-primary {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: #0069d9;\n    border-color: #0062cc;\n}\n\n.btn-primary:focus, .btn-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.btn-primary.disabled, .btn-primary:disabled {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n.show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #0062cc;\n    border-color: #005cbf;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.btn-secondary {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n.btn-secondary:hover {\n    color: #fff;\n    background-color: #5a6268;\n    border-color: #545b62;\n}\n\n.btn-secondary:focus, .btn-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-secondary.disabled, .btn-secondary:disabled {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #545b62;\n    border-color: #4e555b;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-secondary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-success {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745;\n}\n\n.btn-success:hover {\n    color: #fff;\n    background-color: #218838;\n    border-color: #1e7e34;\n}\n\n.btn-success:focus, .btn-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-success.disabled, .btn-success:disabled {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745;\n}\n\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n.show > .btn-success.dropdown-toggle {\n    color: #fff;\n    background-color: #1e7e34;\n    border-color: #1c7430;\n}\n\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-info {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8;\n}\n\n.btn-info:hover {\n    color: #fff;\n    background-color: #138496;\n    border-color: #117a8b;\n}\n\n.btn-info:focus, .btn-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-info.disabled, .btn-info:disabled {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8;\n}\n\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n.show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #117a8b;\n    border-color: #10707f;\n}\n\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-warning {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n\n.btn-warning:hover {\n    color: #212529;\n    background-color: #e0a800;\n    border-color: #d39e00;\n}\n\n.btn-warning:focus, .btn-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-warning.disabled, .btn-warning:disabled {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n.show > .btn-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #d39e00;\n    border-color: #c69500;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-danger {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-danger:hover {\n    color: #fff;\n    background-color: #c82333;\n    border-color: #bd2130;\n}\n\n.btn-danger:focus, .btn-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.btn-danger.disabled, .btn-danger:disabled {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n.show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #bd2130;\n    border-color: #b21f2d;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.btn-light {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa;\n}\n\n.btn-light:hover {\n    color: #212529;\n    background-color: #e2e6ea;\n    border-color: #dae0e5;\n}\n\n.btn-light:focus, .btn-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.btn-light.disabled, .btn-light:disabled {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa;\n}\n\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,\n.show > .btn-light.dropdown-toggle {\n    color: #212529;\n    background-color: #dae0e5;\n    border-color: #d3d9df;\n}\n\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,\n.show > .btn-light.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.btn-dark {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40;\n}\n\n.btn-dark:hover {\n    color: #fff;\n    background-color: #23272b;\n    border-color: #1d2124;\n}\n\n.btn-dark:focus, .btn-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-dark.disabled, .btn-dark:disabled {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,\n.show > .btn-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #1d2124;\n    border-color: #171a1d;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-outline-primary {\n    color: #007bff;\n    background-color: transparent;\n    background-image: none;\n    border-color: #007bff;\n}\n\n.btn-outline-primary:hover {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n    color: #007bff;\n    background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-primary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n}\n\n.btn-outline-secondary {\n    color: #6c757d;\n    background-color: transparent;\n    background-image: none;\n    border-color: #6c757d;\n}\n\n.btn-outline-secondary:hover {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n    color: #6c757d;\n    background-color: transparent;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-secondary.dropdown-toggle {\n    color: #fff;\n    background-color: #6c757d;\n    border-color: #6c757d;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-secondary.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-outline-success {\n    color: #28a745;\n    background-color: transparent;\n    background-image: none;\n    border-color: #28a745;\n}\n\n.btn-outline-success:hover {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745;\n}\n\n.btn-outline-success:focus, .btn-outline-success.focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n    color: #28a745;\n    background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,\n.show > .btn-outline-success.dropdown-toggle {\n    color: #fff;\n    background-color: #28a745;\n    border-color: #28a745;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-success.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);\n}\n\n.btn-outline-info {\n    color: #17a2b8;\n    background-color: transparent;\n    background-image: none;\n    border-color: #17a2b8;\n}\n\n.btn-outline-info:hover {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8;\n}\n\n.btn-outline-info:focus, .btn-outline-info.focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n    color: #17a2b8;\n    background-color: transparent;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,\n.show > .btn-outline-info.dropdown-toggle {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-info.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);\n}\n\n.btn-outline-warning {\n    color: #ffc107;\n    background-color: transparent;\n    background-image: none;\n    border-color: #ffc107;\n}\n\n.btn-outline-warning:hover {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n    color: #ffc107;\n    background-color: transparent;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,\n.show > .btn-outline-warning.dropdown-toggle {\n    color: #212529;\n    background-color: #ffc107;\n    border-color: #ffc107;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-warning.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);\n}\n\n.btn-outline-danger {\n    color: #dc3545;\n    background-color: transparent;\n    background-image: none;\n    border-color: #dc3545;\n}\n\n.btn-outline-danger:hover {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n    color: #dc3545;\n    background-color: transparent;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,\n.show > .btn-outline-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #dc3545;\n    border-color: #dc3545;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-danger.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.5);\n}\n\n.btn-outline-light {\n    color: #f8f9fa;\n    background-color: transparent;\n    background-image: none;\n    border-color: #f8f9fa;\n}\n\n.btn-outline-light:hover {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa;\n}\n\n.btn-outline-light:focus, .btn-outline-light.focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #f8f9fa;\n    background-color: transparent;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,\n.show > .btn-outline-light.dropdown-toggle {\n    color: #212529;\n    background-color: #f8f9fa;\n    border-color: #f8f9fa;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-light.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);\n}\n\n.btn-outline-dark {\n    color: #343a40;\n    background-color: transparent;\n    background-image: none;\n    border-color: #343a40;\n}\n\n.btn-outline-dark:hover {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40;\n}\n\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n    color: #343a40;\n    background-color: transparent;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,\n.show > .btn-outline-dark.dropdown-toggle {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #343a40;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-dark.dropdown-toggle:focus {\n    box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-link {\n    font-weight: 400;\n    color: #007bff;\n    background-color: transparent;\n}\n\n.btn-link:hover {\n    color: #0056b3;\n    text-decoration: underline;\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.btn-link:focus, .btn-link.focus {\n    text-decoration: underline;\n    border-color: transparent;\n    box-shadow: none;\n}\n\n.btn-link:disabled, .btn-link.disabled {\n    color: #6c757d;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n    padding: 0.5rem 1rem;\n    font-size: 1.25rem;\n    line-height: 1.5;\n    border-radius: 0.3rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n}\n\n.btn-block {\n    display: block;\n    width: 100%;\n}\n\n.btn-block + .btn-block {\n    margin-top: 0.5rem;\n}\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n    width: 100%;\n}\n\n.fade {\n    opacity: 0;\n    transition: opacity 0.15s linear;\n}\n\n.fade.show {\n    opacity: 1;\n}\n\n.collapse {\n    display: none;\n}\n\n.collapse.show {\n    display: block;\n}\n\ntr.collapse.show {\n    display: table-row;\n}\n\ntbody.collapse.show {\n    display: table-row-group;\n}\n\n.collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    transition: height 0.35s ease;\n}\n\n.dropup,\n.dropdown {\n    position: relative;\n}\n\n.dropdown-toggle::after {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0;\n    border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropdown-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    display: none;\n    float: left;\n    min-width: 10rem;\n    padding: 0.5rem 0;\n    margin: 0.125rem 0 0;\n    font-size: 1rem;\n    color: #212529;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.15);\n    border-radius: 0.25rem;\n}\n\n.dropup .dropdown-menu {\n    margin-top: 0;\n    margin-bottom: 0.125rem;\n}\n\n.dropup .dropdown-toggle::after {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0;\n    border-right: 0.3em solid transparent;\n    border-bottom: 0.3em solid;\n    border-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n    margin-top: 0;\n    margin-left: 0.125rem;\n}\n\n.dropright .dropdown-toggle::after {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid transparent;\n    border-bottom: 0.3em solid transparent;\n    border-left: 0.3em solid;\n}\n\n.dropright .dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropright .dropdown-toggle::after {\n    vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n    margin-top: 0;\n    margin-right: 0.125rem;\n}\n\n.dropleft .dropdown-toggle::after {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-left: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n}\n\n.dropleft .dropdown-toggle::after {\n    display: none;\n}\n\n.dropleft .dropdown-toggle::before {\n    display: inline-block;\n    width: 0;\n    height: 0;\n    margin-right: 0.255em;\n    vertical-align: 0.255em;\n    content: \"\";\n    border-top: 0.3em solid transparent;\n    border-right: 0.3em solid;\n    border-bottom: 0.3em solid transparent;\n}\n\n.dropleft .dropdown-toggle:empty::after {\n    margin-left: 0;\n}\n\n.dropleft .dropdown-toggle::before {\n    vertical-align: 0;\n}\n\n.dropdown-divider {\n    height: 0;\n    margin: 0.5rem 0;\n    overflow: hidden;\n    border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n    display: block;\n    width: 100%;\n    padding: 0.25rem 1.5rem;\n    clear: both;\n    font-weight: 400;\n    color: #212529;\n    text-align: inherit;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0;\n}\n\n.dropdown-item:hover, .dropdown-item:focus {\n    color: #16181b;\n    text-decoration: none;\n    background-color: #f8f9fa;\n}\n\n.dropdown-item.active, .dropdown-item:active {\n    color: #fff;\n    text-decoration: none;\n    background-color: #007bff;\n}\n\n.dropdown-item.disabled, .dropdown-item:disabled {\n    color: #6c757d;\n    background-color: transparent;\n}\n\n.dropdown-menu.show {\n    display: block;\n}\n\n.dropdown-header {\n    display: block;\n    padding: 0.5rem 1.5rem;\n    margin-bottom: 0;\n    font-size: 0.875rem;\n    color: #6c757d;\n    white-space: nowrap;\n}\n\n.btn-group,\n.btn-group-vertical {\n    position: relative;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    vertical-align: middle;\n}\n\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 1 auto;\n    flex: 0 1 auto;\n}\n\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n    z-index: 1;\n}\n\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n    z-index: 1;\n}\n\n.btn-group .btn + .btn,\n.btn-group .btn + .btn-group,\n.btn-group .btn-group + .btn,\n.btn-group .btn-group + .btn-group,\n.btn-group-vertical .btn + .btn,\n.btn-group-vertical .btn + .btn-group,\n.btn-group-vertical .btn-group + .btn,\n.btn-group-vertical .btn-group + .btn-group {\n    margin-left: -1px;\n}\n\n.btn-toolbar {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n    width: auto;\n}\n\n.btn-group > .btn:first-child {\n    margin-left: 0;\n}\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n    padding-right: 0.5625rem;\n    padding-left: 0.5625rem;\n}\n\n.dropdown-toggle-split::after {\n    margin-left: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n    padding-right: 0.375rem;\n    padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.btn-group-vertical .btn,\n.btn-group-vertical .btn-group {\n    width: 100%;\n}\n\n.btn-group-vertical > .btn + .btn,\n.btn-group-vertical > .btn + .btn-group,\n.btn-group-vertical > .btn-group + .btn,\n.btn-group-vertical > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0;\n}\n\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n    margin-bottom: 0;\n}\n\n.btn-group-toggle > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn input[type=\"checkbox\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none;\n}\n\n.input-group {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n    width: 100%;\n}\n\n.input-group > .form-control,\n.input-group > .custom-select,\n.input-group > .custom-file {\n    position: relative;\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    width: 1%;\n    margin-bottom: 0;\n}\n\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file:focus {\n    z-index: 3;\n}\n\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n    margin-left: -1px;\n}\n\n.input-group > .form-control:not(:last-child),\n.input-group > .custom-select:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.input-group > .custom-file {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.input-group > .custom-file:not(:last-child) .custom-file-label,\n.input-group > .custom-file:not(:last-child) .custom-file-label::before {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group > .custom-file:not(:first-child) .custom-file-label,\n.input-group > .custom-file:not(:first-child) .custom-file-label::before {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.input-group-prepend .btn,\n.input-group-append .btn {\n    position: relative;\n    z-index: 2;\n}\n\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n    margin-left: -1px;\n}\n\n.input-group-prepend {\n    margin-right: -1px;\n}\n\n.input-group-append {\n    margin-left: -1px;\n}\n\n.input-group-text {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 0.375rem 0.75rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #495057;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n}\n\n.input-group-text input[type=\"radio\"],\n.input-group-text input[type=\"checkbox\"] {\n    margin-top: 0;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n\n.custom-control {\n    position: relative;\n    display: block;\n    min-height: 1.5rem;\n    padding-left: 1.5rem;\n}\n\n.custom-control-inline {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    margin-right: 1rem;\n}\n\n.custom-control-input {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #007bff;\n}\n\n.custom-control-input:focus ~ .custom-control-label::before {\n    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-control-input:active ~ .custom-control-label::before {\n    color: #fff;\n    background-color: #b3d7ff;\n}\n\n.custom-control-input:disabled ~ .custom-control-label {\n    color: #6c757d;\n}\n\n.custom-control-input:disabled ~ .custom-control-label::before {\n    background-color: #e9ecef;\n}\n\n.custom-control-label {\n    margin-bottom: 0;\n}\n\n.custom-control-label::before {\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    pointer-events: none;\n    content: \"\";\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: #dee2e6;\n}\n\n.custom-control-label::after {\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    display: block;\n    width: 1rem;\n    height: 1rem;\n    content: \"\";\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n    border-radius: 0.25rem;\n}\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n    background-color: #007bff;\n}\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\");\n}\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n    background-color: #007bff;\n}\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\");\n}\n\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n    background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n    background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n    border-radius: 50%;\n}\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n    background-color: #007bff;\n}\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\");\n}\n\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n    background-color: rgba(0, 123, 255, 0.5);\n}\n\n.custom-select {\n    display: inline-block;\n    width: 100%;\n    height: calc(2.25rem + 2px);\n    padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #495057;\n    vertical-align: middle;\n    background: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right 0.75rem center;\n    background-size: 8px 10px;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n.custom-select:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 5px rgba(128, 189, 255, 0.5);\n}\n\n.custom-select:focus::-ms-value {\n    color: #495057;\n    background-color: #fff;\n}\n\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: 0.75rem;\n    background-image: none;\n}\n\n.custom-select:disabled {\n    color: #6c757d;\n    background-color: #e9ecef;\n}\n\n.custom-select::-ms-expand {\n    opacity: 0;\n}\n\n.custom-select-sm {\n    height: calc(1.8125rem + 2px);\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n    font-size: 75%;\n}\n\n.custom-select-lg {\n    height: calc(2.875rem + 2px);\n    padding-top: 0.375rem;\n    padding-bottom: 0.375rem;\n    font-size: 125%;\n}\n\n.custom-file {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    height: calc(2.25rem + 2px);\n    margin-bottom: 0;\n}\n\n.custom-file-input {\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: calc(2.25rem + 2px);\n    margin: 0;\n    opacity: 0;\n}\n\n.custom-file-input:focus ~ .custom-file-control {\n    border-color: #80bdff;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.custom-file-input:focus ~ .custom-file-control::before {\n    border-color: #80bdff;\n}\n\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n    content: \"Browse\";\n}\n\n.custom-file-label {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1;\n    height: calc(2.25rem + 2px);\n    padding: 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #495057;\n    background-color: #fff;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n}\n\n.custom-file-label::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: calc(calc(2.25rem + 2px) - 1px * 2);\n    padding: 0.375rem 0.75rem;\n    line-height: 1.5;\n    color: #495057;\n    content: \"Browse\";\n    background-color: #e9ecef;\n    border-left: 1px solid #ced4da;\n    border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n\n.nav-link {\n    display: block;\n    padding: 0.5rem 1rem;\n}\n\n.nav-link:hover, .nav-link:focus {\n    text-decoration: none;\n}\n\n.nav-link.disabled {\n    color: #6c757d;\n}\n\n.nav-tabs {\n    border-bottom: 1px solid #dee2e6;\n}\n\n.nav-tabs .nav-item {\n    margin-bottom: -1px;\n}\n\n.nav-tabs .nav-link {\n    border: 1px solid transparent;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n}\n\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n    border-color: #e9ecef #e9ecef #dee2e6;\n}\n\n.nav-tabs .nav-link.disabled {\n    color: #6c757d;\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n    color: #495057;\n    background-color: #fff;\n    border-color: #dee2e6 #dee2e6 #fff;\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: -1px;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n    border-radius: 0.25rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n    color: #fff;\n    background-color: #007bff;\n}\n\n.nav-fill .nav-item {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    text-align: center;\n}\n\n.nav-justified .nav-item {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    text-align: center;\n}\n\n.tab-content > .tab-pane {\n    display: none;\n}\n\n.tab-content > .active {\n    display: block;\n}\n\n.navbar {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    padding: 0.5rem 1rem;\n}\n\n.navbar > .container,\n.navbar > .container-fluid {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n}\n\n.navbar-brand {\n    display: inline-block;\n    padding-top: 0.3125rem;\n    padding-bottom: 0.3125rem;\n    margin-right: 1rem;\n    font-size: 1.25rem;\n    line-height: inherit;\n    white-space: nowrap;\n}\n\n.navbar-brand:hover, .navbar-brand:focus {\n    text-decoration: none;\n}\n\n.navbar-nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n}\n\n.navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.navbar-nav .dropdown-menu {\n    position: static;\n    float: none;\n}\n\n.navbar-text {\n    display: inline-block;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.navbar-toggler {\n    padding: 0.25rem 0.75rem;\n    font-size: 1.25rem;\n    line-height: 1;\n    background-color: transparent;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n}\n\n.navbar-toggler:hover, .navbar-toggler:focus {\n    text-decoration: none;\n}\n\n.navbar-toggler:not(:disabled):not(.disabled) {\n    cursor: pointer;\n}\n\n.navbar-toggler-icon {\n    display: inline-block;\n    width: 1.5em;\n    height: 1.5em;\n    vertical-align: middle;\n    content: \"\";\n    background: no-repeat center center;\n    background-size: 100% 100%;\n}\n\n@media (max-width: 575.98px) {\n    .navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid {\n        padding-right: 0;\n        padding-left: 0;\n    }\n}\n\n@media (min-width: 576px) {\n    .navbar-expand-sm {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-sm .navbar-nav {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-sm .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n    }\n\n    .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem;\n    }\n\n    .navbar-expand-sm > .container,\n    .navbar-expand-sm > .container-fluid {\n        -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    }\n\n    .navbar-expand-sm .navbar-collapse {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n        -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-sm .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-sm .dropup .dropdown-menu {\n        top: auto;\n        bottom: 100%;\n    }\n}\n\n@media (max-width: 767.98px) {\n    .navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid {\n        padding-right: 0;\n        padding-left: 0;\n    }\n}\n\n@media (min-width: 768px) {\n    .navbar-expand-md {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-md .navbar-nav {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-md .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n    }\n\n    .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem;\n    }\n\n    .navbar-expand-md > .container,\n    .navbar-expand-md > .container-fluid {\n        -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    }\n\n    .navbar-expand-md .navbar-collapse {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n        -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-md .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-md .dropup .dropdown-menu {\n        top: auto;\n        bottom: 100%;\n    }\n}\n\n@media (max-width: 991.98px) {\n    .navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid {\n        padding-right: 0;\n        padding-left: 0;\n    }\n}\n\n@media (min-width: 992px) {\n    .navbar-expand-lg {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-lg .navbar-nav {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-lg .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n    }\n\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem;\n    }\n\n    .navbar-expand-lg > .container,\n    .navbar-expand-lg > .container-fluid {\n        -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    }\n\n    .navbar-expand-lg .navbar-collapse {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n        -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-lg .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-lg .dropup .dropdown-menu {\n        top: auto;\n        bottom: 100%;\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid {\n        padding-right: 0;\n        padding-left: 0;\n    }\n}\n\n@media (min-width: 1200px) {\n    .navbar-expand-xl {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        justify-content: flex-start;\n    }\n\n    .navbar-expand-xl .navbar-nav {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n        flex-direction: row;\n    }\n\n    .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute;\n    }\n\n    .navbar-expand-xl .navbar-nav .dropdown-menu-right {\n        right: 0;\n        left: auto;\n    }\n\n    .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: 0.5rem;\n        padding-left: 0.5rem;\n    }\n\n    .navbar-expand-xl > .container,\n    .navbar-expand-xl > .container-fluid {\n        -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n    }\n\n    .navbar-expand-xl .navbar-collapse {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n        -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    }\n\n    .navbar-expand-xl .navbar-toggler {\n        display: none;\n    }\n\n    .navbar-expand-xl .dropup .dropdown-menu {\n        top: auto;\n        bottom: 100%;\n    }\n}\n\n.navbar-expand {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-flow: row nowrap;\n    flex-flow: row nowrap;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid {\n    padding-right: 0;\n    padding-left: 0;\n}\n\n.navbar-expand .navbar-nav {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n    position: absolute;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu-right {\n    right: 0;\n    left: auto;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid {\n    -ms-flex-wrap: nowrap;\n    flex-wrap: nowrap;\n}\n\n.navbar-expand .navbar-collapse {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n    display: none;\n}\n\n.navbar-expand .dropup .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n}\n\n.navbar-light .navbar-brand {\n    color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n    color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n    color: rgba(0, 0, 0, 0.7);\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n    color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n    color: rgba(0, 0, 0, 0.5);\n    border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n.navbar-light .navbar-text {\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.navbar-light .navbar-text a {\n    color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n    color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n    color: #fff;\n}\n\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n    color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n    color: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n    color: rgba(255, 255, 255, 0.5);\n    border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n.navbar-dark .navbar-text {\n    color: rgba(255, 255, 255, 0.5);\n}\n\n.navbar-dark .navbar-text a {\n    color: #fff;\n}\n\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n    color: #fff;\n}\n\n.card {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n}\n\n.card > hr {\n    margin-right: 0;\n    margin-left: 0;\n}\n\n.card > .list-group:first-child .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n}\n\n.card > .list-group:last-child .list-group-item:last-child {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.card-body {\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 1.25rem;\n}\n\n.card-title {\n    margin-bottom: 0.75rem;\n}\n\n.card-subtitle {\n    margin-top: -0.375rem;\n    margin-bottom: 0;\n}\n\n.card-text:last-child {\n    margin-bottom: 0;\n}\n\n.card-link:hover {\n    text-decoration: none;\n}\n\n.card-link + .card-link {\n    margin-left: 1.25rem;\n}\n\n.card-header {\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 0;\n    background-color: rgba(0, 0, 0, 0.03);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.card-header:first-child {\n    border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n\n.card-header + .list-group .list-group-item:first-child {\n    border-top: 0;\n}\n\n.card-footer {\n    padding: 0.75rem 1.25rem;\n    background-color: rgba(0, 0, 0, 0.03);\n    border-top: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.card-footer:last-child {\n    border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n    margin-right: -0.625rem;\n    margin-bottom: -0.75rem;\n    margin-left: -0.625rem;\n    border-bottom: 0;\n}\n\n.card-header-pills {\n    margin-right: -0.625rem;\n    margin-left: -0.625rem;\n}\n\n.card-img-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1.25rem;\n}\n\n.card-img {\n    width: 100%;\n    border-radius: calc(0.25rem - 1px);\n}\n\n.card-img-top {\n    width: 100%;\n    border-top-left-radius: calc(0.25rem - 1px);\n    border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img-bottom {\n    width: 100%;\n    border-bottom-right-radius: calc(0.25rem - 1px);\n    border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-deck {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.card-deck .card {\n    margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n    .card-deck {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n        margin-right: -15px;\n        margin-left: -15px;\n    }\n\n    .card-deck .card {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-flex: 1;\n        -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n        flex-direction: column;\n        margin-right: 15px;\n        margin-bottom: 0;\n        margin-left: 15px;\n    }\n}\n\n.card-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.card-group > .card {\n    margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n    .card-group {\n        -webkit-box-orient: horizontal;\n        -webkit-box-direction: normal;\n        -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n    }\n\n    .card-group > .card {\n        -webkit-box-flex: 1;\n        -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n        margin-bottom: 0;\n    }\n\n    .card-group > .card + .card {\n        margin-left: 0;\n        border-left: 0;\n    }\n\n    .card-group > .card:first-child {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n\n    .card-group > .card:first-child .card-img-top,\n    .card-group > .card:first-child .card-header {\n        border-top-right-radius: 0;\n    }\n\n    .card-group > .card:first-child .card-img-bottom,\n    .card-group > .card:first-child .card-footer {\n        border-bottom-right-radius: 0;\n    }\n\n    .card-group > .card:last-child {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .card-group > .card:last-child .card-img-top,\n    .card-group > .card:last-child .card-header {\n        border-top-left-radius: 0;\n    }\n\n    .card-group > .card:last-child .card-img-bottom,\n    .card-group > .card:last-child .card-footer {\n        border-bottom-left-radius: 0;\n    }\n\n    .card-group > .card:only-child {\n        border-radius: 0.25rem;\n    }\n\n    .card-group > .card:only-child .card-img-top,\n    .card-group > .card:only-child .card-header {\n        border-top-left-radius: 0.25rem;\n        border-top-right-radius: 0.25rem;\n    }\n\n    .card-group > .card:only-child .card-img-bottom,\n    .card-group > .card:only-child .card-footer {\n        border-bottom-right-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n    }\n\n    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {\n        border-radius: 0;\n    }\n\n    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,\n    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,\n    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,\n    .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {\n        border-radius: 0;\n    }\n}\n\n.card-columns .card {\n    margin-bottom: 0.75rem;\n}\n\n@media (min-width: 576px) {\n    .card-columns {\n        -webkit-column-count: 3;\n        -moz-column-count: 3;\n        column-count: 3;\n        -webkit-column-gap: 1.25rem;\n        -moz-column-gap: 1.25rem;\n        column-gap: 1.25rem;\n    }\n\n    .card-columns .card {\n        display: inline-block;\n        width: 100%;\n    }\n}\n\n.breadcrumb {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding: 0.75rem 1rem;\n    margin-bottom: 1rem;\n    list-style: none;\n    background-color: #e9ecef;\n    border-radius: 0.25rem;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n    display: inline-block;\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n    color: #6c757d;\n    content: \"/\";\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n    text-decoration: none;\n}\n\n.breadcrumb-item.active {\n    color: #6c757d;\n}\n\n.pagination {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding-left: 0;\n    list-style: none;\n    border-radius: 0.25rem;\n}\n\n.page-link {\n    position: relative;\n    display: block;\n    padding: 0.5rem 0.75rem;\n    margin-left: -1px;\n    line-height: 1.25;\n    color: #007bff;\n    background-color: #fff;\n    border: 1px solid #dee2e6;\n}\n\n.page-link:hover {\n    color: #0056b3;\n    text-decoration: none;\n    background-color: #e9ecef;\n    border-color: #dee2e6;\n}\n\n.page-link:focus {\n    z-index: 2;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.page-link:not(:disabled):not(.disabled) {\n    cursor: pointer;\n}\n\n.page-item:first-child .page-link {\n    margin-left: 0;\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.page-item:last-child .page-link {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n}\n\n.page-item.active .page-link {\n    z-index: 1;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.page-item.disabled .page-link {\n    color: #6c757d;\n    pointer-events: none;\n    cursor: auto;\n    background-color: #fff;\n    border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n    padding: 0.75rem 1.5rem;\n    font-size: 1.25rem;\n    line-height: 1.5;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n    border-top-left-radius: 0.3rem;\n    border-bottom-left-radius: 0.3rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n    border-top-right-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n    border-top-left-radius: 0.2rem;\n    border-bottom-left-radius: 0.2rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n    border-top-right-radius: 0.2rem;\n    border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n    display: inline-block;\n    padding: 0.25em 0.4em;\n    font-size: 75%;\n    font-weight: 700;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: 0.25rem;\n}\n\n.badge:empty {\n    display: none;\n}\n\n.btn .badge {\n    position: relative;\n    top: -1px;\n}\n\n.badge-pill {\n    padding-right: 0.6em;\n    padding-left: 0.6em;\n    border-radius: 10rem;\n}\n\n.badge-primary {\n    color: #fff;\n    background-color: #007bff;\n}\n\n.badge-primary[href]:hover, .badge-primary[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #0062cc;\n}\n\n.badge-secondary {\n    color: #fff;\n    background-color: #6c757d;\n}\n\n.badge-secondary[href]:hover, .badge-secondary[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #545b62;\n}\n\n.badge-success {\n    color: #fff;\n    background-color: #28a745;\n}\n\n.badge-success[href]:hover, .badge-success[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1e7e34;\n}\n\n.badge-info {\n    color: #fff;\n    background-color: #17a2b8;\n}\n\n.badge-info[href]:hover, .badge-info[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #117a8b;\n}\n\n.badge-warning {\n    color: #212529;\n    background-color: #ffc107;\n}\n\n.badge-warning[href]:hover, .badge-warning[href]:focus {\n    color: #212529;\n    text-decoration: none;\n    background-color: #d39e00;\n}\n\n.badge-danger {\n    color: #fff;\n    background-color: #dc3545;\n}\n\n.badge-danger[href]:hover, .badge-danger[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #bd2130;\n}\n\n.badge-light {\n    color: #212529;\n    background-color: #f8f9fa;\n}\n\n.badge-light[href]:hover, .badge-light[href]:focus {\n    color: #212529;\n    text-decoration: none;\n    background-color: #dae0e5;\n}\n\n.badge-dark {\n    color: #fff;\n    background-color: #343a40;\n}\n\n.badge-dark[href]:hover, .badge-dark[href]:focus {\n    color: #fff;\n    text-decoration: none;\n    background-color: #1d2124;\n}\n\n.jumbotron {\n    padding: 2rem 1rem;\n    margin-bottom: 2rem;\n    background-color: #e9ecef;\n    border-radius: 0.3rem;\n}\n\n@media (min-width: 576px) {\n    .jumbotron {\n        padding: 4rem 2rem;\n    }\n}\n\n.jumbotron-fluid {\n    padding-right: 0;\n    padding-left: 0;\n    border-radius: 0;\n}\n\n.alert {\n    position: relative;\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 1rem;\n    border: 1px solid transparent;\n    border-radius: 0.25rem;\n}\n\n.alert-heading {\n    color: inherit;\n}\n\n.alert-link {\n    font-weight: 700;\n}\n\n.alert-dismissible {\n    padding-right: 4rem;\n}\n\n.alert-dismissible .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 0.75rem 1.25rem;\n    color: inherit;\n}\n\n.alert-primary {\n    color: #004085;\n    background-color: #cce5ff;\n    border-color: #b8daff;\n}\n\n.alert-primary hr {\n    border-top-color: #9fcdff;\n}\n\n.alert-primary .alert-link {\n    color: #002752;\n}\n\n.alert-secondary {\n    color: #383d41;\n    background-color: #e2e3e5;\n    border-color: #d6d8db;\n}\n\n.alert-secondary hr {\n    border-top-color: #c8cbcf;\n}\n\n.alert-secondary .alert-link {\n    color: #202326;\n}\n\n.alert-success {\n    color: #155724;\n    background-color: #d4edda;\n    border-color: #c3e6cb;\n}\n\n.alert-success hr {\n    border-top-color: #b1dfbb;\n}\n\n.alert-success .alert-link {\n    color: #0b2e13;\n}\n\n.alert-info {\n    color: #0c5460;\n    background-color: #d1ecf1;\n    border-color: #bee5eb;\n}\n\n.alert-info hr {\n    border-top-color: #abdde5;\n}\n\n.alert-info .alert-link {\n    color: #062c33;\n}\n\n.alert-warning {\n    color: #856404;\n    background-color: #fff3cd;\n    border-color: #ffeeba;\n}\n\n.alert-warning hr {\n    border-top-color: #ffe8a1;\n}\n\n.alert-warning .alert-link {\n    color: #533f03;\n}\n\n.alert-danger {\n    color: #721c24;\n    background-color: #f8d7da;\n    border-color: #f5c6cb;\n}\n\n.alert-danger hr {\n    border-top-color: #f1b0b7;\n}\n\n.alert-danger .alert-link {\n    color: #491217;\n}\n\n.alert-light {\n    color: #818182;\n    background-color: #fefefe;\n    border-color: #fdfdfe;\n}\n\n.alert-light hr {\n    border-top-color: #ececf6;\n}\n\n.alert-light .alert-link {\n    color: #686868;\n}\n\n.alert-dark {\n    color: #1b1e21;\n    background-color: #d6d8d9;\n    border-color: #c6c8ca;\n}\n\n.alert-dark hr {\n    border-top-color: #b9bbbe;\n}\n\n.alert-dark .alert-link {\n    color: #040505;\n}\n\n@-webkit-keyframes progress-bar-stripes {\n    from {\n        background-position: 1rem 0;\n    }\n    to {\n        background-position: 0 0;\n    }\n}\n\n@keyframes progress-bar-stripes {\n    from {\n        background-position: 1rem 0;\n    }\n    to {\n        background-position: 0 0;\n    }\n}\n\n.progress {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 1rem;\n    overflow: hidden;\n    font-size: 0.75rem;\n    background-color: #e9ecef;\n    border-radius: 0.25rem;\n}\n\n.progress-bar {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    color: #fff;\n    text-align: center;\n    background-color: #007bff;\n    transition: width 0.6s ease;\n}\n\n.progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n    background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n    -webkit-animation: progress-bar-stripes 1s linear infinite;\n    animation: progress-bar-stripes 1s linear infinite;\n}\n\n.media {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n}\n\n.media-body {\n    -webkit-box-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n}\n\n.list-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n}\n\n.list-group-item-action {\n    width: 100%;\n    color: #495057;\n    text-align: inherit;\n}\n\n.list-group-item-action:hover, .list-group-item-action:focus {\n    color: #495057;\n    text-decoration: none;\n    background-color: #f8f9fa;\n}\n\n.list-group-item-action:active {\n    color: #212529;\n    background-color: #e9ecef;\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: 0.75rem 1.25rem;\n    margin-bottom: -1px;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n}\n\n.list-group-item:last-child {\n    margin-bottom: 0;\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n}\n\n.list-group-item:hover, .list-group-item:focus {\n    z-index: 1;\n    text-decoration: none;\n}\n\n.list-group-item.disabled, .list-group-item:disabled {\n    color: #6c757d;\n    background-color: #fff;\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n}\n\n.list-group-flush .list-group-item {\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0;\n}\n\n.list-group-flush:first-child .list-group-item:first-child {\n    border-top: 0;\n}\n\n.list-group-flush:last-child .list-group-item:last-child {\n    border-bottom: 0;\n}\n\n.list-group-item-primary {\n    color: #004085;\n    background-color: #b8daff;\n}\n\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n    color: #004085;\n    background-color: #9fcdff;\n}\n\n.list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #004085;\n    border-color: #004085;\n}\n\n.list-group-item-secondary {\n    color: #383d41;\n    background-color: #d6d8db;\n}\n\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n    color: #383d41;\n    background-color: #c8cbcf;\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #383d41;\n    border-color: #383d41;\n}\n\n.list-group-item-success {\n    color: #155724;\n    background-color: #c3e6cb;\n}\n\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n    color: #155724;\n    background-color: #b1dfbb;\n}\n\n.list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #155724;\n    border-color: #155724;\n}\n\n.list-group-item-info {\n    color: #0c5460;\n    background-color: #bee5eb;\n}\n\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n    color: #0c5460;\n    background-color: #abdde5;\n}\n\n.list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #0c5460;\n    border-color: #0c5460;\n}\n\n.list-group-item-warning {\n    color: #856404;\n    background-color: #ffeeba;\n}\n\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n    color: #856404;\n    background-color: #ffe8a1;\n}\n\n.list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #856404;\n    border-color: #856404;\n}\n\n.list-group-item-danger {\n    color: #721c24;\n    background-color: #f5c6cb;\n}\n\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n    color: #721c24;\n    background-color: #f1b0b7;\n}\n\n.list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #721c24;\n    border-color: #721c24;\n}\n\n.list-group-item-light {\n    color: #818182;\n    background-color: #fdfdfe;\n}\n\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n    color: #818182;\n    background-color: #ececf6;\n}\n\n.list-group-item-light.list-group-item-action.active {\n    color: #fff;\n    background-color: #818182;\n    border-color: #818182;\n}\n\n.list-group-item-dark {\n    color: #1b1e21;\n    background-color: #c6c8ca;\n}\n\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n    color: #1b1e21;\n    background-color: #b9bbbe;\n}\n\n.list-group-item-dark.list-group-item-action.active {\n    color: #fff;\n    background-color: #1b1e21;\n    border-color: #1b1e21;\n}\n\n.close {\n    float: right;\n    font-size: 1.5rem;\n    font-weight: 700;\n    line-height: 1;\n    color: #000;\n    text-shadow: 0 1px 0 #fff;\n    opacity: .5;\n}\n\n.close:hover, .close:focus {\n    color: #000;\n    text-decoration: none;\n    opacity: .75;\n}\n\n.close:not(:disabled):not(.disabled) {\n    cursor: pointer;\n}\n\nbutton.close {\n    padding: 0;\n    background-color: transparent;\n    border: 0;\n    -webkit-appearance: none;\n}\n\n.modal-open {\n    overflow: hidden;\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    overflow: hidden;\n    outline: 0;\n}\n\n.modal-open .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 0.5rem;\n    pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n    transition: -webkit-transform 0.3s ease-out;\n    transition: transform 0.3s ease-out;\n    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n    -webkit-transform: translate(0, -25%);\n    transform: translate(0, -25%);\n}\n\n.modal.show .modal-dialog {\n    -webkit-transform: translate(0, 0);\n    transform: translate(0, 0);\n}\n\n.modal-dialog-centered {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    min-height: calc(100% - (0.5rem * 2));\n}\n\n.modal-content {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    width: 100%;\n    pointer-events: auto;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0.3rem;\n    outline: 0;\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1040;\n    background-color: #000;\n}\n\n.modal-backdrop.fade {\n    opacity: 0;\n}\n\n.modal-backdrop.show {\n    opacity: 0.5;\n}\n\n.modal-header {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: start;\n    -ms-flex-align: start;\n    align-items: flex-start;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    padding: 1rem;\n    border-bottom: 1px solid #e9ecef;\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n}\n\n.modal-header .close {\n    padding: 1rem;\n    margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n    margin-bottom: 0;\n    line-height: 1.5;\n}\n\n.modal-body {\n    position: relative;\n    -webkit-box-flex: 1;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 1rem;\n}\n\n.modal-footer {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    padding: 1rem;\n    border-top: 1px solid #e9ecef;\n}\n\n.modal-footer > :not(:first-child) {\n    margin-left: .25rem;\n}\n\n.modal-footer > :not(:last-child) {\n    margin-right: .25rem;\n}\n\n.modal-scrollbar-measure {\n    position: absolute;\n    top: -9999px;\n    width: 50px;\n    height: 50px;\n    overflow: scroll;\n}\n\n@media (min-width: 576px) {\n    .modal-dialog {\n        max-width: 500px;\n        margin: 1.75rem auto;\n    }\n\n    .modal-dialog-centered {\n        min-height: calc(100% - (1.75rem * 2));\n    }\n\n    .modal-sm {\n        max-width: 300px;\n    }\n}\n\n@media (min-width: 992px) {\n    .modal-lg {\n        max-width: 800px;\n    }\n}\n\n.tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: 0.875rem;\n    word-wrap: break-word;\n    opacity: 0;\n}\n\n.tooltip.show {\n    opacity: 0.9;\n}\n\n.tooltip .arrow {\n    position: absolute;\n    display: block;\n    width: 0.8rem;\n    height: 0.4rem;\n}\n\n.tooltip .arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n    padding: 0.4rem 0;\n}\n\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n    bottom: 0;\n}\n\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n    top: 0;\n    border-width: 0.4rem 0.4rem 0;\n    border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n    padding: 0 0.4rem;\n}\n\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n    left: 0;\n    width: 0.4rem;\n    height: 0.8rem;\n}\n\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n    right: 0;\n    border-width: 0.4rem 0.4rem 0.4rem 0;\n    border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n    padding: 0.4rem 0;\n}\n\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n    top: 0;\n}\n\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n    bottom: 0;\n    border-width: 0 0.4rem 0.4rem;\n    border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n    padding: 0 0.4rem;\n}\n\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n    right: 0;\n    width: 0.4rem;\n    height: 0.8rem;\n}\n\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n    left: 0;\n    border-width: 0.4rem 0 0.4rem 0.4rem;\n    border-left-color: #000;\n}\n\n.tooltip-inner {\n    max-width: 200px;\n    padding: 0.25rem 0.5rem;\n    color: #fff;\n    text-align: center;\n    background-color: #000;\n    border-radius: 0.25rem;\n}\n\n.popover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1060;\n    display: block;\n    max-width: 276px;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: 0.875rem;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0.3rem;\n}\n\n.popover .arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: 0.5rem;\n    margin: 0 0.3rem;\n}\n\n.popover .arrow::before, .popover .arrow::after {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n    margin-bottom: 0.5rem;\n}\n\n.bs-popover-top .arrow, .bs-popover-auto[x-placement^=\"top\"] .arrow {\n    bottom: calc((0.5rem + 1px) * -1);\n}\n\n.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=\"top\"] .arrow::before,\n.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    border-width: 0.5rem 0.5rem 0;\n}\n\n.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=\"top\"] .arrow::before {\n    bottom: 0;\n    border-top-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    bottom: 1px;\n    border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n    margin-left: 0.5rem;\n}\n\n.bs-popover-right .arrow, .bs-popover-auto[x-placement^=\"right\"] .arrow {\n    left: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0;\n}\n\n.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=\"right\"] .arrow::before,\n.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    border-width: 0.5rem 0.5rem 0.5rem 0;\n}\n\n.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=\"right\"] .arrow::before {\n    left: 0;\n    border-right-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    left: 1px;\n    border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n    margin-top: 0.5rem;\n}\n\n.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=\"bottom\"] .arrow {\n    top: calc((0.5rem + 1px) * -1);\n}\n\n.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before,\n.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    border-width: 0 0.5rem 0.5rem 0.5rem;\n}\n\n.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before {\n    top: 0;\n    border-bottom-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    top: 1px;\n    border-bottom-color: #fff;\n}\n\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -0.5rem;\n    content: \"\";\n    border-bottom: 1px solid #f7f7f7;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n    margin-right: 0.5rem;\n}\n\n.bs-popover-left .arrow, .bs-popover-auto[x-placement^=\"left\"] .arrow {\n    right: calc((0.5rem + 1px) * -1);\n    width: 0.5rem;\n    height: 1rem;\n    margin: 0.3rem 0;\n}\n\n.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=\"left\"] .arrow::before,\n.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    border-width: 0.5rem 0 0.5rem 0.5rem;\n}\n\n.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=\"left\"] .arrow::before {\n    right: 0;\n    border-left-color: rgba(0, 0, 0, 0.25);\n}\n\n.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    right: 1px;\n    border-left-color: #fff;\n}\n\n.popover-header {\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n    color: inherit;\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #ebebeb;\n    border-top-left-radius: calc(0.3rem - 1px);\n    border-top-right-radius: calc(0.3rem - 1px);\n}\n\n.popover-header:empty {\n    display: none;\n}\n\n.popover-body {\n    padding: 0.5rem 0.75rem;\n    color: #212529;\n}\n\n.carousel {\n    position: relative;\n}\n\n.carousel-inner {\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n}\n\n.carousel-item {\n    position: relative;\n    display: none;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    width: 100%;\n    transition: -webkit-transform 0.6s ease;\n    transition: transform 0.6s ease;\n    transition: transform 0.6s ease, -webkit-transform 0.6s ease;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    -webkit-perspective: 1000px;\n    perspective: 1000px;\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n    display: block;\n}\n\n.carousel-item-next,\n.carousel-item-prev {\n    position: absolute;\n    top: 0;\n}\n\n.carousel-item-next.carousel-item-left,\n.carousel-item-prev.carousel-item-right {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n}\n\n@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {\n    .carousel-item-next.carousel-item-left,\n    .carousel-item-prev.carousel-item-right {\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n.carousel-item-next,\n.active.carousel-item-right {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n}\n\n@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {\n    .carousel-item-next,\n    .active.carousel-item-right {\n        -webkit-transform: translate3d(100%, 0, 0);\n        transform: translate3d(100%, 0, 0);\n    }\n}\n\n.carousel-item-prev,\n.active.carousel-item-left {\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n}\n\n@supports ((-webkit-transform-style: preserve-3d) or (transform-style: preserve-3d)) {\n    .carousel-item-prev,\n    .active.carousel-item-left {\n        -webkit-transform: translate3d(-100%, 0, 0);\n        transform: translate3d(-100%, 0, 0);\n    }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    width: 15%;\n    color: #fff;\n    text-align: center;\n    opacity: 0.5;\n}\n\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9;\n}\n\n.carousel-control-prev {\n    left: 0;\n}\n\n.carousel-control-next {\n    right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    background: transparent no-repeat center center;\n    background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\");\n}\n\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\");\n}\n\n.carousel-indicators {\n    position: absolute;\n    right: 0;\n    bottom: 10px;\n    left: 0;\n    z-index: 15;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    padding-left: 0;\n    margin-right: 15%;\n    margin-left: 15%;\n    list-style: none;\n}\n\n.carousel-indicators li {\n    position: relative;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 1 auto;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    background-color: rgba(255, 255, 255, 0.5);\n}\n\n.carousel-indicators li::before {\n    position: absolute;\n    top: -10px;\n    left: 0;\n    display: inline-block;\n    width: 100%;\n    height: 10px;\n    content: \"\";\n}\n\n.carousel-indicators li::after {\n    position: absolute;\n    bottom: -10px;\n    left: 0;\n    display: inline-block;\n    width: 100%;\n    height: 10px;\n    content: \"\";\n}\n\n.carousel-indicators .active {\n    background-color: #fff;\n}\n\n.carousel-caption {\n    position: absolute;\n    right: 15%;\n    bottom: 20px;\n    left: 15%;\n    z-index: 10;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    color: #fff;\n    text-align: center;\n}\n\n.align-baseline {\n    vertical-align: baseline !important;\n}\n\n.align-top {\n    vertical-align: top !important;\n}\n\n.align-middle {\n    vertical-align: middle !important;\n}\n\n.align-bottom {\n    vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n    vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n    vertical-align: text-top !important;\n}\n\n.bg-primary {\n    background-color: #007bff !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n    background-color: #0062cc !important;\n}\n\n.bg-secondary {\n    background-color: #6c757d !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n    background-color: #545b62 !important;\n}\n\n.bg-success {\n    background-color: #28a745 !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n    background-color: #1e7e34 !important;\n}\n\n.bg-info {\n    background-color: #17a2b8 !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n    background-color: #117a8b !important;\n}\n\n.bg-warning {\n    background-color: #ffc107 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n    background-color: #d39e00 !important;\n}\n\n.bg-danger {\n    background-color: #dc3545 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n    background-color: #bd2130 !important;\n}\n\n.bg-light {\n    background-color: #f8f9fa !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n    background-color: #dae0e5 !important;\n}\n\n.bg-dark {\n    background-color: #343a40 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n    background-color: #1d2124 !important;\n}\n\n.bg-white {\n    background-color: #fff !important;\n}\n\n.bg-transparent {\n    background-color: transparent !important;\n}\n\n.border {\n    border: 1px solid #dee2e6 !important;\n}\n\n.border-top {\n    border-top: 1px solid #dee2e6 !important;\n}\n\n.border-right {\n    border-right: 1px solid #dee2e6 !important;\n}\n\n.border-bottom {\n    border-bottom: 1px solid #dee2e6 !important;\n}\n\n.border-left {\n    border-left: 1px solid #dee2e6 !important;\n}\n\n.border-0 {\n    border: 0 !important;\n}\n\n.border-top-0 {\n    border-top: 0 !important;\n}\n\n.border-right-0 {\n    border-right: 0 !important;\n}\n\n.border-bottom-0 {\n    border-bottom: 0 !important;\n}\n\n.border-left-0 {\n    border-left: 0 !important;\n}\n\n.border-primary {\n    border-color: #007bff !important;\n}\n\n.border-secondary {\n    border-color: #6c757d !important;\n}\n\n.border-success {\n    border-color: #28a745 !important;\n}\n\n.border-info {\n    border-color: #17a2b8 !important;\n}\n\n.border-warning {\n    border-color: #ffc107 !important;\n}\n\n.border-danger {\n    border-color: #dc3545 !important;\n}\n\n.border-light {\n    border-color: #f8f9fa !important;\n}\n\n.border-dark {\n    border-color: #343a40 !important;\n}\n\n.border-white {\n    border-color: #fff !important;\n}\n\n.rounded {\n    border-radius: 0.25rem !important;\n}\n\n.rounded-top {\n    border-top-left-radius: 0.25rem !important;\n    border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-right {\n    border-top-right-radius: 0.25rem !important;\n    border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n    border-bottom-right-radius: 0.25rem !important;\n    border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-left {\n    border-top-left-radius: 0.25rem !important;\n    border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-circle {\n    border-radius: 50% !important;\n}\n\n.rounded-0 {\n    border-radius: 0 !important;\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\";\n}\n\n.d-none {\n    display: none !important;\n}\n\n.d-inline {\n    display: inline !important;\n}\n\n.d-inline-block {\n    display: inline-block !important;\n}\n\n.d-block {\n    display: block !important;\n}\n\n.d-table {\n    display: table !important;\n}\n\n.d-table-row {\n    display: table-row !important;\n}\n\n.d-table-cell {\n    display: table-cell !important;\n}\n\n.d-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n\n.d-inline-flex {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n    .d-sm-none {\n        display: none !important;\n    }\n\n    .d-sm-inline {\n        display: inline !important;\n    }\n\n    .d-sm-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-sm-block {\n        display: block !important;\n    }\n\n    .d-sm-table {\n        display: table !important;\n    }\n\n    .d-sm-table-row {\n        display: table-row !important;\n    }\n\n    .d-sm-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-sm-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-sm-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .d-md-none {\n        display: none !important;\n    }\n\n    .d-md-inline {\n        display: inline !important;\n    }\n\n    .d-md-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-md-block {\n        display: block !important;\n    }\n\n    .d-md-table {\n        display: table !important;\n    }\n\n    .d-md-table-row {\n        display: table-row !important;\n    }\n\n    .d-md-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-md-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-md-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .d-lg-none {\n        display: none !important;\n    }\n\n    .d-lg-inline {\n        display: inline !important;\n    }\n\n    .d-lg-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-lg-block {\n        display: block !important;\n    }\n\n    .d-lg-table {\n        display: table !important;\n    }\n\n    .d-lg-table-row {\n        display: table-row !important;\n    }\n\n    .d-lg-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-lg-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-lg-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .d-xl-none {\n        display: none !important;\n    }\n\n    .d-xl-inline {\n        display: inline !important;\n    }\n\n    .d-xl-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-xl-block {\n        display: block !important;\n    }\n\n    .d-xl-table {\n        display: table !important;\n    }\n\n    .d-xl-table-row {\n        display: table-row !important;\n    }\n\n    .d-xl-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-xl-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-xl-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n@media print {\n    .d-print-none {\n        display: none !important;\n    }\n\n    .d-print-inline {\n        display: inline !important;\n    }\n\n    .d-print-inline-block {\n        display: inline-block !important;\n    }\n\n    .d-print-block {\n        display: block !important;\n    }\n\n    .d-print-table {\n        display: table !important;\n    }\n\n    .d-print-table-row {\n        display: table-row !important;\n    }\n\n    .d-print-table-cell {\n        display: table-cell !important;\n    }\n\n    .d-print-flex {\n        display: -webkit-box !important;\n        display: -ms-flexbox !important;\n        display: flex !important;\n    }\n\n    .d-print-inline-flex {\n        display: -webkit-inline-box !important;\n        display: -ms-inline-flexbox !important;\n        display: inline-flex !important;\n    }\n}\n\n.embed-responsive {\n    position: relative;\n    display: block;\n    width: 100%;\n    padding: 0;\n    overflow: hidden;\n}\n\n.embed-responsive::before {\n    display: block;\n    content: \"\";\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n}\n\n.embed-responsive-21by9::before {\n    padding-top: 42.857143%;\n}\n\n.embed-responsive-16by9::before {\n    padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n    padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n    padding-top: 100%;\n}\n\n.flex-row {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: row !important;\n    flex-direction: row !important;\n}\n\n.flex-column {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: normal !important;\n    -ms-flex-direction: column !important;\n    flex-direction: column !important;\n}\n\n.flex-row-reverse {\n    -webkit-box-orient: horizontal !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: row-reverse !important;\n    flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n    -webkit-box-orient: vertical !important;\n    -webkit-box-direction: reverse !important;\n    -ms-flex-direction: column-reverse !important;\n    flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n    -ms-flex-wrap: wrap !important;\n    flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n    -ms-flex-wrap: nowrap !important;\n    flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n    flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n    -webkit-box-pack: start !important;\n    -ms-flex-pack: start !important;\n    justify-content: flex-start !important;\n}\n\n.justify-content-end {\n    -webkit-box-pack: end !important;\n    -ms-flex-pack: end !important;\n    justify-content: flex-end !important;\n}\n\n.justify-content-center {\n    -webkit-box-pack: center !important;\n    -ms-flex-pack: center !important;\n    justify-content: center !important;\n}\n\n.justify-content-between {\n    -webkit-box-pack: justify !important;\n    -ms-flex-pack: justify !important;\n    justify-content: space-between !important;\n}\n\n.justify-content-around {\n    -ms-flex-pack: distribute !important;\n    justify-content: space-around !important;\n}\n\n.align-items-start {\n    -webkit-box-align: start !important;\n    -ms-flex-align: start !important;\n    align-items: flex-start !important;\n}\n\n.align-items-end {\n    -webkit-box-align: end !important;\n    -ms-flex-align: end !important;\n    align-items: flex-end !important;\n}\n\n.align-items-center {\n    -webkit-box-align: center !important;\n    -ms-flex-align: center !important;\n    align-items: center !important;\n}\n\n.align-items-baseline {\n    -webkit-box-align: baseline !important;\n    -ms-flex-align: baseline !important;\n    align-items: baseline !important;\n}\n\n.align-items-stretch {\n    -webkit-box-align: stretch !important;\n    -ms-flex-align: stretch !important;\n    align-items: stretch !important;\n}\n\n.align-content-start {\n    -ms-flex-line-pack: start !important;\n    align-content: flex-start !important;\n}\n\n.align-content-end {\n    -ms-flex-line-pack: end !important;\n    align-content: flex-end !important;\n}\n\n.align-content-center {\n    -ms-flex-line-pack: center !important;\n    align-content: center !important;\n}\n\n.align-content-between {\n    -ms-flex-line-pack: justify !important;\n    align-content: space-between !important;\n}\n\n.align-content-around {\n    -ms-flex-line-pack: distribute !important;\n    align-content: space-around !important;\n}\n\n.align-content-stretch {\n    -ms-flex-line-pack: stretch !important;\n    align-content: stretch !important;\n}\n\n.align-self-auto {\n    -ms-flex-item-align: auto !important;\n    align-self: auto !important;\n}\n\n.align-self-start {\n    -ms-flex-item-align: start !important;\n    align-self: flex-start !important;\n}\n\n.align-self-end {\n    -ms-flex-item-align: end !important;\n    align-self: flex-end !important;\n}\n\n.align-self-center {\n    -ms-flex-item-align: center !important;\n    align-self: center !important;\n}\n\n.align-self-baseline {\n    -ms-flex-item-align: baseline !important;\n    align-self: baseline !important;\n}\n\n.align-self-stretch {\n    -ms-flex-item-align: stretch !important;\n    align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n    .flex-sm-row {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n        flex-direction: row !important;\n    }\n\n    .flex-sm-column {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n        flex-direction: column !important;\n    }\n\n    .flex-sm-row-reverse {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-sm-column-reverse {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-sm-wrap {\n        -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n    }\n\n    .flex-sm-nowrap {\n        -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-sm-wrap-reverse {\n        -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-sm-start {\n        -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-sm-end {\n        -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-sm-center {\n        -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n        justify-content: center !important;\n    }\n\n    .justify-content-sm-between {\n        -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n    }\n\n    .justify-content-sm-around {\n        -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n    }\n\n    .align-items-sm-start {\n        -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n        align-items: flex-start !important;\n    }\n\n    .align-items-sm-end {\n        -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n        align-items: flex-end !important;\n    }\n\n    .align-items-sm-center {\n        -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n        align-items: center !important;\n    }\n\n    .align-items-sm-baseline {\n        -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n    }\n\n    .align-items-sm-stretch {\n        -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n    }\n\n    .align-content-sm-start {\n        -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n    }\n\n    .align-content-sm-end {\n        -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n    }\n\n    .align-content-sm-center {\n        -ms-flex-line-pack: center !important;\n        align-content: center !important;\n    }\n\n    .align-content-sm-between {\n        -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n    }\n\n    .align-content-sm-around {\n        -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n    }\n\n    .align-content-sm-stretch {\n        -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n    }\n\n    .align-self-sm-auto {\n        -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n    }\n\n    .align-self-sm-start {\n        -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n    }\n\n    .align-self-sm-end {\n        -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n    }\n\n    .align-self-sm-center {\n        -ms-flex-item-align: center !important;\n        align-self: center !important;\n    }\n\n    .align-self-sm-baseline {\n        -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n    }\n\n    .align-self-sm-stretch {\n        -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .flex-md-row {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n        flex-direction: row !important;\n    }\n\n    .flex-md-column {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n        flex-direction: column !important;\n    }\n\n    .flex-md-row-reverse {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-md-column-reverse {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-md-wrap {\n        -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n    }\n\n    .flex-md-nowrap {\n        -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-md-wrap-reverse {\n        -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-md-start {\n        -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-md-end {\n        -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-md-center {\n        -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n        justify-content: center !important;\n    }\n\n    .justify-content-md-between {\n        -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n    }\n\n    .justify-content-md-around {\n        -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n    }\n\n    .align-items-md-start {\n        -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n        align-items: flex-start !important;\n    }\n\n    .align-items-md-end {\n        -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n        align-items: flex-end !important;\n    }\n\n    .align-items-md-center {\n        -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n        align-items: center !important;\n    }\n\n    .align-items-md-baseline {\n        -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n    }\n\n    .align-items-md-stretch {\n        -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n    }\n\n    .align-content-md-start {\n        -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n    }\n\n    .align-content-md-end {\n        -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n    }\n\n    .align-content-md-center {\n        -ms-flex-line-pack: center !important;\n        align-content: center !important;\n    }\n\n    .align-content-md-between {\n        -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n    }\n\n    .align-content-md-around {\n        -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n    }\n\n    .align-content-md-stretch {\n        -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n    }\n\n    .align-self-md-auto {\n        -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n    }\n\n    .align-self-md-start {\n        -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n    }\n\n    .align-self-md-end {\n        -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n    }\n\n    .align-self-md-center {\n        -ms-flex-item-align: center !important;\n        align-self: center !important;\n    }\n\n    .align-self-md-baseline {\n        -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n    }\n\n    .align-self-md-stretch {\n        -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .flex-lg-row {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n        flex-direction: row !important;\n    }\n\n    .flex-lg-column {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n        flex-direction: column !important;\n    }\n\n    .flex-lg-row-reverse {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-lg-column-reverse {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-lg-wrap {\n        -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n    }\n\n    .flex-lg-nowrap {\n        -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-lg-wrap-reverse {\n        -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-lg-start {\n        -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-lg-end {\n        -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-lg-center {\n        -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n        justify-content: center !important;\n    }\n\n    .justify-content-lg-between {\n        -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n    }\n\n    .justify-content-lg-around {\n        -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n    }\n\n    .align-items-lg-start {\n        -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n        align-items: flex-start !important;\n    }\n\n    .align-items-lg-end {\n        -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n        align-items: flex-end !important;\n    }\n\n    .align-items-lg-center {\n        -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n        align-items: center !important;\n    }\n\n    .align-items-lg-baseline {\n        -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n    }\n\n    .align-items-lg-stretch {\n        -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n    }\n\n    .align-content-lg-start {\n        -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n    }\n\n    .align-content-lg-end {\n        -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n    }\n\n    .align-content-lg-center {\n        -ms-flex-line-pack: center !important;\n        align-content: center !important;\n    }\n\n    .align-content-lg-between {\n        -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n    }\n\n    .align-content-lg-around {\n        -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n    }\n\n    .align-content-lg-stretch {\n        -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n    }\n\n    .align-self-lg-auto {\n        -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n    }\n\n    .align-self-lg-start {\n        -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n    }\n\n    .align-self-lg-end {\n        -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n    }\n\n    .align-self-lg-center {\n        -ms-flex-item-align: center !important;\n        align-self: center !important;\n    }\n\n    .align-self-lg-baseline {\n        -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n    }\n\n    .align-self-lg-stretch {\n        -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .flex-xl-row {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: row !important;\n        flex-direction: row !important;\n    }\n\n    .flex-xl-column {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: normal !important;\n        -ms-flex-direction: column !important;\n        flex-direction: column !important;\n    }\n\n    .flex-xl-row-reverse {\n        -webkit-box-orient: horizontal !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n    }\n\n    .flex-xl-column-reverse {\n        -webkit-box-orient: vertical !important;\n        -webkit-box-direction: reverse !important;\n        -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n    }\n\n    .flex-xl-wrap {\n        -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n    }\n\n    .flex-xl-nowrap {\n        -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .flex-xl-wrap-reverse {\n        -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n    }\n\n    .justify-content-xl-start {\n        -webkit-box-pack: start !important;\n        -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n    }\n\n    .justify-content-xl-end {\n        -webkit-box-pack: end !important;\n        -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n    }\n\n    .justify-content-xl-center {\n        -webkit-box-pack: center !important;\n        -ms-flex-pack: center !important;\n        justify-content: center !important;\n    }\n\n    .justify-content-xl-between {\n        -webkit-box-pack: justify !important;\n        -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n    }\n\n    .justify-content-xl-around {\n        -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n    }\n\n    .align-items-xl-start {\n        -webkit-box-align: start !important;\n        -ms-flex-align: start !important;\n        align-items: flex-start !important;\n    }\n\n    .align-items-xl-end {\n        -webkit-box-align: end !important;\n        -ms-flex-align: end !important;\n        align-items: flex-end !important;\n    }\n\n    .align-items-xl-center {\n        -webkit-box-align: center !important;\n        -ms-flex-align: center !important;\n        align-items: center !important;\n    }\n\n    .align-items-xl-baseline {\n        -webkit-box-align: baseline !important;\n        -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n    }\n\n    .align-items-xl-stretch {\n        -webkit-box-align: stretch !important;\n        -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n    }\n\n    .align-content-xl-start {\n        -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n    }\n\n    .align-content-xl-end {\n        -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n    }\n\n    .align-content-xl-center {\n        -ms-flex-line-pack: center !important;\n        align-content: center !important;\n    }\n\n    .align-content-xl-between {\n        -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n    }\n\n    .align-content-xl-around {\n        -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n    }\n\n    .align-content-xl-stretch {\n        -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n    }\n\n    .align-self-xl-auto {\n        -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n    }\n\n    .align-self-xl-start {\n        -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n    }\n\n    .align-self-xl-end {\n        -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n    }\n\n    .align-self-xl-center {\n        -ms-flex-item-align: center !important;\n        align-self: center !important;\n    }\n\n    .align-self-xl-baseline {\n        -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n    }\n\n    .align-self-xl-stretch {\n        -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n    }\n}\n\n.float-left {\n    float: left !important;\n}\n\n.float-right {\n    float: right !important;\n}\n\n.float-none {\n    float: none !important;\n}\n\n@media (min-width: 576px) {\n    .float-sm-left {\n        float: left !important;\n    }\n\n    .float-sm-right {\n        float: right !important;\n    }\n\n    .float-sm-none {\n        float: none !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .float-md-left {\n        float: left !important;\n    }\n\n    .float-md-right {\n        float: right !important;\n    }\n\n    .float-md-none {\n        float: none !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .float-lg-left {\n        float: left !important;\n    }\n\n    .float-lg-right {\n        float: right !important;\n    }\n\n    .float-lg-none {\n        float: none !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .float-xl-left {\n        float: left !important;\n    }\n\n    .float-xl-right {\n        float: right !important;\n    }\n\n    .float-xl-none {\n        float: none !important;\n    }\n}\n\n.position-static {\n    position: static !important;\n}\n\n.position-relative {\n    position: relative !important;\n}\n\n.position-absolute {\n    position: absolute !important;\n}\n\n.position-fixed {\n    position: fixed !important;\n}\n\n.position-sticky {\n    position: -webkit-sticky !important;\n    position: sticky !important;\n}\n\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030;\n}\n\n.fixed-bottom {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1030;\n}\n\n@supports ((position: -webkit-sticky) or (position: sticky)) {\n    .sticky-top {\n        position: -webkit-sticky;\n        position: sticky;\n        top: 0;\n        z-index: 1020;\n    }\n}\n\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    -webkit-clip-path: inset(50%);\n    clip-path: inset(50%);\n    border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n    -webkit-clip-path: none;\n    clip-path: none;\n}\n\n.w-25 {\n    width: 25% !important;\n}\n\n.w-50 {\n    width: 50% !important;\n}\n\n.w-75 {\n    width: 75% !important;\n}\n\n.w-100 {\n    width: 100% !important;\n}\n\n.h-25 {\n    height: 25% !important;\n}\n\n.h-50 {\n    height: 50% !important;\n}\n\n.h-75 {\n    height: 75% !important;\n}\n\n.h-100 {\n    height: 100% !important;\n}\n\n.mw-100 {\n    max-width: 100% !important;\n}\n\n.mh-100 {\n    max-height: 100% !important;\n}\n\n.m-0 {\n    margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n    margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n    margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n    margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n    margin-left: 0 !important;\n}\n\n.m-1 {\n    margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n    margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n    margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n    margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n    margin-left: 0.25rem !important;\n}\n\n.m-2 {\n    margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n    margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n    margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n    margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n    margin-left: 0.5rem !important;\n}\n\n.m-3 {\n    margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n    margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n    margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n    margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n    margin-left: 1rem !important;\n}\n\n.m-4 {\n    margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n    margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n    margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n    margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n    margin-left: 1.5rem !important;\n}\n\n.m-5 {\n    margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n    margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n    margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n    margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n    margin-left: 3rem !important;\n}\n\n.p-0 {\n    padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n    padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n    padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n    padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n    padding-left: 0 !important;\n}\n\n.p-1 {\n    padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n    padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n    padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n    padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n    padding-left: 0.25rem !important;\n}\n\n.p-2 {\n    padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n    padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n    padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n    padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n    padding-left: 0.5rem !important;\n}\n\n.p-3 {\n    padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n    padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n    padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n    padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n    padding-left: 1rem !important;\n}\n\n.p-4 {\n    padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n    padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n    padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n    padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n    padding-left: 1.5rem !important;\n}\n\n.p-5 {\n    padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n    padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n    padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n    padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n    padding-left: 3rem !important;\n}\n\n.m-auto {\n    margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n    margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n    margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n    margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n    margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n    .m-sm-0 {\n        margin: 0 !important;\n    }\n\n    .mt-sm-0,\n    .my-sm-0 {\n        margin-top: 0 !important;\n    }\n\n    .mr-sm-0,\n    .mx-sm-0 {\n        margin-right: 0 !important;\n    }\n\n    .mb-sm-0,\n    .my-sm-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .ml-sm-0,\n    .mx-sm-0 {\n        margin-left: 0 !important;\n    }\n\n    .m-sm-1 {\n        margin: 0.25rem !important;\n    }\n\n    .mt-sm-1,\n    .my-sm-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mr-sm-1,\n    .mx-sm-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .mb-sm-1,\n    .my-sm-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .ml-sm-1,\n    .mx-sm-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .m-sm-2 {\n        margin: 0.5rem !important;\n    }\n\n    .mt-sm-2,\n    .my-sm-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mr-sm-2,\n    .mx-sm-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .mb-sm-2,\n    .my-sm-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .ml-sm-2,\n    .mx-sm-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .m-sm-3 {\n        margin: 1rem !important;\n    }\n\n    .mt-sm-3,\n    .my-sm-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mr-sm-3,\n    .mx-sm-3 {\n        margin-right: 1rem !important;\n    }\n\n    .mb-sm-3,\n    .my-sm-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .ml-sm-3,\n    .mx-sm-3 {\n        margin-left: 1rem !important;\n    }\n\n    .m-sm-4 {\n        margin: 1.5rem !important;\n    }\n\n    .mt-sm-4,\n    .my-sm-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mr-sm-4,\n    .mx-sm-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .mb-sm-4,\n    .my-sm-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .ml-sm-4,\n    .mx-sm-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .m-sm-5 {\n        margin: 3rem !important;\n    }\n\n    .mt-sm-5,\n    .my-sm-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mr-sm-5,\n    .mx-sm-5 {\n        margin-right: 3rem !important;\n    }\n\n    .mb-sm-5,\n    .my-sm-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .ml-sm-5,\n    .mx-sm-5 {\n        margin-left: 3rem !important;\n    }\n\n    .p-sm-0 {\n        padding: 0 !important;\n    }\n\n    .pt-sm-0,\n    .py-sm-0 {\n        padding-top: 0 !important;\n    }\n\n    .pr-sm-0,\n    .px-sm-0 {\n        padding-right: 0 !important;\n    }\n\n    .pb-sm-0,\n    .py-sm-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pl-sm-0,\n    .px-sm-0 {\n        padding-left: 0 !important;\n    }\n\n    .p-sm-1 {\n        padding: 0.25rem !important;\n    }\n\n    .pt-sm-1,\n    .py-sm-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pr-sm-1,\n    .px-sm-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pb-sm-1,\n    .py-sm-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pl-sm-1,\n    .px-sm-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .p-sm-2 {\n        padding: 0.5rem !important;\n    }\n\n    .pt-sm-2,\n    .py-sm-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pr-sm-2,\n    .px-sm-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pb-sm-2,\n    .py-sm-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pl-sm-2,\n    .px-sm-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .p-sm-3 {\n        padding: 1rem !important;\n    }\n\n    .pt-sm-3,\n    .py-sm-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pr-sm-3,\n    .px-sm-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pb-sm-3,\n    .py-sm-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pl-sm-3,\n    .px-sm-3 {\n        padding-left: 1rem !important;\n    }\n\n    .p-sm-4 {\n        padding: 1.5rem !important;\n    }\n\n    .pt-sm-4,\n    .py-sm-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pr-sm-4,\n    .px-sm-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pb-sm-4,\n    .py-sm-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pl-sm-4,\n    .px-sm-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .p-sm-5 {\n        padding: 3rem !important;\n    }\n\n    .pt-sm-5,\n    .py-sm-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pr-sm-5,\n    .px-sm-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-sm-5,\n    .py-sm-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .pl-sm-5,\n    .px-sm-5 {\n        padding-left: 3rem !important;\n    }\n\n    .m-sm-auto {\n        margin: auto !important;\n    }\n\n    .mt-sm-auto,\n    .my-sm-auto {\n        margin-top: auto !important;\n    }\n\n    .mr-sm-auto,\n    .mx-sm-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-sm-auto,\n    .my-sm-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ml-sm-auto,\n    .mx-sm-auto {\n        margin-left: auto !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .m-md-0 {\n        margin: 0 !important;\n    }\n\n    .mt-md-0,\n    .my-md-0 {\n        margin-top: 0 !important;\n    }\n\n    .mr-md-0,\n    .mx-md-0 {\n        margin-right: 0 !important;\n    }\n\n    .mb-md-0,\n    .my-md-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .ml-md-0,\n    .mx-md-0 {\n        margin-left: 0 !important;\n    }\n\n    .m-md-1 {\n        margin: 0.25rem !important;\n    }\n\n    .mt-md-1,\n    .my-md-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mr-md-1,\n    .mx-md-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .mb-md-1,\n    .my-md-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .ml-md-1,\n    .mx-md-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .m-md-2 {\n        margin: 0.5rem !important;\n    }\n\n    .mt-md-2,\n    .my-md-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mr-md-2,\n    .mx-md-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .mb-md-2,\n    .my-md-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .ml-md-2,\n    .mx-md-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .m-md-3 {\n        margin: 1rem !important;\n    }\n\n    .mt-md-3,\n    .my-md-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mr-md-3,\n    .mx-md-3 {\n        margin-right: 1rem !important;\n    }\n\n    .mb-md-3,\n    .my-md-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .ml-md-3,\n    .mx-md-3 {\n        margin-left: 1rem !important;\n    }\n\n    .m-md-4 {\n        margin: 1.5rem !important;\n    }\n\n    .mt-md-4,\n    .my-md-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mr-md-4,\n    .mx-md-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .mb-md-4,\n    .my-md-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .ml-md-4,\n    .mx-md-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .m-md-5 {\n        margin: 3rem !important;\n    }\n\n    .mt-md-5,\n    .my-md-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mr-md-5,\n    .mx-md-5 {\n        margin-right: 3rem !important;\n    }\n\n    .mb-md-5,\n    .my-md-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .ml-md-5,\n    .mx-md-5 {\n        margin-left: 3rem !important;\n    }\n\n    .p-md-0 {\n        padding: 0 !important;\n    }\n\n    .pt-md-0,\n    .py-md-0 {\n        padding-top: 0 !important;\n    }\n\n    .pr-md-0,\n    .px-md-0 {\n        padding-right: 0 !important;\n    }\n\n    .pb-md-0,\n    .py-md-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pl-md-0,\n    .px-md-0 {\n        padding-left: 0 !important;\n    }\n\n    .p-md-1 {\n        padding: 0.25rem !important;\n    }\n\n    .pt-md-1,\n    .py-md-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pr-md-1,\n    .px-md-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pb-md-1,\n    .py-md-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pl-md-1,\n    .px-md-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .p-md-2 {\n        padding: 0.5rem !important;\n    }\n\n    .pt-md-2,\n    .py-md-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pr-md-2,\n    .px-md-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pb-md-2,\n    .py-md-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pl-md-2,\n    .px-md-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .p-md-3 {\n        padding: 1rem !important;\n    }\n\n    .pt-md-3,\n    .py-md-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pr-md-3,\n    .px-md-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pb-md-3,\n    .py-md-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pl-md-3,\n    .px-md-3 {\n        padding-left: 1rem !important;\n    }\n\n    .p-md-4 {\n        padding: 1.5rem !important;\n    }\n\n    .pt-md-4,\n    .py-md-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pr-md-4,\n    .px-md-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pb-md-4,\n    .py-md-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pl-md-4,\n    .px-md-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .p-md-5 {\n        padding: 3rem !important;\n    }\n\n    .pt-md-5,\n    .py-md-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pr-md-5,\n    .px-md-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-md-5,\n    .py-md-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .pl-md-5,\n    .px-md-5 {\n        padding-left: 3rem !important;\n    }\n\n    .m-md-auto {\n        margin: auto !important;\n    }\n\n    .mt-md-auto,\n    .my-md-auto {\n        margin-top: auto !important;\n    }\n\n    .mr-md-auto,\n    .mx-md-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-md-auto,\n    .my-md-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ml-md-auto,\n    .mx-md-auto {\n        margin-left: auto !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .m-lg-0 {\n        margin: 0 !important;\n    }\n\n    .mt-lg-0,\n    .my-lg-0 {\n        margin-top: 0 !important;\n    }\n\n    .mr-lg-0,\n    .mx-lg-0 {\n        margin-right: 0 !important;\n    }\n\n    .mb-lg-0,\n    .my-lg-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .ml-lg-0,\n    .mx-lg-0 {\n        margin-left: 0 !important;\n    }\n\n    .m-lg-1 {\n        margin: 0.25rem !important;\n    }\n\n    .mt-lg-1,\n    .my-lg-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mr-lg-1,\n    .mx-lg-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .mb-lg-1,\n    .my-lg-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .ml-lg-1,\n    .mx-lg-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .m-lg-2 {\n        margin: 0.5rem !important;\n    }\n\n    .mt-lg-2,\n    .my-lg-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mr-lg-2,\n    .mx-lg-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .mb-lg-2,\n    .my-lg-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .ml-lg-2,\n    .mx-lg-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .m-lg-3 {\n        margin: 1rem !important;\n    }\n\n    .mt-lg-3,\n    .my-lg-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mr-lg-3,\n    .mx-lg-3 {\n        margin-right: 1rem !important;\n    }\n\n    .mb-lg-3,\n    .my-lg-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .ml-lg-3,\n    .mx-lg-3 {\n        margin-left: 1rem !important;\n    }\n\n    .m-lg-4 {\n        margin: 1.5rem !important;\n    }\n\n    .mt-lg-4,\n    .my-lg-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mr-lg-4,\n    .mx-lg-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .mb-lg-4,\n    .my-lg-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .ml-lg-4,\n    .mx-lg-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .m-lg-5 {\n        margin: 3rem !important;\n    }\n\n    .mt-lg-5,\n    .my-lg-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mr-lg-5,\n    .mx-lg-5 {\n        margin-right: 3rem !important;\n    }\n\n    .mb-lg-5,\n    .my-lg-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .ml-lg-5,\n    .mx-lg-5 {\n        margin-left: 3rem !important;\n    }\n\n    .p-lg-0 {\n        padding: 0 !important;\n    }\n\n    .pt-lg-0,\n    .py-lg-0 {\n        padding-top: 0 !important;\n    }\n\n    .pr-lg-0,\n    .px-lg-0 {\n        padding-right: 0 !important;\n    }\n\n    .pb-lg-0,\n    .py-lg-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pl-lg-0,\n    .px-lg-0 {\n        padding-left: 0 !important;\n    }\n\n    .p-lg-1 {\n        padding: 0.25rem !important;\n    }\n\n    .pt-lg-1,\n    .py-lg-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pr-lg-1,\n    .px-lg-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pb-lg-1,\n    .py-lg-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pl-lg-1,\n    .px-lg-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .p-lg-2 {\n        padding: 0.5rem !important;\n    }\n\n    .pt-lg-2,\n    .py-lg-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pr-lg-2,\n    .px-lg-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pb-lg-2,\n    .py-lg-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pl-lg-2,\n    .px-lg-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .p-lg-3 {\n        padding: 1rem !important;\n    }\n\n    .pt-lg-3,\n    .py-lg-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pr-lg-3,\n    .px-lg-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pb-lg-3,\n    .py-lg-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pl-lg-3,\n    .px-lg-3 {\n        padding-left: 1rem !important;\n    }\n\n    .p-lg-4 {\n        padding: 1.5rem !important;\n    }\n\n    .pt-lg-4,\n    .py-lg-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pr-lg-4,\n    .px-lg-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pb-lg-4,\n    .py-lg-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pl-lg-4,\n    .px-lg-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .p-lg-5 {\n        padding: 3rem !important;\n    }\n\n    .pt-lg-5,\n    .py-lg-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pr-lg-5,\n    .px-lg-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-lg-5,\n    .py-lg-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .pl-lg-5,\n    .px-lg-5 {\n        padding-left: 3rem !important;\n    }\n\n    .m-lg-auto {\n        margin: auto !important;\n    }\n\n    .mt-lg-auto,\n    .my-lg-auto {\n        margin-top: auto !important;\n    }\n\n    .mr-lg-auto,\n    .mx-lg-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-lg-auto,\n    .my-lg-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ml-lg-auto,\n    .mx-lg-auto {\n        margin-left: auto !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .m-xl-0 {\n        margin: 0 !important;\n    }\n\n    .mt-xl-0,\n    .my-xl-0 {\n        margin-top: 0 !important;\n    }\n\n    .mr-xl-0,\n    .mx-xl-0 {\n        margin-right: 0 !important;\n    }\n\n    .mb-xl-0,\n    .my-xl-0 {\n        margin-bottom: 0 !important;\n    }\n\n    .ml-xl-0,\n    .mx-xl-0 {\n        margin-left: 0 !important;\n    }\n\n    .m-xl-1 {\n        margin: 0.25rem !important;\n    }\n\n    .mt-xl-1,\n    .my-xl-1 {\n        margin-top: 0.25rem !important;\n    }\n\n    .mr-xl-1,\n    .mx-xl-1 {\n        margin-right: 0.25rem !important;\n    }\n\n    .mb-xl-1,\n    .my-xl-1 {\n        margin-bottom: 0.25rem !important;\n    }\n\n    .ml-xl-1,\n    .mx-xl-1 {\n        margin-left: 0.25rem !important;\n    }\n\n    .m-xl-2 {\n        margin: 0.5rem !important;\n    }\n\n    .mt-xl-2,\n    .my-xl-2 {\n        margin-top: 0.5rem !important;\n    }\n\n    .mr-xl-2,\n    .mx-xl-2 {\n        margin-right: 0.5rem !important;\n    }\n\n    .mb-xl-2,\n    .my-xl-2 {\n        margin-bottom: 0.5rem !important;\n    }\n\n    .ml-xl-2,\n    .mx-xl-2 {\n        margin-left: 0.5rem !important;\n    }\n\n    .m-xl-3 {\n        margin: 1rem !important;\n    }\n\n    .mt-xl-3,\n    .my-xl-3 {\n        margin-top: 1rem !important;\n    }\n\n    .mr-xl-3,\n    .mx-xl-3 {\n        margin-right: 1rem !important;\n    }\n\n    .mb-xl-3,\n    .my-xl-3 {\n        margin-bottom: 1rem !important;\n    }\n\n    .ml-xl-3,\n    .mx-xl-3 {\n        margin-left: 1rem !important;\n    }\n\n    .m-xl-4 {\n        margin: 1.5rem !important;\n    }\n\n    .mt-xl-4,\n    .my-xl-4 {\n        margin-top: 1.5rem !important;\n    }\n\n    .mr-xl-4,\n    .mx-xl-4 {\n        margin-right: 1.5rem !important;\n    }\n\n    .mb-xl-4,\n    .my-xl-4 {\n        margin-bottom: 1.5rem !important;\n    }\n\n    .ml-xl-4,\n    .mx-xl-4 {\n        margin-left: 1.5rem !important;\n    }\n\n    .m-xl-5 {\n        margin: 3rem !important;\n    }\n\n    .mt-xl-5,\n    .my-xl-5 {\n        margin-top: 3rem !important;\n    }\n\n    .mr-xl-5,\n    .mx-xl-5 {\n        margin-right: 3rem !important;\n    }\n\n    .mb-xl-5,\n    .my-xl-5 {\n        margin-bottom: 3rem !important;\n    }\n\n    .ml-xl-5,\n    .mx-xl-5 {\n        margin-left: 3rem !important;\n    }\n\n    .p-xl-0 {\n        padding: 0 !important;\n    }\n\n    .pt-xl-0,\n    .py-xl-0 {\n        padding-top: 0 !important;\n    }\n\n    .pr-xl-0,\n    .px-xl-0 {\n        padding-right: 0 !important;\n    }\n\n    .pb-xl-0,\n    .py-xl-0 {\n        padding-bottom: 0 !important;\n    }\n\n    .pl-xl-0,\n    .px-xl-0 {\n        padding-left: 0 !important;\n    }\n\n    .p-xl-1 {\n        padding: 0.25rem !important;\n    }\n\n    .pt-xl-1,\n    .py-xl-1 {\n        padding-top: 0.25rem !important;\n    }\n\n    .pr-xl-1,\n    .px-xl-1 {\n        padding-right: 0.25rem !important;\n    }\n\n    .pb-xl-1,\n    .py-xl-1 {\n        padding-bottom: 0.25rem !important;\n    }\n\n    .pl-xl-1,\n    .px-xl-1 {\n        padding-left: 0.25rem !important;\n    }\n\n    .p-xl-2 {\n        padding: 0.5rem !important;\n    }\n\n    .pt-xl-2,\n    .py-xl-2 {\n        padding-top: 0.5rem !important;\n    }\n\n    .pr-xl-2,\n    .px-xl-2 {\n        padding-right: 0.5rem !important;\n    }\n\n    .pb-xl-2,\n    .py-xl-2 {\n        padding-bottom: 0.5rem !important;\n    }\n\n    .pl-xl-2,\n    .px-xl-2 {\n        padding-left: 0.5rem !important;\n    }\n\n    .p-xl-3 {\n        padding: 1rem !important;\n    }\n\n    .pt-xl-3,\n    .py-xl-3 {\n        padding-top: 1rem !important;\n    }\n\n    .pr-xl-3,\n    .px-xl-3 {\n        padding-right: 1rem !important;\n    }\n\n    .pb-xl-3,\n    .py-xl-3 {\n        padding-bottom: 1rem !important;\n    }\n\n    .pl-xl-3,\n    .px-xl-3 {\n        padding-left: 1rem !important;\n    }\n\n    .p-xl-4 {\n        padding: 1.5rem !important;\n    }\n\n    .pt-xl-4,\n    .py-xl-4 {\n        padding-top: 1.5rem !important;\n    }\n\n    .pr-xl-4,\n    .px-xl-4 {\n        padding-right: 1.5rem !important;\n    }\n\n    .pb-xl-4,\n    .py-xl-4 {\n        padding-bottom: 1.5rem !important;\n    }\n\n    .pl-xl-4,\n    .px-xl-4 {\n        padding-left: 1.5rem !important;\n    }\n\n    .p-xl-5 {\n        padding: 3rem !important;\n    }\n\n    .pt-xl-5,\n    .py-xl-5 {\n        padding-top: 3rem !important;\n    }\n\n    .pr-xl-5,\n    .px-xl-5 {\n        padding-right: 3rem !important;\n    }\n\n    .pb-xl-5,\n    .py-xl-5 {\n        padding-bottom: 3rem !important;\n    }\n\n    .pl-xl-5,\n    .px-xl-5 {\n        padding-left: 3rem !important;\n    }\n\n    .m-xl-auto {\n        margin: auto !important;\n    }\n\n    .mt-xl-auto,\n    .my-xl-auto {\n        margin-top: auto !important;\n    }\n\n    .mr-xl-auto,\n    .mx-xl-auto {\n        margin-right: auto !important;\n    }\n\n    .mb-xl-auto,\n    .my-xl-auto {\n        margin-bottom: auto !important;\n    }\n\n    .ml-xl-auto,\n    .mx-xl-auto {\n        margin-left: auto !important;\n    }\n}\n\n.text-justify {\n    text-align: justify !important;\n}\n\n.text-nowrap {\n    white-space: nowrap !important;\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.text-left {\n    text-align: left !important;\n}\n\n.text-right {\n    text-align: right !important;\n}\n\n.text-center {\n    text-align: center !important;\n}\n\n@media (min-width: 576px) {\n    .text-sm-left {\n        text-align: left !important;\n    }\n\n    .text-sm-right {\n        text-align: right !important;\n    }\n\n    .text-sm-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .text-md-left {\n        text-align: left !important;\n    }\n\n    .text-md-right {\n        text-align: right !important;\n    }\n\n    .text-md-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .text-lg-left {\n        text-align: left !important;\n    }\n\n    .text-lg-right {\n        text-align: right !important;\n    }\n\n    .text-lg-center {\n        text-align: center !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .text-xl-left {\n        text-align: left !important;\n    }\n\n    .text-xl-right {\n        text-align: right !important;\n    }\n\n    .text-xl-center {\n        text-align: center !important;\n    }\n}\n\n.text-lowercase {\n    text-transform: lowercase !important;\n}\n\n.text-uppercase {\n    text-transform: uppercase !important;\n}\n\n.text-capitalize {\n    text-transform: capitalize !important;\n}\n\n.font-weight-light {\n    font-weight: 300 !important;\n}\n\n.font-weight-normal {\n    font-weight: 400 !important;\n}\n\n.font-weight-bold {\n    font-weight: 700 !important;\n}\n\n.font-italic {\n    font-style: italic !important;\n}\n\n.text-white {\n    color: #fff !important;\n}\n\n.text-primary {\n    color: #007bff !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n    color: #0062cc !important;\n}\n\n.text-secondary {\n    color: #6c757d !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n    color: #545b62 !important;\n}\n\n.text-success {\n    color: #28a745 !important;\n}\n\na.text-success:hover, a.text-success:focus {\n    color: #1e7e34 !important;\n}\n\n.text-info {\n    color: #17a2b8 !important;\n}\n\na.text-info:hover, a.text-info:focus {\n    color: #117a8b !important;\n}\n\n.text-warning {\n    color: #ffc107 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n    color: #d39e00 !important;\n}\n\n.text-danger {\n    color: #dc3545 !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n    color: #bd2130 !important;\n}\n\n.text-light {\n    color: #f8f9fa !important;\n}\n\na.text-light:hover, a.text-light:focus {\n    color: #dae0e5 !important;\n}\n\n.text-dark {\n    color: #343a40 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n    color: #1d2124 !important;\n}\n\n.text-muted {\n    color: #6c757d !important;\n}\n\n.text-hide {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0;\n}\n\n.visible {\n    visibility: visible !important;\n}\n\n.invisible {\n    visibility: hidden !important;\n}\n\n@media print {\n    *,\n    *::before,\n    *::after {\n        text-shadow: none !important;\n        box-shadow: none !important;\n    }\n\n    a:not(.btn) {\n        text-decoration: underline;\n    }\n\n    abbr[title]::after {\n        content: \" (\" attr(title) \")\";\n    }\n\n    pre {\n        white-space: pre-wrap !important;\n    }\n\n    pre,\n    blockquote {\n        border: 1px solid #999;\n        page-break-inside: avoid;\n    }\n\n    thead {\n        display: table-header-group;\n    }\n\n    tr,\n    img {\n        page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n        orphans: 3;\n        widows: 3;\n    }\n\n    h2,\n    h3 {\n        page-break-after: avoid;\n    }\n\n    @page {\n        size: a3;\n    }\n\n    body {\n        min-width: 992px !important;\n    }\n\n    .container {\n        min-width: 992px !important;\n    }\n\n    .navbar {\n        display: none;\n    }\n\n    .badge {\n        border: 1px solid #000;\n    }\n\n    .table {\n        border-collapse: collapse !important;\n    }\n\n    .table td,\n    .table th {\n        background-color: #fff !important;\n    }\n\n    .table-bordered th,\n    .table-bordered td {\n        border: 1px solid #ddd !important;\n    }\n}\n\n.rtl {\n    direction: rtl;\n    text-align: right;\n}\n\n.rtl .nav {\n    padding-right: 0;\n}\n\n.rtl .navbar-nav .nav-item {\n    float: right;\n}\n\n.rtl .navbar-nav .nav-item + .nav-item {\n    margin-right: 1rem;\n    margin-left: inherit;\n}\n\n.rtl .alert-dismissible {\n    padding-right: 1.25rem;\n    padding-left: 4rem;\n}\n\n.rtl .dropdown-menu {\n    text-align: right;\n}\n\n.rtl .checkbox label {\n    padding-right: 1.25rem;\n    padding-left: inherit;\n}\n\n.rtl .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-radius: 0 .2rem .2rem 0;\n}\n\n.rtl .btn-group > .btn:last-child:not(:first-child),\n.rtl .btn-group > .dropdown-toggle:not(:first-child) {\n    border-radius: .2rem 0 0 .2rem;\n}\n\n.rtl .btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n    border-radius: .2rem 0 0 .2rem;\n}\n\n.rtl .custom-control-label::after,\n.rtl .custom-control-label::before {\n    right: 0;\n    left: inherit;\n}\n\n.rtl .custom-select {\n    padding: 0.375rem 0.75rem 0.375rem 1.75rem;\n    background: #fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat left 0.75rem center;\n    background-size: 8px 10px;\n}\n\n.rtl .input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.rtl .input-group > .input-group-append:last-child > .input-group-text:not(:last-child),\n.rtl .input-group > .input-group-append:not(:last-child) > .btn,\n.rtl .input-group > .input-group-append:not(:last-child) > .input-group-text,\n.rtl .input-group > .input-group-prepend > .btn,\n.rtl .input-group > .input-group-prepend > .input-group-text {\n    border-radius: 0 .2rem .2rem 0;\n}\n\n.rtl .input-group > .input-group-append > .btn,\n.rtl .input-group > .input-group-append > .input-group-text,\n.rtl .input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.rtl .input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child),\n.rtl .input-group > .input-group-prepend:not(:first-child) > .btn,\n.rtl .input-group > .input-group-prepend:not(:first-child) > .input-group-text {\n    border-radius: .2rem 0 0 .2rem;\n}\n\n.rtl .custom-control {\n    padding-right: 1.5rem;\n    padding-left: inherit;\n    margin-right: inherit;\n    margin-left: 1rem;\n}\n\n.rtl .custom-control-indicator {\n    right: 0;\n    left: inherit;\n}\n\n.rtl .custom-file-label::after {\n    right: initial;\n    left: -1px;\n    border-radius: .25rem 0 0 .25rem;\n}\n\n.rtl .radio input,\n.rtl .radio-inline,\n.rtl .checkbox input,\n.rtl .checkbox-inline input {\n    margin-right: -1.25rem;\n    margin-left: inherit;\n}\n\n.rtl .list-group {\n    padding-right: 0;\n    padding-left: 40px;\n}\n\n.rtl .close {\n    float: left;\n}\n\n.rtl .modal-header .close {\n    margin: -15px auto -15px -15px;\n}\n\n.rtl .modal-footer > :not(:first-child) {\n    margin-right: .25rem;\n}\n\n.rtl .alert-dismissible .close {\n    right: inherit;\n    left: 0;\n}\n\n.rtl .dropdown-toggle::after {\n    margin-right: .255em;\n    margin-left: 0;\n}\n\n.rtl .form-check-input {\n    margin-right: -1.25rem;\n    margin-left: inherit;\n}\n\n.rtl .form-check-label {\n    padding-right: 1.25rem;\n    padding-left: inherit;\n}\n\n.rtl .col-xs-1,\n.rtl .col-xs-10,\n.rtl .col-xs-11,\n.rtl .col-xs-12,\n.rtl .col-xs-2,\n.rtl .col-xs-3,\n.rtl .col-xs-4,\n.rtl .col-xs-5,\n.rtl .col-xs-6,\n.rtl .col-xs-7,\n.rtl .col-xs-8,\n.rtl .col-xs-9 {\n    float: right;\n}\n\n.rtl .push-xs-1 {\n    right: 8.333333%;\n}\n\n.rtl .push-xs-2 {\n    right: 16.666667%;\n}\n\n.rtl .push-xs-3 {\n    right: 25%;\n}\n\n.rtl .push-xs-4 {\n    right: 33.333333%;\n}\n\n.rtl .push-xs-5 {\n    right: 41.666667%;\n}\n\n.rtl .push-xs-6 {\n    right: 50%;\n}\n\n.rtl .push-xs-7 {\n    right: 58.333333%;\n}\n\n.rtl .push-xs-8 {\n    right: 66.666667%;\n}\n\n.rtl .push-xs-9 {\n    right: 75%;\n}\n\n.rtl .push-xs-10 {\n    right: 83.333333%;\n}\n\n.rtl .push-xs-11 {\n    right: 91.666667%;\n}\n\n.rtl .push-xs-12 {\n    right: 100%;\n}\n\n.rtl .offset-xs-0 {\n    margin-right: 0%;\n}\n\n.rtl .offset-xs-1 {\n    margin-right: 8.333333%;\n}\n\n.rtl .offset-xs-2 {\n    margin-right: 16.666667%;\n}\n\n.rtl .offset-xs-3 {\n    margin-right: 25%;\n}\n\n.rtl .offset-xs-4 {\n    margin-right: 33.333333%;\n}\n\n.rtl .offset-xs-5 {\n    margin-right: 41.666667%;\n}\n\n.rtl .offset-xs-6 {\n    margin-right: 50%;\n}\n\n.rtl .offset-xs-7 {\n    margin-right: 58.333333%;\n}\n\n.rtl .offset-xs-8 {\n    margin-right: 66.666667%;\n}\n\n.rtl .offset-xs-9 {\n    margin-right: 75%;\n}\n\n.rtl .offset-xs-10 {\n    margin-right: 83.333333%;\n}\n\n.rtl .offset-xs-11 {\n    margin-right: 91.666667%;\n}\n\n.rtl .offset-xs-12 {\n    margin-right: 100%;\n}\n\n@media (min-width: 544px) {\n    .rtl .col-sm-1,\n    .rtl .col-sm-2,\n    .rtl .col-sm-3,\n    .rtl .col-sm-4,\n    .rtl .col-sm-5,\n    .rtl .col-sm-6,\n    .rtl .col-sm-7,\n    .rtl .col-sm-8,\n    .rtl .col-sm-9,\n    .rtl .col-sm-10,\n    .rtl .col-sm-11,\n    .rtl .col-sm-12 {\n        float: right;\n    }\n\n    .rtl .offset-sm-0 {\n        margin-right: 0%;\n    }\n\n    .rtl .offset-sm-1 {\n        margin-right: 8.333333%;\n    }\n\n    .rtl .offset-sm-2 {\n        margin-right: 16.666667%;\n    }\n\n    .rtl .offset-sm-3 {\n        margin-right: 25%;\n    }\n\n    .rtl .offset-sm-4 {\n        margin-right: 33.333333%;\n    }\n\n    .rtl .offset-sm-5 {\n        margin-right: 41.666667%;\n    }\n\n    .rtl .offset-sm-6 {\n        margin-right: 50%;\n    }\n\n    .rtl .offset-sm-7 {\n        margin-right: 58.333333%;\n    }\n\n    .rtl .offset-sm-8 {\n        margin-right: 66.666667%;\n    }\n\n    .rtl .offset-sm-9 {\n        margin-right: 75%;\n    }\n\n    .rtl .offset-sm-10 {\n        margin-right: 83.333333%;\n    }\n\n    .rtl .offset-sm-11 {\n        margin-right: 91.666667%;\n    }\n\n    .rtl .offset-sm-12 {\n        margin-right: 100%;\n    }\n}\n\n@media (min-width: 768px) {\n    .rtl .col-md-1,\n    .rtl .col-md-10,\n    .rtl .col-md-11,\n    .rtl .col-md-12,\n    .rtl .col-md-2,\n    .rtl .col-md-3,\n    .rtl .col-md-4,\n    .rtl .col-md-5,\n    .rtl .col-md-6,\n    .rtl .col-md-7,\n    .rtl .col-md-8,\n    .rtl .col-md-9 {\n        float: right;\n    }\n\n    .rtl .offset-md-0 {\n        margin-right: 0%;\n    }\n\n    .rtl .offset-md-1 {\n        margin-right: 8.333333%;\n    }\n\n    .rtl .offset-md-2 {\n        margin-right: 16.666667%;\n    }\n\n    .rtl .offset-md-3 {\n        margin-right: 25%;\n    }\n\n    .rtl .offset-md-4 {\n        margin-right: 33.333333%;\n    }\n\n    .rtl .offset-md-5 {\n        margin-right: 41.666667%;\n    }\n\n    .rtl .offset-md-6 {\n        margin-right: 50%;\n    }\n\n    .rtl .offset-md-7 {\n        margin-right: 58.333333%;\n    }\n\n    .rtl .offset-md-8 {\n        margin-right: 66.666667%;\n    }\n\n    .rtl .offset-md-9 {\n        margin-right: 75%;\n    }\n\n    .rtl .offset-md-10 {\n        margin-right: 83.333333%;\n    }\n\n    .rtl .offset-md-11 {\n        margin-right: 91.666667%;\n    }\n\n    .rtl .offset-md-12 {\n        margin-right: 100%;\n    }\n}\n\n@media (min-width: 992px) {\n    .rtl .col-lg-1,\n    .rtl .col-lg-2,\n    .rtl .col-lg-3,\n    .rtl .col-lg-4,\n    .rtl .col-lg-5,\n    .rtl .col-lg-6,\n    .rtl .col-lg-7,\n    .rtl .col-lg-8,\n    .rtl .col-lg-9,\n    .rtl .col-lg-10,\n    .rtl .col-lg-11,\n    .rtl .col-lg-12 {\n        float: right;\n    }\n\n    .rtl .offset-lg-0 {\n        margin-right: 0%;\n    }\n\n    .rtl .offset-lg-1 {\n        margin-right: 8.333333%;\n    }\n\n    .rtl .offset-lg-2 {\n        margin-right: 16.666667%;\n    }\n\n    .rtl .offset-lg-3 {\n        margin-right: 25%;\n    }\n\n    .rtl .offset-lg-4 {\n        margin-right: 33.333333%;\n    }\n\n    .rtl .offset-lg-5 {\n        margin-right: 41.666667%;\n    }\n\n    .rtl .offset-lg-6 {\n        margin-right: 50%;\n    }\n\n    .rtl .offset-lg-7 {\n        margin-right: 58.333333%;\n    }\n\n    .rtl .offset-lg-8 {\n        margin-right: 66.666667%;\n    }\n\n    .rtl .offset-lg-9 {\n        margin-right: 75%;\n    }\n\n    .rtl .offset-lg-10 {\n        margin-right: 83.333333%;\n    }\n\n    .rtl .offset-lg-11 {\n        margin-right: 91.666667%;\n    }\n\n    .rtl .offset-lg-12 {\n        margin-right: 100%;\n    }\n}\n\n@media (min-width: 1200px) {\n    .rtl .col-xl-1,\n    .rtl .col-xl-2,\n    .rtl .col-xl-3,\n    .rtl .col-xl-4,\n    .rtl .col-xl-5,\n    .rtl .col-xl-6,\n    .rtl .col-xl-7,\n    .rtl .col-xl-8,\n    .rtl .col-xl-9,\n    .rtl .col-xl-10,\n    .rtl .col-xl-11,\n    .rtl .col-xl-12 {\n        float: right;\n    }\n\n    .rtl .offset-xl-0 {\n        margin-right: 0%;\n    }\n\n    .rtl .offset-xl-1 {\n        margin-right: 8.333333%;\n    }\n\n    .rtl .offset-xl-2 {\n        margin-right: 16.666667%;\n    }\n\n    .rtl .offset-xl-3 {\n        margin-right: 25%;\n    }\n\n    .rtl .offset-xl-4 {\n        margin-right: 33.333333%;\n    }\n\n    .rtl .offset-xl-5 {\n        margin-right: 41.666667%;\n    }\n\n    .rtl .offset-xl-6 {\n        margin-right: 50%;\n    }\n\n    .rtl .offset-xl-7 {\n        margin-right: 58.333333%;\n    }\n\n    .rtl .offset-xl-8 {\n        margin-right: 66.666667%;\n    }\n\n    .rtl .offset-xl-9 {\n        margin-right: 75%;\n    }\n\n    .rtl .offset-xl-10 {\n        margin-right: 83.333333%;\n    }\n\n    .rtl .offset-xl-11 {\n        margin-right: 91.666667%;\n    }\n\n    .rtl .offset-xl-12 {\n        margin-right: 100%;\n    }\n}\n\n/*# sourceMappingURL=bootstrap-rtl.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
